import {jsx as $hgUW1$jsx, jsxs as $hgUW1$jsxs, Fragment as $hgUW1$Fragment} from "@emotion/react/jsx-runtime";
import {css as $hgUW1$css, keyframes as $hgUW1$keyframes} from "@emotion/react";
import {token as $hgUW1$token} from "@atlaskit/tokens";
import $hgUW1$react, {useCallback as $hgUW1$useCallback, useState as $hgUW1$useState, useRef as $hgUW1$useRef, useEffect as $hgUW1$useEffect, useMemo as $hgUW1$useMemo, forwardRef as $hgUW1$forwardRef, createElement as $hgUW1$createElement} from "react";
import $hgUW1$atlaskitbutton, {LoadingButton as $hgUW1$LoadingButton} from "@atlaskit/button";
import $hgUW1$atlaskittooltip from "@atlaskit/tooltip";
import $hgUW1$atlaskitspinner from "@atlaskit/spinner";
import {media as $hgUW1$media, Stack as $hgUW1$Stack, Inline as $hgUW1$Inline, xcss as $hgUW1$xcss, Text as $hgUW1$Text} from "@atlaskit/primitives";
import $hgUW1$atlaskiticonglyphcross from "@atlaskit/icon/glyph/cross";
import $hgUW1$atlaskiticonglyphchevrondown from "@atlaskit/icon/glyph/chevron-down";
import $hgUW1$atlaskiticonglyphchevronup from "@atlaskit/icon/glyph/chevron-up";
import $hgUW1$atlaskiticonglyphchevronleft from "@atlaskit/icon/glyph/chevron-left";
import $hgUW1$atlaskiticonglyphchevronright from "@atlaskit/icon/glyph/chevron-right";
import $hgUW1$atlaskiticonglyphchevrondowncircle from "@atlaskit/icon/glyph/chevron-down-circle";
import $hgUW1$atlaskiticonglypharrowupcircle from "@atlaskit/icon/glyph/arrow-up-circle";
import $hgUW1$atlaskiticonglyphcheckcircleoutline from "@atlaskit/icon/glyph/check-circle-outline";
import $hgUW1$atlaskiticonglyphcheckcircle from "@atlaskit/icon/glyph/check-circle";
import $hgUW1$atlaskiticonglypharrowright from "@atlaskit/icon/glyph/arrow-right";
import $hgUW1$atlaskiticonglypheditorclose from "@atlaskit/icon/glyph/editor/close";
import $hgUW1$atlaskiticonglyphemojifrequent from "@atlaskit/icon/glyph/emoji/frequent";
import $hgUW1$atlaskiticonglyphstarfilled from "@atlaskit/icon/glyph/star-filled";
import $hgUW1$atlaskiticonglyphstar from "@atlaskit/icon/glyph/star";
import $hgUW1$atlaskiticonglyphbitbucketbuilds from "@atlaskit/icon/glyph/bitbucket/builds";
import $hgUW1$atlaskiticonglypheditormediawrapright from "@atlaskit/icon/glyph/editor/media-wrap-right";
import $hgUW1$atlaskiticonglypheditortable from "@atlaskit/icon/glyph/editor/table";
import $hgUW1$atlaskiticonglypheditoropen from "@atlaskit/icon/glyph/editor/open";
import $hgUW1$atlaskiticonglyphcopy from "@atlaskit/icon/glyph/copy";
import $hgUW1$atlaskiticonglyphwarning from "@atlaskit/icon/glyph/warning";
import $hgUW1$atlaskiticonglyphimage from "@atlaskit/icon/glyph/image";
import $hgUW1$atlaskiticonglyphdownload from "@atlaskit/icon/glyph/download";
import $hgUW1$atlaskiticonglyphmediaserviceszoomin from "@atlaskit/icon/glyph/media-services/zoom-in";
import $hgUW1$atlaskiticonglyphmediaserviceszoomout from "@atlaskit/icon/glyph/media-services/zoom-out";
import $hgUW1$atlaskiticonglyphsearch from "@atlaskit/icon/glyph/search";
import $hgUW1$atlaskiticonglyphoverview from "@atlaskit/icon/glyph/overview";
import $hgUW1$atlaskiticonglyphadd from "@atlaskit/icon/glyph/add";
import $hgUW1$atlaskiticonglyphaddcircle from "@atlaskit/icon/glyph/add-circle";
import $hgUW1$atlaskiticonglyphedit from "@atlaskit/icon/glyph/edit";
import $hgUW1$atlaskiticonglypheditfilled from "@atlaskit/icon/glyph/edit-filled";
import $hgUW1$atlaskiticonglyphsettings from "@atlaskit/icon/glyph/settings";
import $hgUW1$atlaskiticonglyphinfo from "@atlaskit/icon/glyph/info";
import $hgUW1$atlaskiticonglyphquestion from "@atlaskit/icon/glyph/question";
import $hgUW1$atlaskiticonglyphcheck from "@atlaskit/icon/glyph/check";
import $hgUW1$atlaskiticonglyphemojisymbols from "@atlaskit/icon/glyph/emoji/symbols";
import $hgUW1$atlaskiticonglyphlocation from "@atlaskit/icon/glyph/location";
import $hgUW1$atlaskiticonglyphchevronleftlarge from "@atlaskit/icon/glyph/chevron-left-large";
import $hgUW1$atlaskiticonglyphhipchatchevronup from "@atlaskit/icon/glyph/hipchat/chevron-up";
import $hgUW1$atlaskiticonglyphhipchatchevrondown from "@atlaskit/icon/glyph/hipchat/chevron-down";
import $hgUW1$atlaskiticonglyphexport from "@atlaskit/icon/glyph/export";
import $hgUW1$atlaskiticonglyphlink from "@atlaskit/icon/glyph/link";
import $hgUW1$atlaskiticonglyphshare from "@atlaskit/icon/glyph/share";
import $hgUW1$atlaskiticonglyphmenu from "@atlaskit/icon/glyph/menu";
import $hgUW1$atlaskiticonglypherror from "@atlaskit/icon/glyph/error";
import $hgUW1$atlaskiticonglypharrowleftcircle from "@atlaskit/icon/glyph/arrow-left-circle";
import $hgUW1$atlaskiticonglypharrowrightcircle from "@atlaskit/icon/glyph/arrow-right-circle";
import $hgUW1$atlaskiticonglyphrefresh from "@atlaskit/icon/glyph/refresh";
import $hgUW1$atlaskiticonglyphemojiatlassian from "@atlaskit/icon/glyph/emoji/atlassian";
import $hgUW1$atlaskiticonglyphfilter from "@atlaskit/icon/glyph/filter";
import $hgUW1$atlaskiticoncorethumbsup from "@atlaskit/icon/core/thumbs-up";
import $hgUW1$atlaskiticoncorethumbsdown from "@atlaskit/icon/core/thumbs-down";
import $hgUW1$reactindianadragscroll from "react-indiana-drag-scroll";
import {Y300 as $hgUW1$Y300, DN600 as $hgUW1$DN600, N0 as $hgUW1$N0, N800 as $hgUW1$N800, B300 as $hgUW1$B300, N60 as $hgUW1$N60, N500 as $hgUW1$N500, N70 as $hgUW1$N70, N50 as $hgUW1$N50} from "@atlaskit/theme/colors";
import $hgUW1$atlaskitbuttonnew, {IconButton as $hgUW1$IconButton} from "@atlaskit/button/new";
import $hgUW1$atlaskitavatar from "@atlaskit/avatar";
import $hgUW1$atlaskiticonutilitychevrondown from "@atlaskit/icon/utility/chevron-down";
import $hgUW1$atlaskiticonutilitychevronup from "@atlaskit/icon/utility/chevron-up";
import {AtlassianIcon as $hgUW1$AtlassianIcon, AtlassianLogo as $hgUW1$AtlassianLogo} from "@atlaskit/logo";
import {media as $hgUW1$media1} from "@atlaskit/primitives/responsive";
import $hgUW1$atlaskitlozenge from "@atlaskit/lozenge";
import $hgUW1$atlaskitdropdownmenu, {DropdownItemRadioGroup as $hgUW1$DropdownItemRadioGroup, DropdownItemRadio as $hgUW1$DropdownItemRadio, DropdownItemGroup as $hgUW1$DropdownItemGroup, DropdownItem as $hgUW1$DropdownItem} from "@atlaskit/dropdown-menu";
import {layers as $hgUW1$layers} from "@atlaskit/theme/constants";
import $hgUW1$atlaskitmodaldialog, {ModalHeader as $hgUW1$ModalHeader, ModalBody as $hgUW1$ModalBody, ModalFooter as $hgUW1$ModalFooter, ModalTransition as $hgUW1$ModalTransition} from "@atlaskit/modal-dialog";
import $hgUW1$plyrdistplyr from "plyr/dist/plyr";
import {CircularProgressbarWithChildren as $hgUW1$CircularProgressbarWithChildren, buildStyles as $hgUW1$buildStyles} from "react-circular-progressbar";
import {Label as $hgUW1$Label, FormFooter as $hgUW1$FormFooter, HelperMessage as $hgUW1$HelperMessage, ErrorMessage as $hgUW1$ErrorMessage, ValidMessage as $hgUW1$ValidMessage, RequiredAsterisk as $hgUW1$RequiredAsterisk} from "@atlaskit/form";
import $hgUW1$atlaskittextarea from "@atlaskit/textarea";
import $hgUW1$lodashshuffle from "lodash.shuffle";
import $hgUW1$atlaskitselect from "@atlaskit/select";
import $hgUW1$atlaskiticonglyphmore from "@atlaskit/icon/glyph/more";
import {Buffer as $hgUW1$Buffer} from "buffer";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
/// <reference types="./types/custom.d.ts" />
var $a69491ea5a126553$exports = {};
var $5d4509b60606b6df$exports = {};
var $660bd1c6cb41002a$exports = {};

$parcel$export($660bd1c6cb41002a$exports, "Blockquote", () => $660bd1c6cb41002a$export$29a7a275fe11687);
$parcel$export($660bd1c6cb41002a$exports, "blockquoteStyles", () => $660bd1c6cb41002a$export$7a77f8e9665fa6b2);



const $660bd1c6cb41002a$export$29a7a275fe11687 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("blockquote", {
        css: (0, $hgUW1$css)($660bd1c6cb41002a$export$7a77f8e9665fa6b2),
        children: children
    });
};
const $660bd1c6cb41002a$var$fontSizeStyles = {
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    fontWeight: 600
};
const $660bd1c6cb41002a$export$7a77f8e9665fa6b2 = {
    paddingLeft: 0,
    fontFamily: "Inter, sans-serif",
    color: (0, $hgUW1$token)("color.text"),
    ...$660bd1c6cb41002a$var$fontSizeStyles,
    span: $660bd1c6cb41002a$var$fontSizeStyles,
    "&:before, &:after": {
        content: "''"
    }
};


var $fec02fc26c7e145d$exports = {};

$parcel$export($fec02fc26c7e145d$exports, "ButtonSize", () => $fec02fc26c7e145d$export$5dd2748b7940a2a0);
$parcel$export($fec02fc26c7e145d$exports, "ButtonAppearance", () => $fec02fc26c7e145d$export$261c9483fc4a455a);
$parcel$export($fec02fc26c7e145d$exports, "Button", () => $fec02fc26c7e145d$export$353f5b6fc5456de1);








let $fec02fc26c7e145d$export$5dd2748b7940a2a0;
(function(ButtonSize) {
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["LARGE"] = "large";
})($fec02fc26c7e145d$export$5dd2748b7940a2a0 || ($fec02fc26c7e145d$export$5dd2748b7940a2a0 = {}));
let $fec02fc26c7e145d$export$261c9483fc4a455a;
(function(ButtonAppearance) {
    ButtonAppearance["DEFAULT"] = "default";
    ButtonAppearance["DANGER"] = "danger";
    ButtonAppearance["LINK"] = "link";
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["SUBTLE"] = "subtle";
    ButtonAppearance["WARNING"] = "warning";
    ButtonAppearance["ICON"] = "icon";
    ButtonAppearance["SUCCESS"] = "success";
})($fec02fc26c7e145d$export$261c9483fc4a455a || ($fec02fc26c7e145d$export$261c9483fc4a455a = {}));
const $fec02fc26c7e145d$export$353f5b6fc5456de1 = ({ label: label , appearance: appearance = $fec02fc26c7e145d$export$261c9483fc4a455a.DEFAULT , onClick: onClick , href: href , target: target , iconBefore: iconBefore , iconAfter: iconAfter , type: type = "button" , fullWidth: fullWidth = false , size: size = $fec02fc26c7e145d$export$5dd2748b7940a2a0.MEDIUM , disabled: disabled = false , selected: selected = false , isLoading: isLoading = false , withPadding: withPadding = true , iconType: iconType , tooltip: tooltip , isResponsive: isResponsive = false  })=>{
    const isButtonWithoutIcon = !iconBefore && !iconAfter;
    const showBeforeIcon = !isLoading && iconBefore;
    const showAfterIcon = !isLoading && iconAfter;
    const isResponsiveSpacing = isResponsive && [
        $fec02fc26c7e145d$export$261c9483fc4a455a.PRIMARY,
        $fec02fc26c7e145d$export$261c9483fc4a455a.SECONDARY
    ].includes(appearance) && size === $fec02fc26c7e145d$export$5dd2748b7940a2a0.LARGE;
    const clickHandler = (0, $hgUW1$useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    if (appearance === $fec02fc26c7e145d$export$261c9483fc4a455a.DEFAULT) return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$atlaskitbutton), {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        onClick: clickHandler,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        appearance: appearance,
        testId: `button-${appearance}${selected ? "-selected" : ""}`,
        href: href,
        target: target,
        shouldFitContainer: fullWidth,
        isDisabled: disabled || isLoading,
        isSelected: selected,
        css: [
            isLoading && !label && $fec02fc26c7e145d$var$learningButtonStyles["basic"] && (0, $hgUW1$css)({
                padding: "21px 49px",
                alignItems: "center"
            }),
            $fec02fc26c7e145d$var$fullWidthStyles(fullWidth)
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    isLoading && label && (0, $hgUW1$css)({
                        marginRight: (0, $hgUW1$token)("space.100")
                    })
                ],
                children: label
            }),
            isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                testId: "spinner",
                size: "small"
            })
        ]
    });
    if (appearance === $fec02fc26c7e145d$export$261c9483fc4a455a.ICON) return tooltip ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskittooltip), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
            tabIndex: 0,
            "aria-label": iconType ? iconType.replaceAll("-", " ") : "button icon",
            "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
            disabled: disabled,
            css: [
                $fec02fc26c7e145d$var$learningButtonIconStyles["base"],
                selected && $fec02fc26c7e145d$var$learningButtonIconStyles["selected"]
            ],
            onClick: clickHandler,
            children: [
                isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                    testId: "spinner",
                    size: "small"
                }),
                showBeforeIcon
            ]
        })
    }) : /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        tabIndex: 0,
        "aria-label": iconType ? iconType.replaceAll("-", " ") : "button icon",
        "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
        disabled: disabled,
        css: [
            $fec02fc26c7e145d$var$learningButtonIconStyles["base"],
            selected && $fec02fc26c7e145d$var$learningButtonIconStyles["selected"]
        ],
        onClick: clickHandler,
        children: [
            isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon
        ]
    });
    if (appearance === $fec02fc26c7e145d$export$261c9483fc4a455a.LINK) return /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        "aria-label": label.replaceAll("-", " "),
        disabled: disabled,
        onClick: clickHandler,
        "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
        css: [
            $fec02fc26c7e145d$var$learningButtonLinkStyles["basic"],
            disabled && $fec02fc26c7e145d$var$learningButtonLinkStyles["disabled"],
            isButtonWithoutIcon && $fec02fc26c7e145d$var$learningButtonSpacingStyles[size],
            iconBefore && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-before`],
            iconAfter && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-after`],
            !withPadding && (0, $hgUW1$css)({
                padding: 0
            })
        ],
        children: [
            showBeforeIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginRight: (0, $hgUW1$token)("space.050")
                    })
                ],
                children: iconBefore
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                target: target,
                href: !disabled ? href : undefined,
                rel: target === "_blank" ? "noreferrer" : "",
                tabIndex: 0,
                css: [
                    $fec02fc26c7e145d$var$linkStyles,
                    disabled && $fec02fc26c7e145d$var$disabledLinkStyles
                ],
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    children: label
                })
            }),
            showAfterIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.050")
                    }),
                    disabled && $fec02fc26c7e145d$var$disabledIconStyles
                ],
                children: iconAfter
            })
        ]
    });
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
        onClick: clickHandler,
        disabled: disabled || isLoading,
        css: [
            $fec02fc26c7e145d$var$learningButtonStyles["basic"],
            $fec02fc26c7e145d$var$learningButtonStyles[appearance],
            $fec02fc26c7e145d$var$learningButtonFontStyles[size],
            selected && $fec02fc26c7e145d$var$learningButtonStyles["selected"],
            isButtonWithoutIcon && $fec02fc26c7e145d$var$learningButtonSpacingStyles[size],
            iconBefore && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-before`],
            iconAfter && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-after`],
            isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveSpacing[size],
            isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveFontStyles,
            iconBefore && isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveSpacing[`${size}-icon-before`],
            iconAfter && isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveSpacing[`${size}-icon-after`],
            $fec02fc26c7e145d$var$fullWidthStyles(fullWidth)
        ],
        children: [
            isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginRight: (0, $hgUW1$token)("space.050")
                    })
                ],
                children: iconBefore
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    isLoading && (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.100")
                    })
                ],
                children: label
            }),
            showAfterIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.050")
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $fec02fc26c7e145d$var$fullWidthStyles = (fullWidth)=>fullWidth ? (0, $hgUW1$css)({
        width: "100%",
        justifyContent: "center"
    }) : undefined;
const $fec02fc26c7e145d$var$learningButtonStyles = {
    basic: (0, $hgUW1$css)({
        fontFamily: "Charlie Text, sans-serif",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.hovered"),
            borderColor: (0, $hgUW1$token)("color.border.selected"),
            color: (0, $hgUW1$token)("color.text.inverse")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
            borderColor: (0, $hgUW1$token)("color.border.selected"),
            color: (0, $hgUW1$token)("color.text.inverse")
        },
        "&:disabled": {
            backgroundColor: (0, $hgUW1$token)("color.background.disabled"),
            borderColor: "transparent",
            color: (0, $hgUW1$token)("color.text.disabled"),
            cursor: "not-allowed"
        }
    }),
    primary: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.brand.bold"),
        borderColor: (0, $hgUW1$token)("color.border.brand"),
        color: (0, $hgUW1$token)("color.text.inverse"),
        "&:focus-visible": {
            outline: `2px solid ${(0, $hgUW1$token)("color.border.focused")}`
        }
    }),
    secondary: (0, $hgUW1$css)({
        backgroundColor: "transparent",
        borderColor: (0, $hgUW1$token)("color.border.brand"),
        color: (0, $hgUW1$token)("color.text.brand")
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.selected"),
        borderColor: "transparent",
        color: (0, $hgUW1$token)("color.text.brand"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected"),
            borderColor: "transparent",
            color: (0, $hgUW1$token)("color.text.brand")
        }
    })
};
const $fec02fc26c7e145d$var$learningButtonFontStyles = {
    medium: (0, $hgUW1$css)({
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600
    }),
    large: (0, $hgUW1$css)({
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 600
    })
};
const $fec02fc26c7e145d$var$learningButtonSpacingStyles = {
    medium: (0, $hgUW1$css)({
        padding: `10px ${(0, $hgUW1$token)("space.150")}`
    }),
    "medium-icon-before": (0, $hgUW1$css)({
        padding: `10px ${(0, $hgUW1$token)("space.150")} 10px 10px`
    }),
    "medium-icon-after": (0, $hgUW1$css)({
        padding: `10px 10px 10px ${(0, $hgUW1$token)("space.150")}`
    }),
    large: (0, $hgUW1$css)({
        padding: `${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.200")}`
    }),
    "large-icon-before": (0, $hgUW1$css)({
        padding: `${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.150")}`
    }),
    "large-icon-after": (0, $hgUW1$css)({
        padding: `${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.200")}`
    })
};
const $fec02fc26c7e145d$var$learningButtonResponsiveSpacing = {
    large: (0, $hgUW1$css)({
        [(0, $hgUW1$media).below.sm]: {
            padding: `10px ${(0, $hgUW1$token)("space.150")}`
        }
    }),
    "large-icon-before": (0, $hgUW1$css)({
        [(0, $hgUW1$media).below.sm]: {
            padding: `10px ${(0, $hgUW1$token)("space.150")} 10px 10px`
        }
    }),
    "large-icon-after": (0, $hgUW1$css)({
        [(0, $hgUW1$media).below.sm]: {
            padding: `10px 10px 10px ${(0, $hgUW1$token)("space.150")}`
        }
    })
};
const $fec02fc26c7e145d$var$learningButtonResponsiveFontStyles = (0, $hgUW1$css)({
    [(0, $hgUW1$media).below.sm]: {
        fontSize: "16px",
        lineHeight: "20px"
    }
});
const $fec02fc26c7e145d$var$learningButtonLinkStyles = {
    basic: (0, $hgUW1$css)({
        display: "flex",
        width: "fit-content",
        padding: `10px ${(0, $hgUW1$token)("space.150")}`,
        border: "none",
        alignItems: "center",
        fontFamily: "Charlie Text, sans-serif",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "20px",
        color: (0, $hgUW1$token)("color.text.brand"),
        background: "transparent",
        outline: "none",
        cursor: "pointer",
        "&:hover": {
            color: (0, $hgUW1$token)("color.text.brand"),
            textDecoration: "underline",
            textUnderlineOffset: "4px"
        },
        "&:active": {
            color: (0, $hgUW1$token)("color.text.brand"),
            textDecoration: "underline"
        }
    }),
    disabled: {
        color: (0, $hgUW1$token)("color.text.disabled"),
        "&:hover": {
            textDecoration: "none"
        },
        "&:active": {
            textDecoration: "none"
        }
    }
};
const $fec02fc26c7e145d$var$linkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.brand"),
    cursor: "pointer",
    "&:active": {
        color: (0, $hgUW1$token)("color.link.pressed")
    }
});
const $fec02fc26c7e145d$var$disabledLinkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.disabled"),
    cursor: "not-allowed",
    "&:hover": {
        color: (0, $hgUW1$token)("color.text.disabled"),
        textDecoration: "none"
    },
    "&:active": {
        color: (0, $hgUW1$token)("color.text.disabled"),
        textDecoration: "none"
    }
});
const $fec02fc26c7e145d$var$buttonIconContainerStyles = (0, $hgUW1$css)({
    width: "24px",
    height: "24px"
});
const $fec02fc26c7e145d$var$disabledIconStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.icon.disabled"),
    cursor: "not-allowed"
});
const $fec02fc26c7e145d$var$learningButtonIconStyles = {
    base: (0, $hgUW1$css)({
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: "none",
        color: (0, $hgUW1$token)("color.icon"),
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.hovered")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.pressed")
        },
        "&:disabled": {
            backgroundColor: (0, $hgUW1$token)("color.background.disabled"),
            color: (0, $hgUW1$token)("color.icon.disabled"),
            cursor: "not-allowed"
        }
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.selected"),
        color: (0, $hgUW1$token)("color.icon.selected"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected.hovered"),
            color: (0, $hgUW1$token)("color.icon.selected")
        }
    })
};


var $d501466973a9f0a6$exports = {};

$parcel$export($d501466973a9f0a6$exports, "CheckboxType", () => $d501466973a9f0a6$export$138e17770a0a93a6);
$parcel$export($d501466973a9f0a6$exports, "CheckboxSize", () => $d501466973a9f0a6$export$5e435bc8b081a399);
$parcel$export($d501466973a9f0a6$exports, "Checkbox", () => $d501466973a9f0a6$export$48513f6b9f8ce62d);


var $fde9406d76ec24a9$exports = {};

$parcel$export($fde9406d76ec24a9$exports, "objectValuesToControls", () => $fde9406d76ec24a9$export$8a8918d045227e35);
$parcel$export($fde9406d76ec24a9$exports, "withFocusInteraction", () => $fde9406d76ec24a9$export$1456ddd9fbfc0a1f);
$parcel$export($fde9406d76ec24a9$exports, "inspectorProps", () => $fde9406d76ec24a9$export$1784ac302bd8ebad);
$parcel$export($fde9406d76ec24a9$exports, "formatMinutes", () => $fde9406d76ec24a9$export$30c35cbf580cab77);
$parcel$export($fde9406d76ec24a9$exports, "getRedirectUrl", () => $fde9406d76ec24a9$export$93832c3affb240d3);
$parcel$export($fde9406d76ec24a9$exports, "calculateLearningProgress", () => $fde9406d76ec24a9$export$6e67b290ed5690f6);
const $3dba2111a1a6d39b$var$buildAuthQueryParams = ({ email: email , redirectUrl: redirectUrl , prompt: prompt = "none" , experience: experience = "entry-auth"  })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(`referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $3dba2111a1a6d39b$export$1db7da00354b15ed = (queryParamValues)=>{
    const queryParams = $3dba2111a1a6d39b$var$buildAuthQueryParams(queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};


let $1ff01338112cd7fe$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["DEVELOPMENT"] = "development";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})($1ff01338112cd7fe$export$7dc6752a22ab011a || ($1ff01338112cd7fe$export$7dc6752a22ab011a = {}));
const $1ff01338112cd7fe$export$1b5aa7388a6c5e6f = {
    [$1ff01338112cd7fe$export$7dc6752a22ab011a.DEVELOPMENT]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$1ff01338112cd7fe$export$7dc6752a22ab011a.STAGING]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$1ff01338112cd7fe$export$7dc6752a22ab011a.PRODUCTION]: {
        loggedIn: "https://id.atlassian.com",
        loggedOut: "https://id.atlassian.com"
    }
};
const $1ff01338112cd7fe$export$d349399b473d7299 = {
    loggedIn: "/",
    loggedOut: "/"
};
let $1ff01338112cd7fe$export$93d048dc21eb282a;
(function(CommunityApp) {
    CommunityApp["HOME"] = "home";
    CommunityApp["LEARNING"] = "learning";
    CommunityApp["FORUMS"] = "forums";
    CommunityApp["EVENTS"] = "events";
    CommunityApp["PROFILE"] = "unified-portable-profile";
    CommunityApp["CHAMPIONS"] = "champions";
})($1ff01338112cd7fe$export$93d048dc21eb282a || ($1ff01338112cd7fe$export$93d048dc21eb282a = {}));
const $1ff01338112cd7fe$export$67e61a6fa639f224 = (email)=>[
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.FORUMS,
            label: "Forums",
            target: "_self",
            href: {
                loggedIn: (0, $3dba2111a1a6d39b$export$1db7da00354b15ed)({
                    email: email,
                    redirectUrl: "/forums"
                }),
                loggedOut: "/forums"
            }
        },
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.LEARNING,
            label: "Learning",
            href: {
                loggedIn: "/learning",
                loggedOut: "/learning"
            }
        },
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.EVENTS,
            label: "Events",
            target: "_self",
            href: {
                loggedIn: "/events",
                loggedOut: "/events"
            }
        },
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.CHAMPIONS,
            label: "Champions",
            target: "_self",
            href: {
                loggedIn: "/champions",
                loggedOut: "/champions"
            }
        }
    ];
const $1ff01338112cd7fe$export$208c68d48dfc9a12 = $1ff01338112cd7fe$export$67e61a6fa639f224();
const $1ff01338112cd7fe$export$fe0105b4860d6e11 = {
    [$1ff01338112cd7fe$export$93d048dc21eb282a.FORUMS]: "/forums",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.LEARNING]: "/learning",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.EVENTS]: "/events",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.PROFILE]: "/user",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.CHAMPIONS]: "/champions"
};
const $1ff01338112cd7fe$export$132b2bf91782e62b = {
    loggedIn: "/user",
    loggedOut: "/user"
};
const $1ff01338112cd7fe$export$b9cc8022ec117e91 = {
    loggedIn: "/user/settings",
    loggedOut: "/user/settings"
};
const $1ff01338112cd7fe$export$46dbfbdf99745111 = "Log in";
const $1ff01338112cd7fe$export$4fe37309c24221ae = "Sign up";
const $1ff01338112cd7fe$export$668d072b293d5f38 = {
    PROFILE: {
        text: "Profile",
        id: "profile"
    },
    LOG_OUT: {
        text: "Log out",
        id: "logout"
    },
    SETTINGS: {
        text: "Settings",
        id: "settings"
    }
};
let $1ff01338112cd7fe$export$3d7865934588d77e;
(function(EventType) {
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["IDENTIFY"] = "identify";
})($1ff01338112cd7fe$export$3d7865934588d77e || ($1ff01338112cd7fe$export$3d7865934588d77e = {}));
let $1ff01338112cd7fe$export$d778a884eb401313;
(function(AnalyticsActivityType) {
    AnalyticsActivityType["NAV_LOGO_CLICK"] = "NAV_LOGO_CLICK";
    AnalyticsActivityType["NAV_ITEM_CLICK"] = "NAV_ITEM_CLICK";
    AnalyticsActivityType["LOG_IN_CLICK"] = "LOG_IN_CLICK";
    AnalyticsActivityType["SIGN_UP_CLICK"] = "SIGN_UP_CLICK";
    AnalyticsActivityType["LOG_OUT_CLICK"] = "LOG_OUT_CLICK";
    AnalyticsActivityType["PROFILE_MENU_OPEN"] = "PROFILE_MENU_OPEN";
    AnalyticsActivityType["PROFILE_MENU_CLOSE"] = "PROFILE_MENU_CLOSE";
    AnalyticsActivityType["PROFILE_MENU_ITEM_CLICK"] = "PROFILE_MENU_ITEM_CLICK";
    AnalyticsActivityType["MOBILE_MENU_OPEN"] = "MOBILE_MENU_OPEN";
    AnalyticsActivityType["MOBILE_MENU_CLOSE"] = "MOBILE_MENU_CLOSE";
})($1ff01338112cd7fe$export$d778a884eb401313 || ($1ff01338112cd7fe$export$d778a884eb401313 = {}));
const $1ff01338112cd7fe$export$bc6e44c7f1ae99f6 = "https://www.atlassian.com/legal/training-terms-and-policies";
const $1ff01338112cd7fe$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";


const $fde9406d76ec24a9$export$8a8918d045227e35 = (obj, control = "select")=>({
        control: control,
        options: Object.values(obj)
    });
const $fde9406d76ec24a9$export$1456ddd9fbfc0a1f = (handler)=>(e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            handler();
        }
    };
const $fde9406d76ec24a9$export$1784ac302bd8ebad = (key, inspectMode)=>{
    if (inspectMode && inspectMode[key]) {
        const { entryId: entryId , fieldId: fieldId  } = inspectMode[key];
        return {
            "data-contentful-entry-id": entryId,
            "data-contentful-field-id": fieldId
        };
    }
};
const $fde9406d76ec24a9$export$30c35cbf580cab77 = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    let output = "";
    if (hours > 0) {
        output += `${hours} hour`;
        if (hours > 1) output += "s";
    }
    if (remainingMinutes > 0) {
        if (hours > 0) output += " and ";
        output += `${remainingMinutes} minute`;
        if (remainingMinutes > 1) output += "s";
    }
    return output;
};
const $fde9406d76ec24a9$export$93832c3affb240d3 = (url, environment)=>{
    const idUrl = (0, $1ff01338112cd7fe$export$1b5aa7388a6c5e6f)[environment] || (0, $1ff01338112cd7fe$export$1b5aa7388a6c5e6f)[(0, $1ff01338112cd7fe$export$7dc6752a22ab011a).STAGING];
    return `${idUrl}/login?continue=${encodeURIComponent(url)}`;
};
const $fde9406d76ec24a9$export$6e67b290ed5690f6 = (completed, total)=>{
    if (total === 0) return 0;
    return completed / total * 100;
};




let $d501466973a9f0a6$export$138e17770a0a93a6;
(function(CheckboxType) {
    CheckboxType["DEFAULT"] = "DEFAULT";
    CheckboxType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    CheckboxType["DANGER"] = "DANGER";
    CheckboxType["DISABLED"] = "DISABLED";
})($d501466973a9f0a6$export$138e17770a0a93a6 || ($d501466973a9f0a6$export$138e17770a0a93a6 = {}));
let $d501466973a9f0a6$export$5e435bc8b081a399;
(function(CheckboxSize) {
    CheckboxSize["DEFAULT"] = "DEFAULT";
    CheckboxSize["LARGE"] = "LARGE";
})($d501466973a9f0a6$export$5e435bc8b081a399 || ($d501466973a9f0a6$export$5e435bc8b081a399 = {}));
const $d501466973a9f0a6$export$48513f6b9f8ce62d = ({ label: label , isChecked: isChecked , onChange: onChange , type: type = $d501466973a9f0a6$export$138e17770a0a93a6.DEFAULT , size: size = $d501466973a9f0a6$export$5e435bc8b081a399.DEFAULT , isIndeterminate: isIndeterminate = false , isRequired: isRequired = false , isBold: isBold , tabIndex: tabIndex = 0  })=>{
    const [userHasInteracted, setUserHasInteracted] = (0, $hgUW1$useState)(false);
    const checkboxRef = (0, $hgUW1$useRef)(null);
    const handleChange = (0, $hgUW1$useCallback)(()=>{
        setUserHasInteracted(true);
        if (onChange) onChange();
    }, [
        onChange
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(handleChange), [
        isChecked
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = isIndeterminate && !userHasInteracted;
    }, [
        isIndeterminate,
        userHasInteracted
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("label", {
        onKeyDown: handleKeyDown,
        css: [
            $d501466973a9f0a6$var$labelStyles,
            size === $d501466973a9f0a6$export$5e435bc8b081a399.LARGE && $d501466973a9f0a6$var$labelLargeStyles,
            type === $d501466973a9f0a6$export$138e17770a0a93a6.DISABLED && $d501466973a9f0a6$var$variants.label.DISABLED,
            isBold && (0, $hgUW1$css)({
                fontWeight: 700
            }),
            !isBold && (0, $hgUW1$css)({
                fontWeight: 400
            })
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("input", {
                ref: checkboxRef,
                tabIndex: -1,
                type: "checkbox",
                role: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                css: $d501466973a9f0a6$var$inputCheckboxStyles
            }),
            label,
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                tabIndex: tabIndex,
                onKeyDown: handleKeyDown,
                css: [
                    $d501466973a9f0a6$var$variants.checkbox[type],
                    $d501466973a9f0a6$var$checkmarkStyles,
                    size === $d501466973a9f0a6$export$5e435bc8b081a399.LARGE && $d501466973a9f0a6$var$checkmarkLargeStyles,
                    isIndeterminate && !userHasInteracted && $d501466973a9f0a6$var$indeterminateCheckmarkStyles,
                    isChecked && $d501466973a9f0a6$var$checkedCheckmarkStyles,
                    isChecked && type === $d501466973a9f0a6$export$138e17770a0a93a6.DANGER && (0, $hgUW1$css)({
                        backgroundColor: (0, $hgUW1$token)("color.border.danger")
                    })
                ]
            }),
            isRequired && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $d501466973a9f0a6$var$requiredMarkStyles,
                    size === $d501466973a9f0a6$export$5e435bc8b081a399.LARGE && (0, $hgUW1$css)({
                        marginLeft: "2px"
                    })
                ],
                children: "*"
            })
        ]
    });
};
const $d501466973a9f0a6$var$requiredMarkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtle"),
    marginLeft: "6px"
});
const $d501466973a9f0a6$var$labelStyles = (0, $hgUW1$css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    marginBottom: 0,
    userSelect: "none",
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    "&:hover": {
        cursor: "pointer"
    }
});
const $d501466973a9f0a6$var$labelLargeStyles = (0, $hgUW1$css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $d501466973a9f0a6$var$inputCheckboxStyles = (0, $hgUW1$css)({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
});
const $d501466973a9f0a6$var$checkmarkStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "3px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    border: `1px solid ${(0, $hgUW1$token)("color.border.input")}`,
    borderRadius: "2px",
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    }
});
const $d501466973a9f0a6$var$checkedCheckmarkStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold"),
    borderColor: (0, $hgUW1$token)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "1px",
        width: "4px",
        height: "7px",
        border: `solid ${(0, $hgUW1$token)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $d501466973a9f0a6$var$checkmarkLargeStyles = (0, $hgUW1$css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "1px",
        width: "6px !important",
        height: "10px !important",
        border: `solid ${(0, $hgUW1$token)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $d501466973a9f0a6$var$indeterminateCheckmarkStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold"),
    borderColor: (0, $hgUW1$token)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "2.5px",
        top: "-1px",
        width: "9px",
        height: "7px",
        borderBottom: `2px solid ${(0, $hgUW1$token)("color.text.inverse")}`
    }
});
const $d501466973a9f0a6$var$variants = {
    label: {
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $hgUW1$css)({
            "&:hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        SUCCESS: (0, $hgUW1$css)({
            "&, &:hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        DANGER: (0, $hgUW1$css)({
            "&, &:hover": {
                borderColor: (0, $hgUW1$token)("color.border.danger")
            }
        }),
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};


var $c4979bfceee73878$exports = {};

$parcel$export($c4979bfceee73878$exports, "CommonModal", () => $c4979bfceee73878$export$8577c1390d697bac);





const $c4979bfceee73878$export$8577c1390d697bac = ({ isOpen: isOpen , toggleModal: toggleModal , modalDescriptionLabel: modalDescription , children: children , styles: styles  })=>{
    const closeModal = (0, $hgUW1$useCallback)((e)=>{
        e?.stopPropagation();
        toggleModal(false);
    }, []);
    const modalRef = (0, $hgUW1$useRef)(null);
    const focusOnOpen = (0, $hgUW1$useCallback)(()=>{
        if (isOpen) modalRef?.current?.focus();
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        focusOnOpen();
        const handleEsc = (event)=>{
            if (event.key === "Escape") toggleModal(false);
        };
        document.addEventListener("keyup", handleEsc, false);
        return ()=>{
            document.removeEventListener("keyup", handleEsc, false);
        };
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        focusOnOpen();
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return isOpen && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $c4979bfceee73878$var$backdropStyles,
            styles && styles
        ],
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            "aria-modal": true,
            role: "dialog",
            ref: modalRef,
            "aria-label": modalDescription,
            tabIndex: -1,
            css: $c4979bfceee73878$var$modalStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                    type: "button",
                    css: $c4979bfceee73878$var$closeButtonStyles,
                    onClick: closeModal,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcross), {
                        label: "Close Modal",
                        size: "medium",
                        primaryColor: (0, $hgUW1$token)("color.icon")
                    })
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $c4979bfceee73878$var$modalSlotStyles,
                    children: children
                })
            ]
        })
    });
};
const $c4979bfceee73878$var$backdropStyles = (0, $hgUW1$css)({
    "&, *": {
        boxSizing: "border-box"
    },
    backgroundColor: "gray",
    position: "fixed",
    padding: "16px",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    zIndex: 100000000
});
const $c4979bfceee73878$var$modalStyles = (0, $hgUW1$css)({
    position: "relative",
    padding: "16px",
    paddingTop: "48px",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    zIndex: 200000000
});
const $c4979bfceee73878$var$closeButtonStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "4px",
    "&:hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    },
    "&:focus svg": {
        color: (0, $hgUW1$token)("color.icon.selected")
    },
    "&:active": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.pressed")
    },
    "&:disabled": {
        backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtle.hovered")
    }
});
const $c4979bfceee73878$var$modalSlotStyles = (0, $hgUW1$css)({
    minWidth: "100px",
    minHeight: "25px",
    fontSize: "16px"
});


var $0903e93de01b205a$exports = {};

$parcel$export($0903e93de01b205a$exports, "Divider", () => $0903e93de01b205a$export$2e0a83ec2e27ecbb);
/**
 * Horizontal line acting as divider with custom color and height
 * @param {DividerProps} DividerProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <Divider color={token('color.border')} />
 */ 

const $0903e93de01b205a$export$2e0a83ec2e27ecbb = ({ color: color , height: height = 1  })=>{
    const styles = {
        height: height + "px",
        border: `0 solid ${(0, $hgUW1$token)("color.border")}`,
        margin: 0,
        backgroundColor: color
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)("hr", {
        "data-testid": "divider",
        style: styles
    });
};


var $a950778dc3003c4a$exports = {};

$parcel$export($a950778dc3003c4a$exports, "Eyebrow", () => $a950778dc3003c4a$export$71f050e2efa708bb);



const $a950778dc3003c4a$export$71f050e2efa708bb = ({ fontWeight: fontWeight = "regular" , size: size = "small" , color: color = (0, $hgUW1$token)("color.text") , children: children  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("h4", {
        css: [
            $a950778dc3003c4a$var$eyebrowSmallStyles,
            size === "medium" && $a950778dc3003c4a$var$eyebrowMediumStyles,
            fontWeight === "semibold" && (0, $hgUW1$css)({
                fontWeight: 600
            }),
            color && (0, $hgUW1$css)({
                color: color
            })
        ],
        children: children
    });
};
const $a950778dc3003c4a$var$eyebrowSmallStyles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Text", sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: (0, $hgUW1$token)("color.text"),
    textTransform: "uppercase"
});
const $a950778dc3003c4a$var$eyebrowMediumStyles = (0, $hgUW1$css)({
    fontSize: "14px",
    lineHeight: "18px"
});


var $582583ec420fce57$exports = {};

$parcel$export($582583ec420fce57$exports, "Heading", () => $582583ec420fce57$export$a8a3e93435678ff9);






const $582583ec420fce57$export$a8a3e93435678ff9 = ({ children: children , level: level , inspectMode: inspectMode , id: id , color: color = (0, $hgUW1$token)("color.text") , fontWeight: fontWeight  })=>{
    const HeadingElement = $582583ec420fce57$var$levelToHeadingElementsMap[level];
    const headingStyles = $582583ec420fce57$var$levelToHeadingStylesMap[level];
    const additionalProps = inspectMode ? (0, $fde9406d76ec24a9$export$1784ac302bd8ebad)(Object.keys(inspectMode)[0], inspectMode) : {};
    return /*#__PURE__*/ (0, $hgUW1$jsx)(HeadingElement, {
        id: id,
        css: [
            headingStyles,
            fontWeight && (0, $hgUW1$css)({
                fontWeight: fontWeight
            })
        ],
        ...additionalProps,
        style: {
            color: color
        },
        children: children
    });
};
const $582583ec420fce57$var$h0Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "52px",
    letterSpacing: "-0.144px",
    margin: 0,
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "56px",
        lineHeight: "64px",
        letterSpacing: "-0.168px"
    }
});
const $582583ec420fce57$var$h1Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    margin: 0,
    letterSpacing: "-0.144px",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "3rem",
        lineHeight: "3.5rem",
        letterSpacing: "-0.168px"
    }
});
const $582583ec420fce57$var$h2Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    margin: 0,
    letterSpacing: "-0.096px",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "2.5rem",
        lineHeight: "3rem",
        letterSpacing: "-0.12px"
    }
});
const $582583ec420fce57$var$h3Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "2rem",
        lineHeight: "2.5rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$h4Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "1.5rem",
        lineHeight: "2rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$h5Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$h6Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    textTransform: "unset",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$levelToHeadingElementsMap = {
    0: "h1",
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $582583ec420fce57$var$levelToHeadingStylesMap = {
    0: $582583ec420fce57$var$h0Styles,
    1: $582583ec420fce57$var$h1Styles,
    2: $582583ec420fce57$var$h2Styles,
    3: $582583ec420fce57$var$h3Styles,
    4: $582583ec420fce57$var$h4Styles,
    5: $582583ec420fce57$var$h5Styles,
    6: $582583ec420fce57$var$h6Styles
};


var $a02a6f7de308273b$exports = {};

$parcel$export($a02a6f7de308273b$exports, "icons", () => $a02a6f7de308273b$export$df03f54e09e486fa);
$parcel$export($a02a6f7de308273b$exports, "IconSize", () => $a02a6f7de308273b$export$ff775019b5b6e7df);
$parcel$export($a02a6f7de308273b$exports, "IconRotation", () => $a02a6f7de308273b$export$b3241a99d3e47e02);
$parcel$export($a02a6f7de308273b$exports, "Icon", () => $a02a6f7de308273b$export$f04a61298a47a40f);























































const $a02a6f7de308273b$export$df03f54e09e486fa = {
    filter: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphfilter), {
            ...props
        }),
    "chevron-down": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevrondown), {
            ...props
        }),
    "chevron-up": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronup), {
            ...props
        }),
    "chevron-left": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronleft), {
            ...props
        }),
    "chevron-right": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronright), {
            ...props
        }),
    "chevron-down-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevrondowncircle), {
            ...props
        }),
    "arrow-up-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowupcircle), {
            ...props
        }),
    "check-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheckcircle), {
            ...props
        }),
    "check-circle-outline": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheckcircleoutline), {
            ...props
        }),
    "arrow-right": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowright), {
            ...props
        }),
    "arrow-left-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowleftcircle), {
            ...props
        }),
    "arrow-right-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowrightcircle), {
            ...props
        }),
    "atlassian-logo": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphemojiatlassian), {
            ...props
        }),
    cross: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcross), {
            ...props
        }),
    "dropdown-cross": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditorclose), {
            ...props
        }),
    "menu-icon": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphmenu), {
            ...props
        }),
    "emoji-frequent": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphemojifrequent), {
            ...props
        }),
    "star-filled": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphstarfilled), {
            ...props
        }),
    star: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphstar), {
            ...props
        }),
    "bitbucket-builds": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphbitbucketbuilds), {
            ...props
        }),
    "editor-media-wrap-right": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditormediawrapright), {
            ...props
        }),
    "editor-table": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditortable), {
            ...props
        }),
    "editor-open": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditoropen), {
            ...props
        }),
    copy: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcopy), {
            ...props
        }),
    warning: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphwarning), {
            ...props
        }),
    image: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphimage), {
            ...props
        }),
    download: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphdownload), {
            ...props
        }),
    "zoom-in": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphmediaserviceszoomin), {
            ...props
        }),
    "zoom-out": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphmediaserviceszoomout), {
            ...props
        }),
    search: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphsearch), {
            ...props
        }),
    overview: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphoverview), {
            ...props
        }),
    add: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphadd), {
            ...props
        }),
    refresh: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphrefresh), {
            ...props
        }),
    "add-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphaddcircle), {
            ...props
        }),
    edit: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphedit), {
            ...props
        }),
    "edit-filled": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditfilled), {
            ...props
        }),
    error: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypherror), {
            ...props
        }),
    settings: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphsettings), {
            ...props
        }),
    info: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphinfo), {
            ...props
        }),
    question: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphquestion), {
            ...props
        }),
    check: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheck), {
            ...props
        }),
    "check-circle-filled": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheckcircle), {
            ...props
        }),
    "emoji-symbols": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphemojisymbols), {
            ...props
        }),
    location: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphlocation), {
            ...props
        }),
    "chevron-left-large": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronleftlarge), {
            ...props
        }),
    "chevron-right-large": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronleftlarge), {
            ...props
        }),
    "hipchat-chevron-up": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphhipchatchevronup), {
            ...props
        }),
    "hipchat-chevron-down": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphhipchatchevrondown), {
            ...props
        }),
    export: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphexport), {
            ...props
        }),
    link: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphlink), {
            ...props
        }),
    share: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphshare), {
            ...props
        }),
    bookmark: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            "aria-label": "bookmark",
            "data-testid": "bookmark",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "Icons/bookmark_24px",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "transparent",
                    stroke: "#626F86",
                    strokeWidth: "1.5"
                })
            })
        }),
    "bookmark-filled": ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            "aria-label": "bookmark filled",
            "data-testid": "bookmark-filled",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "Icons/bookmark_24px",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "#626F86",
                    stroke: "#626F86",
                    strokeWidth: "1.5"
                })
            })
        }),
    "gap-completed": ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            "data-testid": "gap-completed",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "Icon / <CheckCircleIcon>",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "gap",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z",
                    fill: "#22A06B"
                })
            })
        }),
    "thumb-down": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticoncorethumbsdown), {
            ...props
        }),
    "thumb-up": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticoncorethumbsup), {
            ...props
        }),
    one: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "one",
            children: "1"
        }),
    two: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "two",
            children: "2"
        }),
    three: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "three",
            children: "3"
        }),
    four: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "four",
            children: "4"
        }),
    five: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "five",
            children: "5"
        }),
    six: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "six",
            children: "6"
        }),
    seven: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "seven",
            children: "7"
        }),
    eight: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "eight",
            children: "8"
        }),
    nine: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "nine",
            children: "9"
        }),
    zero: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "zero",
            children: "0"
        })
};
let $a02a6f7de308273b$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["XLARGE"] = "xlarge";
})($a02a6f7de308273b$export$ff775019b5b6e7df || ($a02a6f7de308273b$export$ff775019b5b6e7df = {}));
let $a02a6f7de308273b$export$b3241a99d3e47e02;
(function(IconRotation) {
    IconRotation["ZERO"] = "0deg";
    IconRotation["NINETY"] = "90deg";
    IconRotation["ONE_EIGHTY"] = "180deg";
    IconRotation["TWO_SEVENTY"] = "270deg";
})($a02a6f7de308273b$export$b3241a99d3e47e02 || ($a02a6f7de308273b$export$b3241a99d3e47e02 = {}));
const $a02a6f7de308273b$export$f04a61298a47a40f = ({ type: type , size: size = $a02a6f7de308273b$export$ff775019b5b6e7df.MEDIUM , rotation: rotation = $a02a6f7de308273b$export$b3241a99d3e47e02.ZERO , alt: alt = "" , color: color , hoverColor: hoverColor , activeColor: activeColor  })=>{
    const icon = (0, $hgUW1$useMemo)(()=>$a02a6f7de308273b$export$df03f54e09e486fa[type], [
        type
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
        css: [
            $a02a6f7de308273b$var$baseStyles,
            $a02a6f7de308273b$var$rotationStyles[rotation],
            hoverColor && {
                "&:hover": {
                    color: hoverColor
                }
            },
            activeColor && {
                "&:active": {
                    color: activeColor
                }
            }
        ],
        "data-testid": `icon-${type}`,
        children: icon ? icon({
            size: size,
            label: alt,
            primaryColor: color || undefined,
            testId: type
        }) : null
    });
};
const $a02a6f7de308273b$var$baseStyles = (0, $hgUW1$css)({
    width: "fit-content",
    height: "fit-content",
    display: "inline-flex"
});
const $a02a6f7de308273b$var$rotationStyles = {
    "0deg": (0, $hgUW1$css)({
        transform: "rotate(0deg)"
    }),
    "90deg": (0, $hgUW1$css)({
        transform: "rotate(90deg)"
    }),
    "180deg": (0, $hgUW1$css)({
        transform: "rotate(180deg)"
    }),
    "270deg": (0, $hgUW1$css)({
        transform: "rotate(270deg)"
    })
};
const $a02a6f7de308273b$var$iconNumberStyles = (0, $hgUW1$css)({
    fontSize: "16px"
});


var $1298c86a7e6a9fc7$exports = {};

$parcel$export($1298c86a7e6a9fc7$exports, "Image", () => $1298c86a7e6a9fc7$export$3e431a229df88919);








/**
 * It takes a url and returns the last part of the url which is the name of the image.
 * @param {string} url - The URL of the image you want to get the name.
 * @returns name of the image file.
 */ const $1298c86a7e6a9fc7$var$getImageName = (url)=>{
    const urlSplitted = url.split("/");
    return urlSplitted[urlSplitted.length - 1];
};
/**
 * Convert bytes into KB or MB
 * @param {number} [bytes] - The number of bytes to format.
 * @returns a string with the KB o MB converted
 */ const $1298c86a7e6a9fc7$var$formatBytes = (bytes)=>{
    const marker = 1024;
    const decimal = 0;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    return bytes ? bytes < kiloBytes ? bytes + " Bytes" : bytes < megaBytes ? (bytes / kiloBytes).toFixed(decimal) + " KB" : (bytes / megaBytes).toFixed(decimal) + " MB" : undefined;
};
/**
 * Download image
 * @param {string} src - The URL of the image you want to download.
 * @param {string} name - The name of the file you want to save the image as.
 */ const $1298c86a7e6a9fc7$var$downloadImage = async (src, name)=>{
    const image = await fetch(src);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $1298c86a7e6a9fc7$export$3e431a229df88919 = ({ inspectMode: inspectMode , src: src , alt: alt , width: width , height: height , caption: caption = "" , size: size , center: center = true , preventModal: preventModal = false , onClick: onClick , ...props })=>{
    const rightToolsRef = (0, $hgUW1$useRef)(null);
    const downloadButtonRef = (0, $hgUW1$useRef)(null);
    const modalImgRef = (0, $hgUW1$useRef)(null);
    const originalImgRef = (0, $hgUW1$useRef)(null);
    const [showModal, setShowModal] = (0, $hgUW1$useState)(false);
    const [showControls, setShowControls] = (0, $hgUW1$useState)(false);
    const [totalZoom, setTotalZoom] = (0, $hgUW1$useState)(100);
    const [initialWidthModalImage, setInitialWidthModalImage] = (0, $hgUW1$useState)(0);
    const [initialHeightImage, setInitialHeightImage] = (0, $hgUW1$useState)(0);
    const [initialWidthOriginalImage, setInitialWidthOriginalImage] = (0, $hgUW1$useState)(0);
    (0, $hgUW1$useEffect)(()=>{
        if (showModal) {
            setShowControls(true);
            setTotalZoom(100);
            if (rightToolsRef.current) rightToolsRef.current.focus();
        }
    }, [
        showModal
    ]);
    (0, $hgUW1$useEffect)(()=>{
        let timer = null;
        if (showControls) timer = setTimeout(()=>setShowControls(false), 5000);
        return ()=>clearTimeout(timer);
    }, [
        showControls
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") setShowModal(false);
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const onHoverModal = ()=>{
        setShowControls(true);
    };
    const onZoomOut = ()=>{
        if (totalZoom > 20) {
            setTotalZoom(totalZoom - 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth - initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight - initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onZoomIn = ()=>{
        if (totalZoom < 320) {
            setTotalZoom(totalZoom + 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth + initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight + initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onBlur = ()=>{
        if (rightToolsRef.current && downloadButtonRef.current) {
            rightToolsRef.current.setAttribute("tabIndex", "-1");
            downloadButtonRef.current.focus();
        }
    };
    const onClickImage = (0, $hgUW1$useCallback)(()=>{
        if (onClick) onClick();
        if (!preventModal) setShowModal(true);
    }, [
        onClick
    ]);
    const onLoadImageModal = ()=>{
        setInitialWidthModalImage(modalImgRef.current?.offsetWidth ?? 0);
        setInitialHeightImage(modalImgRef.current?.offsetHeight ?? 0);
    };
    (0, $hgUW1$useEffect)(()=>{
        if (originalImgRef.current?.offsetWidth) setInitialWidthOriginalImage(originalImgRef.current.offsetWidth);
    }, [
        originalImgRef.current?.offsetWidth
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((e)=>{
        if (e.code === "Space") onClickImage();
    }, [
        onClickImage
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
        children: [
            showModal && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                "data-testid": "modal",
                id: "myModal",
                css: $1298c86a7e6a9fc7$var$modalStyles,
                onMouseMove: onHoverModal,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $1298c86a7e6a9fc7$var$modalContentStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: [
                                $1298c86a7e6a9fc7$var$modalControlsStyles,
                                showControls && (0, $hgUW1$css)({
                                    opacity: 1
                                }),
                                !showControls && (0, $hgUW1$css)({
                                    opacity: 0
                                })
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $1298c86a7e6a9fc7$var$containerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $1298c86a7e6a9fc7$var$textContainerStyles,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $1298c86a7e6a9fc7$var$iconContainerStyles,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "image",
                                                    size: "large",
                                                    color: (0, $hgUW1$Y300)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                                css: $1298c86a7e6a9fc7$var$imageContainerStyles,
                                                children: [
                                                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                                        css: $1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: $1298c86a7e6a9fc7$var$getImageName(src)
                                                    }),
                                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                                                        css: $1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: [
                                                            "image \xb7 ",
                                                            $1298c86a7e6a9fc7$var$formatBytes(size)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        className: "right",
                                        tabIndex: 0,
                                        ref: rightToolsRef,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                "data-testid": "download-button",
                                                ref: downloadButtonRef,
                                                tabIndex: 0,
                                                css: (0, $hgUW1$css)({
                                                    marginRight: "1rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "download image",
                                                onClick: ()=>{
                                                    $1298c86a7e6a9fc7$var$downloadImage(src, $1298c86a7e6a9fc7$var$getImageName(src));
                                                },
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "download",
                                                    size: "medium"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                tabIndex: 0,
                                                "data-testid": "close-modal-button",
                                                "aria-label": "close modal",
                                                onClick: ()=>{
                                                    setShowModal(false);
                                                },
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "cross",
                                                    size: "medium"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$reactindianadragscroll), {
                            css: $1298c86a7e6a9fc7$var$scrollContainerStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                                src: src,
                                alt: alt,
                                ref: modalImgRef,
                                onLoad: onLoadImageModal,
                                css: (0, $hgUW1$css)({
                                    margin: "auto"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: [
                                $1298c86a7e6a9fc7$var$modalToolsStyles,
                                (0, $hgUW1$css)({
                                    opacity: showControls ? 1 : 0
                                })
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $1298c86a7e6a9fc7$var$buttonContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                "data-testid": "zoom-out-button",
                                                onClick: ()=>onZoomOut(),
                                                css: (0, $hgUW1$css)({
                                                    marginRight: "0.625rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "zoom out",
                                                tabIndex: 0,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "zoom-out"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                "data-testid": "zoom-in-button",
                                                onClick: ()=>onZoomIn(),
                                                onBlur: onBlur,
                                                "aria-label": "zoom in",
                                                tabIndex: 0,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "zoom-in"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: (0, $hgUW1$css)({
                                            color: (0, $hgUW1$DN600)
                                        }),
                                        children: [
                                            totalZoom,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("image", inspectMode),
                css: (0, $hgUW1$css)({
                    width: "100%",
                    overflow: "hidden"
                }),
                "data-testid": "image",
                onClick: onClickImage,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("figure", {
                    css: $1298c86a7e6a9fc7$var$figureStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                            tabIndex: 0,
                            width: width,
                            height: height,
                            ref: originalImgRef,
                            alt: alt,
                            src: src,
                            onKeyDown: handleKeyDown,
                            css: [
                                (0, $hgUW1$css)({
                                    transform: "scale(1)",
                                    objectFit: "contain",
                                    height: "auto"
                                }),
                                center && (0, $hgUW1$css)({
                                    margin: "auto"
                                }),
                                !preventModal && (0, $hgUW1$css)({
                                    cursor: "pointer"
                                }),
                                !width && (0, $hgUW1$css)({
                                    width: "100%"
                                })
                            ],
                            ...props
                        }),
                        !!initialWidthOriginalImage && !!caption && /*#__PURE__*/ (0, $hgUW1$jsx)("figcaption", {
                            style: {
                                width: `${initialWidthOriginalImage}px`
                            },
                            css: $1298c86a7e6a9fc7$var$captionContainerStyles,
                            children: caption
                        })
                    ]
                })
            })
        ]
    });
};
const $1298c86a7e6a9fc7$var$modalStyles = (0, $hgUW1$css)({
    position: "fixed",
    zIndex: 100000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    "& button": {
        background: "transparent",
        borderRadius: "3px",
        verticalAlign: "middle",
        display: "inline-flex",
        padding: "0.125rem !important",
        height: "fit-content",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.bolder.hovered"),
            borderRadius: "3px"
        }
    }
});
const $1298c86a7e6a9fc7$var$modalContentStyles = (0, $hgUW1$css)({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    "& img": [
        {
            maxWidth: "320%",
            width: "-moz-available"
        },
        {
            width: "-webkit-fill-available"
        }
    ]
});
const $1298c86a7e6a9fc7$var$modalControlsStyles = (0, $hgUW1$css)({
    backgroundImage: "linear-gradient(rgb(14, 22, 36), rgba(14, 22, 36, 0))",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "6.125rem",
    zIndex: 1,
    fontWeight: 500,
    padding: "1.5rem",
    transition: "opacity 0.3s ease 0s",
    "& .right:focus": {
        outline: "none"
    },
    "& .right svg": {
        color: `${(0, $hgUW1$DN600)} !important`
    }
});
const $1298c86a7e6a9fc7$var$containerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between"
});
const $1298c86a7e6a9fc7$var$textContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    color: (0, $hgUW1$DN600)
});
const $1298c86a7e6a9fc7$var$iconContainerStyles = (0, $hgUW1$css)({
    marginRight: "0.75rem",
    display: "flex",
    alignItems: "center"
});
const $1298c86a7e6a9fc7$var$imageContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    color: "filter",
    fontSize: ".875rem",
    lineHeight: "1.25rem"
});
const $1298c86a7e6a9fc7$var$badgeContentStyles = (0, $hgUW1$css)({
    margin: 0
});
const $1298c86a7e6a9fc7$var$scrollContainerStyles = (0, $hgUW1$css)({
    height: "100%",
    display: "flex",
    flexDirection: "column"
});
const $1298c86a7e6a9fc7$var$modalToolsStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "6.125rem",
    padding: "0.625rem",
    backgroundImage: "linear-gradient(rgba(14, 22, 36, 0), rgb(14, 22, 36))",
    "& svg": {
        color: `${(0, $hgUW1$DN600)} !important`
    }
});
const $1298c86a7e6a9fc7$var$buttonContainerStyles = (0, $hgUW1$css)({
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
});
const $1298c86a7e6a9fc7$var$figureStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    textAlign: "center"
});
const $1298c86a7e6a9fc7$var$captionContainerStyles = (0, $hgUW1$css)({
    margin: "16px auto",
    textAlign: "center",
    fontStyle: "italic",
    fontSize: ".875rem",
    lineHeight: "1.25rem",
    color: (0, $hgUW1$token)("color.text.subtlest")
});


var $4fce8dfc4ce8f546$exports = {};

$parcel$export($4fce8dfc4ce8f546$exports, "LinkStyle", () => $4fce8dfc4ce8f546$export$2b77966d73aefa77);
$parcel$export($4fce8dfc4ce8f546$exports, "LinkSize", () => $4fce8dfc4ce8f546$export$be4c932f76c19adf);
$parcel$export($4fce8dfc4ce8f546$exports, "Link", () => $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a);






let $4fce8dfc4ce8f546$export$2b77966d73aefa77;
(function(LinkStyle) {
    LinkStyle["REGULAR"] = "regular";
    LinkStyle["SEMIBOLD"] = "semibold";
})($4fce8dfc4ce8f546$export$2b77966d73aefa77 || ($4fce8dfc4ce8f546$export$2b77966d73aefa77 = {}));
let $4fce8dfc4ce8f546$export$be4c932f76c19adf;
(function(LinkSize) {
    LinkSize["LARGE"] = "large";
    LinkSize["MEDIUM"] = "medium";
})($4fce8dfc4ce8f546$export$be4c932f76c19adf || ($4fce8dfc4ce8f546$export$be4c932f76c19adf = {}));
const $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a = ({ label: label , fontColor: fontColor = (0, $hgUW1$token)("color.text.accent.blue") , target: target = "_self" , link: link , style: style = $4fce8dfc4ce8f546$export$2b77966d73aefa77.REGULAR , icon: icon , onClick: onClick , size: size = $4fce8dfc4ce8f546$export$be4c932f76c19adf.MEDIUM , ...props })=>{
    const clickHandler = (0, $hgUW1$useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const onKeyDown = (e)=>(handler)=>{
            if (e.key === "Enter" || e.key === " ") handler(e);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("a", {
        target: target,
        href: link,
        rel: target === "_blank" ? "noopener noreferrer" : "",
        tabIndex: 0,
        css: [
            $4fce8dfc4ce8f546$var$sizeStyles[size],
            $4fce8dfc4ce8f546$var$variantStyles[style].base,
            $4fce8dfc4ce8f546$var$baseStyles,
            $4fce8dfc4ce8f546$var$variantStyles[style].hover,
            (0, $hgUW1$css)({
                color: fontColor
            })
        ],
        style: {
            wordBreak: "break-word",
            overflowWrap: "break-word"
        },
        onClick: clickHandler,
        onKeyDown: (e)=>onKeyDown(e)(clickHandler),
        ...props,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                children: label
            }),
            icon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $4fce8dfc4ce8f546$var$iconContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: icon,
                    size: "medium"
                })
            })
        ]
    });
};
const $4fce8dfc4ce8f546$var$baseStyles = (0, $hgUW1$css)({
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px",
    textDecoration: "none",
    [(0, $hgUW1$media).below.sm]: {
        fontSize: "16px !important",
        lineHeight: "20px !important"
    }
});
const $4fce8dfc4ce8f546$var$sizeStyles = {
    medium: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    large: {
        fontSize: "20px",
        lineHeight: "24px"
    }
};
const $4fce8dfc4ce8f546$var$variantStyles = {
    regular: {
        base: (0, $hgUW1$css)({
            fontWeight: "normal"
        }),
        hover: (0, $hgUW1$css)({
            "&:hover": {
                color: (0, $hgUW1$token)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $hgUW1$token)("color.link")
            }
        })
    },
    semibold: {
        base: (0, $hgUW1$css)({
            fontWeight: 600
        }),
        hover: (0, $hgUW1$css)({
            "&:hover": {
                color: (0, $hgUW1$token)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $hgUW1$token)("color.link")
            }
        })
    }
};
const $4fce8dfc4ce8f546$var$iconContainerStyles = {
    display: "inline",
    verticalAlign: "middle"
};


var $800df40a54823a3f$exports = {};

$parcel$export($800df40a54823a3f$exports, "List", () => $800df40a54823a3f$export$54c2e3dc7acea9f5);
$parcel$export($800df40a54823a3f$exports, "variantsListStyles", () => $800df40a54823a3f$export$6427468642e6e9fe);




const $800df40a54823a3f$export$54c2e3dc7acea9f5 = ({ type: type = "unordered" , textStyleType: textStyleType = "regular" , children: children  })=>{
    if (type === "ordered") return /*#__PURE__*/ (0, $hgUW1$jsx)("ol", {
        "aria-label": "ordered",
        css: [
            $800df40a54823a3f$var$listStyles,
            (0, $hgUW1$css)($800df40a54823a3f$export$6427468642e6e9fe.list[type]),
            $800df40a54823a3f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
    return /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
        "aria-label": "unordered",
        css: [
            $800df40a54823a3f$var$listStyles,
            (0, $hgUW1$css)($800df40a54823a3f$export$6427468642e6e9fe.list[type]),
            $800df40a54823a3f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
};
const $800df40a54823a3f$var$fontSizeStyles = {
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [(0, $hgUW1$media).below.md]: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    }
};
const $800df40a54823a3f$var$listStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    letterSpacing: "0.3%",
    color: (0, $hgUW1$token)("color.text"),
    ...$800df40a54823a3f$var$fontSizeStyles,
    span: $800df40a54823a3f$var$fontSizeStyles
});
const $800df40a54823a3f$export$6427468642e6e9fe = {
    list: {
        unordered: {
            listStyleType: "disc",
            paddingLeft: "1.25rem",
            ul: {
                listStyleType: "circle",
                paddingLeft: "1.25rem"
            },
            "ul ul": {
                listStyleType: "square",
                paddingLeft: "1.25rem"
            },
            "ul:not(:first-child), ul li, li + li": {
                marginTop: 0
            }
        },
        ordered: {
            listStyleType: "decimal",
            paddingLeft: "1.25rem",
            ol: {
                listStyleType: "lower-alpha",
                paddingLeft: "1.25rem"
            },
            "ol ol": {
                listStyleType: "lower-roman",
                paddingLeft: "1.25rem"
            },
            "ol:not(:first-child), ol li, li + li": {
                marginTop: 0
            }
        }
    },
    textStyle: {
        regular: (0, $hgUW1$css)({
            fontWeight: 400
        }),
        italic: (0, $hgUW1$css)({
            fontStyle: "italic"
        }),
        bold: (0, $hgUW1$css)({
            fontWeight: 700
        }),
        boldItalic: (0, $hgUW1$css)({
            fontWeight: 700,
            fontStyle: "italic"
        })
    }
};


var $25cbe9fdb2d8d071$exports = {};

$parcel$export($25cbe9fdb2d8d071$exports, "NavigationBar", () => $25cbe9fdb2d8d071$export$214ae410b202e65a);
$parcel$export($25cbe9fdb2d8d071$exports, "NavBarProfileItem", () => $397a78fff494027c$export$1cba3806e1f1b01d);
$parcel$export($25cbe9fdb2d8d071$exports, "NavBarLogoItem", () => $90d3cbebafca1fdb$export$6ce3be5638d8e2a);
$parcel$export($25cbe9fdb2d8d071$exports, "MenuItem", () => $3539883ac1727dfc$export$2ce376c2cc3355c8);
$parcel$export($25cbe9fdb2d8d071$exports, "NavBarExpandableItem", () => $3b7e032fd37ae5a5$export$1229978ae51a03a8);



var $965a3cfbe886b380$exports = {};

$parcel$export($965a3cfbe886b380$exports, "useOutsideClickHandler", () => $965a3cfbe886b380$export$aa79b0abe3dfeaba);

const $965a3cfbe886b380$export$aa79b0abe3dfeaba = (refs, onOutsideClick)=>{
    (0, $hgUW1$useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            // if click has occurred outside of all refs, then call onOutsideClick
            if (refs.every((ref)=>ref.current && !ref.current.contains(event.target))) onOutsideClick();
        };
        // bind the event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            // unbind the event listener on clean up
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        refs,
        onOutsideClick
    ]);
};


const $f0285f05d4d9f8a0$export$426e07cd0772984d = {
    MOBILE: {
        MAX_WIDTH: 767
    },
    TABLET: {
        MIN_WIDTH: 768,
        MAX_WIDTH: 1279
    },
    DESKTOP: {
        MIN_WIDTH: 1280
    }
};



const $6a34d18c8d59b475$var$CloseIcon = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M7 7L23.9706 23.9706",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M7 24L23.9706 7.02944",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $6a34d18c8d59b475$export$2e2bcd8739ae039 = $6a34d18c8d59b475$var$CloseIcon;



const $5ba5f450ff826a14$var$HamburgerMenuIcon = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M4 8H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M4 16H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M4 24H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $5ba5f450ff826a14$export$2e2bcd8739ae039 = $5ba5f450ff826a14$var$HamburgerMenuIcon;






var $6e8a4d5d78071ed7$exports = {};

$parcel$export($6e8a4d5d78071ed7$exports, "useMediaQuery", () => $6e8a4d5d78071ed7$export$32d5543ab307c01);

const $6e8a4d5d78071ed7$export$32d5543ab307c01 = (mediaQuery)=>{
    const [targetReached, setTargetReached] = (0, $hgUW1$useState)(false);
    const updateTarget = (0, $hgUW1$useCallback)((e)=>{
        if (e.matches) setTargetReached(true);
        else setTargetReached(false);
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        const media = window.matchMedia(mediaQuery);
        media.addEventListener("change", updateTarget);
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) setTargetReached(true);
        return ()=>media.removeEventListener("change", updateTarget);
    }, []);
    return targetReached;
};










const $3b7e032fd37ae5a5$export$1229978ae51a03a8 = ({ headerContent: headerContent , expandedHeaderContent: expandedHeaderContent , bodyContent: bodyContent , onExpandClick: onExpandClick , isNested: isNested = false  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const onExpandClickHandler = ()=>{
        setIsOpen(!isOpen);
        if (onExpandClick) onExpandClick(isOpen);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $3b7e032fd37ae5a5$var$containerStyles,
        role: "group",
        children: bodyContent ? /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: [
                        $3b7e032fd37ae5a5$var$headerStyles,
                        isOpen && $3b7e032fd37ae5a5$var$headerSelectedStyles,
                        isNested && $3b7e032fd37ae5a5$var$nestedHeaderStyles
                    ],
                    role: "treeitem",
                    onClick: onExpandClickHandler,
                    children: [
                        isOpen && expandedHeaderContent ? expandedHeaderContent : headerContent,
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: isOpen && $3b7e032fd37ae5a5$var$chevronSelectedStyles,
                            children: isOpen ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonutilitychevronup), {
                                label: "Collapse item"
                            }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonutilitychevrondown), {
                                label: "Expand item"
                            })
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                    css: [
                        $3b7e032fd37ae5a5$var$bodyContentContainerStyles,
                        isNested && $3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles
                    ],
                    children: bodyContent
                })
            ]
        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $3b7e032fd37ae5a5$var$headerStyles,
            role: "treeitem",
            children: headerContent
        })
    });
};
const $3b7e032fd37ae5a5$var$containerStyles = (0, $hgUW1$css)({
    display: "flex",
    fontSize: "1rem",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $3b7e032fd37ae5a5$var$headerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: "0 24px"
});
// when selected, header text color should appear as selected color (apply to different elements, since headerContent can vary)
const $3b7e032fd37ae5a5$var$headerSelectedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.selected"),
    a: {
        color: (0, $hgUW1$token)("color.text.selected")
    },
    span: {
        color: (0, $hgUW1$token)("color.text.selected")
    }
});
const $3b7e032fd37ae5a5$var$nestedHeaderStyles = (0, $hgUW1$css)({
    padding: "0 40px"
});
const $3b7e032fd37ae5a5$var$bodyContentContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    paddingTop: "8px",
    paddingLeft: "0",
    margin: 0,
    listStyle: "none"
});
const $3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles = (0, $hgUW1$css)({
    li: {
        paddingLeft: "56px"
    }
});
const $3b7e032fd37ae5a5$var$chevronSelectedStyles = (0, $hgUW1$css)({
    svg: {
        color: (0, $hgUW1$token)("color.text.selected")
    }
});





const $397a78fff494027c$var$getAvatarUserHeaderForMobile = (user, isExpanded)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $397a78fff494027c$var$headerContentStyles,
            isExpanded && $397a78fff494027c$var$avatarUserSelectedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitavatar), {
                appearance: "circle",
                src: user.avatar,
                size: "small",
                name: user.publicName
            }, user.publicName),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $397a78fff494027c$var$nameStyles,
                children: user.publicName
            })
        ]
    });
const $397a78fff494027c$export$1cba3806e1f1b01d = ({ user: user , expandableMenuContent: expandableMenuContent , profileMenuContent: profileMenuContent , onProfileMenuClick: onProfileMenuClick  })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $hgUW1$useState)(false);
    const isBreakpoint = (0, $6e8a4d5d78071ed7$export$32d5543ab307c01)(`(max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`);
    const avatarMenuRef = (0, $hgUW1$useRef)(null);
    (0, $965a3cfbe886b380$export$aa79b0abe3dfeaba)([
        avatarMenuRef
    ], ()=>setIsMenuOpen(false));
    const onProfileMenuClickHandler = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onProfileMenuClick) onProfileMenuClick(isMenuOpen);
    };
    if (isBreakpoint) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3b7e032fd37ae5a5$export$1229978ae51a03a8), {
        headerContent: $397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        expandedHeaderContent: $397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        bodyContent: expandableMenuContent,
        onExpandClick: onProfileMenuClick
    });
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
        ref: avatarMenuRef,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                css: [
                    $397a78fff494027c$var$avatarStyles,
                    isMenuOpen && $397a78fff494027c$var$avatarUserSelectedStyles
                ],
                onClick: onProfileMenuClickHandler,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitavatar), {
                    appearance: "circle",
                    src: user.avatar,
                    size: "medium",
                    name: user.publicName
                }, user.publicName)
            }),
            isMenuOpen && profileMenuContent ? /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                css: $397a78fff494027c$var$openMenuStyles,
                "aria-label": "Profile menu",
                role: "menu",
                children: profileMenuContent
            }) : null
        ]
    });
};
const $397a78fff494027c$var$headerContentStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: "8px",
    fontSize: "1rem"
});
const $397a78fff494027c$var$nameStyles = (0, $hgUW1$css)({
    alignSelf: "center"
});
const $397a78fff494027c$var$avatarStyles = (0, $hgUW1$css)({
    all: "unset",
    cursor: "pointer",
    marginTop: "3px",
    "&:focus-visible": {
        outline: `1px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $397a78fff494027c$var$avatarUserSelectedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.selected"),
    "& > * > span": {
        outline: `2px ${(0, $hgUW1$token)("color.text.selected")} solid`
    }
});
const $397a78fff494027c$var$openMenuStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: 0,
    zIndex: 10,
    borderRadius: "4px",
    boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)",
    listStyle: "none",
    margin: 0,
    padding: 0
});








const $90d3cbebafca1fdb$export$6ce3be5638d8e2a = ({ subtitleHref: subtitleHref , label: label , logoSubtitle: logoSubtitle  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
        css: $90d3cbebafca1fdb$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("a", {
                href: "https://www.atlassian.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: $90d3cbebafca1fdb$var$smallAtlassianLogoStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianIcon), {
                            testId: "mobile"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: $90d3cbebafca1fdb$var$bigAtlassianLogoStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianLogo), {
                            testId: "desktop"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $90d3cbebafca1fdb$var$dividerStyles
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                href: subtitleHref,
                css: $90d3cbebafca1fdb$var$subtitleStyles,
                "data-testid": "logoSubtitle",
                "aria-label": label,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                    children: [
                        " ",
                        logoSubtitle,
                        " "
                    ]
                })
            })
        ]
    });
};
const $90d3cbebafca1fdb$var$containerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    background: "none",
    fontFamily: "Charlie Display"
});
const $90d3cbebafca1fdb$var$smallAtlassianLogoStyles = (0, $hgUW1$css)({
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        svg: {
            color: (0, $hgUW1$token)("color.icon.brand"),
            transform: "scale(0.74)"
        }
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $90d3cbebafca1fdb$var$bigAtlassianLogoStyles = (0, $hgUW1$css)({
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        span: {
            width: "148px",
            height: "24px"
        },
        svg: {
            color: (0, $hgUW1$token)("color.icon.brand")
        }
    },
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        display: "none"
    }
});
const $90d3cbebafca1fdb$var$dividerStyles = (0, $hgUW1$css)({
    width: "1px",
    height: "32px",
    backgroundColor: "#DDDEE1",
    marginLeft: "24px",
    marginRight: "16px",
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        marginLeft: "8px",
        marginRight: "16px"
    }
});
const $90d3cbebafca1fdb$var$subtitleStyles = (0, $hgUW1$css)({
    fontSize: "22px",
    fontWeight: 600,
    color: (0, $hgUW1$token)("color.text"),
    textDecoration: "none",
    padding: "6px 8px",
    "&:hover": {
        color: (0, $hgUW1$token)("color.border.brand"),
        textDecoration: "none"
    }
});






const $3539883ac1727dfc$export$2ce376c2cc3355c8 = ({ link: link , type: type  })=>{
    const { href: href , onClick: onClick , text: text  } = link;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        css: $3539883ac1727dfc$var$menuLinkStyles,
        href: href,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
            css: [
                $3539883ac1727dfc$var$menuItemContainerBaseStyles,
                $3539883ac1727dfc$var$menuItemContainerStyles[type]
            ],
            role: "treeitem",
            children: text
        })
    });
};
const $3539883ac1727dfc$var$menuItemContainerBaseStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
const $3539883ac1727dfc$var$menuItemContainerStyles = {
    subMenu: (0, $hgUW1$css)({
        height: "32px",
        padding: "0 40px"
    }),
    profile: (0, $hgUW1$css)({
        height: "48px",
        padding: "0 24px"
    })
};
const $3539883ac1727dfc$var$menuLinkStyles = (0, $hgUW1$css)({
    fontSize: "1rem",
    fontWeight: 400,
    color: "#172B4D",
    cursor: "pointer",
    "&:hover": {
        color: "#0C66E4",
        textDecoration: "none"
    },
    "&:active": {
        color: "#0055CC",
        li: {
            background: (0, $hgUW1$token)("color.background.accent.blue.subtlest")
        }
    }
});



const $25cbe9fdb2d8d071$var$ToggleButton = ({ isOpen: isOpen , toggleMenu: toggleMenu  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$IconButton), {
        appearance: "subtle",
        onClick: toggleMenu,
        icon: isOpen ? (0, $6a34d18c8d59b475$export$2e2bcd8739ae039) : (0, $5ba5f450ff826a14$export$2e2bcd8739ae039),
        label: isOpen ? "Close menu" : "Open menu"
    });
const $25cbe9fdb2d8d071$export$214ae410b202e65a = ({ leftItems: leftItems , rightItems: rightItems , logoItem: logoItem , isSticky: isSticky = true , onMenuToggleClick: onMenuToggleClick , onMenuOutsideClick: onMenuOutsideClick  })=>{
    // open state of mobile/tablet menu
    const [isMenuOpen, setIsMenuOpen] = (0, $hgUW1$useState)(false);
    // ref for the toggle button - necessary for the useOutsideClickHandler
    // useOutsideClickHandler will close menu IF the user clicks outside of the menu or toggle button (necessary to include toggle button prevent double-click)
    // separately, toggle button (close button) should also close the menu
    const toggleRef = (0, $hgUW1$useRef)(null);
    const handleToggle = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onMenuToggleClick) onMenuToggleClick(isMenuOpen);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)("nav", {
        css: [
            $25cbe9fdb2d8d071$var$containerStyles,
            !isSticky && $25cbe9fdb2d8d071$var$stickyStyles
        ],
        "data-testid": "navbar",
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $25cbe9fdb2d8d071$var$innerContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $25cbe9fdb2d8d071$var$logoWrapperStyles,
                    children: logoItem
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $25cbe9fdb2d8d071$var$navContentWrapperStyles,
                    children: [
                        leftItems || rightItems ? /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $25cbe9fdb2d8d071$var$navMenuToggleButtonStyles,
                            ref: toggleRef,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$ToggleButton, {
                                isOpen: isMenuOpen,
                                toggleMenu: handleToggle
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$DesktopNavItems, {
                            leftItems: leftItems,
                            rightItems: rightItems
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$SmallNavItems, {
                            isMenuOpen: isMenuOpen,
                            setIsMenuOpen: setIsMenuOpen,
                            onMenuOutsideClick: onMenuOutsideClick,
                            leftItems: leftItems,
                            rightItems: rightItems,
                            toggleRef: toggleRef
                        })
                    ]
                })
            ]
        })
    });
};
const $25cbe9fdb2d8d071$var$MenuItems = ({ leftItems: leftItems , rightItems: rightItems  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
        children: [
            leftItems?.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                    css: [
                        $25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $25cbe9fdb2d8d071$var$leftItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `left-${index}`)),
            rightItems?.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                    css: [
                        $25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $25cbe9fdb2d8d071$var$rightItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `right-${index}`))
        ]
    });
const $25cbe9fdb2d8d071$var$DesktopNavItems = ({ leftItems: leftItems , rightItems: rightItems  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
        css: $25cbe9fdb2d8d071$var$desktopNavWrapperStyles,
        role: "menubar",
        "aria-orientation": "horizontal",
        children: /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$MenuItems, {
            leftItems: leftItems,
            rightItems: rightItems
        })
    });
const $25cbe9fdb2d8d071$var$SmallNavItems = ({ isMenuOpen: isMenuOpen , setIsMenuOpen: setIsMenuOpen , onMenuOutsideClick: onMenuOutsideClick , leftItems: leftItems , rightItems: rightItems , toggleRef: toggleRef  })=>{
    const menuRef = (0, $hgUW1$useRef)(null);
    // if user clicks outside of the mobile/tablet menu or toggle button, then close the menu
    (0, $965a3cfbe886b380$export$aa79b0abe3dfeaba)([
        menuRef,
        toggleRef
    ], ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
            if (onMenuOutsideClick) onMenuOutsideClick();
        }
    });
    return isMenuOpen ? /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $25cbe9fdb2d8d071$var$smallNavWrapperStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
            css: $25cbe9fdb2d8d071$var$smallNavUlStyles,
            ref: menuRef,
            role: "menubar",
            "aria-orientation": "vertical",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$MenuItems, {
                leftItems: leftItems,
                rightItems: rightItems
            })
        })
    }) : null;
};
const $25cbe9fdb2d8d071$var$navItemWrapperStyles = (0, $hgUW1$css)({
    height: "100%",
    alignSelf: "center",
    margin: "0 auto",
    padding: 0,
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        "& > button": {
            width: "100%",
            justifyContent: "center"
        }
    }
});
const $25cbe9fdb2d8d071$var$containerStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    position: "sticky",
    width: "100%",
    height: "68px",
    left: 0,
    top: 0,
    padding: "0 16px",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        height: "56px",
        justifyContent: "space-between"
    }
});
const $25cbe9fdb2d8d071$var$stickyStyles = (0, $hgUW1$css)({
    position: "fixed"
});
const $25cbe9fdb2d8d071$var$innerContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1232px",
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        width: "1232px"
    }
});
const $25cbe9fdb2d8d071$var$navContentWrapperStyles = (0, $hgUW1$css)({
    flex: 1,
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        flexDirection: "column"
    }
});
const $25cbe9fdb2d8d071$var$navMenuToggleButtonStyles = (0, $hgUW1$css)({
    flex: 0,
    alignSelf: "flex-end",
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    },
    button: {
        "&:hover, &:active": {
            backgroundColor: "transparent",
            color: (0, $hgUW1$token)("color.icon.brand")
        }
    }
});
const $25cbe9fdb2d8d071$var$desktopNavWrapperStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    width: "100%",
    padding: "16px 12px",
    margin: 0,
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "block",
        position: "relative",
        gap: "8px",
        padding: 0,
        boxShadow: "none",
        height: "42px"
    }
});
// mobile/tablet open menu
const $25cbe9fdb2d8d071$var$smallNavWrapperStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    right: 0,
    margin: 0,
    width: "100%",
    zIndex: 1000,
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MAX_WIDTH}px)`]: {
        // full screen menu in mobile view
        height: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        marginTop: "56px"
    },
    [`@media ((min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MIN_WIDTH}px) and (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px))`]: {
        // appearance of floating fixed-width menu in tablet view
        width: "375px",
        top: "100%",
        marginTop: "-9px",
        marginRight: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)"
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $25cbe9fdb2d8d071$var$smallNavUlStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    listStyle: "none",
    padding: "16px 0"
});
const $25cbe9fdb2d8d071$var$logoWrapperStyles = (0, $hgUW1$css)({
    margin: 0,
    padding: 0,
    paddingRight: "32px",
    flexShrink: 0,
    flexGrow: 0
});
const $25cbe9fdb2d8d071$var$leftItemStyles = (0, $hgUW1$css)({
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        alignSelf: "flex-start",
        width: "100%"
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        float: "left",
        marginRight: "8px"
    }
});
const $25cbe9fdb2d8d071$var$rightItemStyles = (0, $hgUW1$css)({
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        width: "100%"
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        float: "right"
    }
});


var $3fbcb32390ca7008$exports = {};

$parcel$export($3fbcb32390ca7008$exports, "RadioType", () => $3fbcb32390ca7008$export$f5eff9f4cffe1e46);
$parcel$export($3fbcb32390ca7008$exports, "RadioSize", () => $3fbcb32390ca7008$export$4da24539a3bb7d98);
$parcel$export($3fbcb32390ca7008$exports, "Radio", () => $3fbcb32390ca7008$export$d7b12c4107be0d61);






let $3fbcb32390ca7008$export$f5eff9f4cffe1e46;
(function(RadioType) {
    RadioType["DEFAULT"] = "DEFAULT";
    RadioType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    RadioType["DANGER"] = "DANGER";
    RadioType["DISABLED"] = "DISABLED";
})($3fbcb32390ca7008$export$f5eff9f4cffe1e46 || ($3fbcb32390ca7008$export$f5eff9f4cffe1e46 = {}));
let $3fbcb32390ca7008$export$4da24539a3bb7d98;
(function(RadioSize) {
    RadioSize["DEFAULT"] = "DEFAULT";
    RadioSize["LARGE"] = "LARGE";
})($3fbcb32390ca7008$export$4da24539a3bb7d98 || ($3fbcb32390ca7008$export$4da24539a3bb7d98 = {}));
const $3fbcb32390ca7008$export$d7b12c4107be0d61 = ({ label: label , name: name , isChecked: isChecked , setIsChecked: setIsChecked , type: type = $3fbcb32390ca7008$export$f5eff9f4cffe1e46.DEFAULT , size: size = $3fbcb32390ca7008$export$4da24539a3bb7d98.DEFAULT , isRequired: isRequired = false , isBold: isBold , tabIndex: tabIndex = 0  })=>{
    const handleChange = (0, $hgUW1$useCallback)(()=>{
        setIsChecked(!isChecked);
    }, [
        isChecked,
        setIsChecked
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(handleChange), [
        isChecked
    ]);
    const labelAndInputConnection = name ? `${name}-${label?.toLowerCase().replace(/\s+/g, "-")}` + "-radio-input" : label?.toLowerCase().replace(/\s+/g, "-") + "-radio-input";
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $3fbcb32390ca7008$var$radioContainerStyles,
            size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && (0, $hgUW1$css)({
                columnGap: "8px"
            })
        ],
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("label", {
            htmlFor: labelAndInputConnection,
            css: [
                $3fbcb32390ca7008$var$labelStyles,
                size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && $3fbcb32390ca7008$var$labelLargeStyles,
                type === $3fbcb32390ca7008$export$f5eff9f4cffe1e46.DISABLED && $3fbcb32390ca7008$var$variantClasses.label.DISABLED,
                isBold && (0, $hgUW1$css)({
                    fontWeight: 700
                }),
                !isBold && (0, $hgUW1$css)({
                    fontWeight: 400
                })
            ],
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("input", {
                    "data-testid": "radio-input",
                    name: name,
                    tabIndex: -1,
                    id: labelAndInputConnection,
                    type: "radio",
                    role: "radio",
                    css: $3fbcb32390ca7008$var$inputStyles,
                    checked: isChecked,
                    onChange: (e)=>setIsChecked(e.currentTarget.checked),
                    "aria-checked": isChecked
                }),
                label,
                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    role: "radio",
                    "aria-checked": isChecked,
                    "aria-label": label,
                    tabIndex: tabIndex,
                    onKeyDown: handleKeyDown,
                    css: [
                        $3fbcb32390ca7008$var$variantClasses.checkbox[type],
                        $3fbcb32390ca7008$var$checkmarkStyles,
                        size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && $3fbcb32390ca7008$var$checkmarkLargeStyles,
                        isChecked && $3fbcb32390ca7008$var$checkedCheckmarkStyles,
                        isChecked && type === $3fbcb32390ca7008$export$f5eff9f4cffe1e46.DANGER && (0, $hgUW1$css)({
                            backgroundColor: (0, $hgUW1$token)("color.border.danger")
                        })
                    ]
                }),
                isRequired && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    css: [
                        $3fbcb32390ca7008$var$requiredMarkStyles,
                        size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && (0, $hgUW1$css)({
                            marginLeft: "4px"
                        })
                    ],
                    children: "*"
                })
            ]
        })
    });
};
const $3fbcb32390ca7008$var$radioContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    columnGap: "6px"
});
const $3fbcb32390ca7008$var$requiredMarkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtle"),
    marginLeft: "2px"
});
const $3fbcb32390ca7008$var$inputStyles = (0, $hgUW1$css)({
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
    cursor: "pointer"
});
const $3fbcb32390ca7008$var$checkmarkStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "2px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "50%",
    border: `1px solid ${(0, $hgUW1$token)("color.border.input")}`,
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    },
    [(0, $hgUW1$media1).below.xs]: {
        marginTop: "4px"
    }
});
const $3fbcb32390ca7008$var$checkmarkLargeStyles = (0, $hgUW1$css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "5px !important",
        width: "8px !important",
        height: "8px !important"
    }
});
const $3fbcb32390ca7008$var$checkedCheckmarkStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold"),
    borderColor: (0, $hgUW1$token)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "4px",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: (0, $hgUW1$token)("color.background.input")
    }
});
const $3fbcb32390ca7008$var$labelStyles = (0, $hgUW1$css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    userSelect: "none",
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px"
});
const $3fbcb32390ca7008$var$labelLargeStyles = (0, $hgUW1$css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $3fbcb32390ca7008$var$variantClasses = {
    label: {
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $hgUW1$css)({
            ":hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        SUCCESS: (0, $hgUW1$css)({
            ":hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        DANGER: (0, $hgUW1$css)({
            "&, &:hover": {
                borderColor: (0, $hgUW1$token)("color.border.danger")
            }
        }),
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};


var $731a4fd527bab680$exports = {};

$parcel$export($731a4fd527bab680$exports, "TabsSize", () => $731a4fd527bab680$export$ddadc1228c8dcfa);
$parcel$export($731a4fd527bab680$exports, "Tab", () => $731a4fd527bab680$export$3e41faf802a29e71);





let $731a4fd527bab680$export$ddadc1228c8dcfa;
(function(TabsSize) {
    TabsSize["MEDIUM"] = "medium";
    TabsSize["LARGE"] = "large";
})($731a4fd527bab680$export$ddadc1228c8dcfa || ($731a4fd527bab680$export$ddadc1228c8dcfa = {}));
const $731a4fd527bab680$export$3e41faf802a29e71 = ({ label: label , onClick: onClick , iconBefore: iconBefore , iconAfter: iconAfter , size: size = $731a4fd527bab680$export$ddadc1228c8dcfa.MEDIUM , selected: selected = false , isLoading: isLoading  })=>{
    const clickHandler = (0, $hgUW1$useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        tabIndex: 0,
        onClick: clickHandler,
        "data-testid": `tab${selected ? "-selected" : ""}`,
        css: [
            $731a4fd527bab680$var$tabStyles["basic"],
            selected && $731a4fd527bab680$var$tabStyles["selected"],
            !iconBefore && !iconAfter && $731a4fd527bab680$var$tabSpacingStyles[size],
            iconBefore && $731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-before`],
            iconAfter && $731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-after`]
        ],
        children: [
            iconBefore && !isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginRight: "0.25rem"
                    })
                ],
                children: iconBefore
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    isLoading && (0, $hgUW1$css)({
                        marginRight: "0.5rem"
                    })
                ],
                children: label
            }),
            iconAfter && !isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginLeft: "0.25rem"
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $731a4fd527bab680$var$tabStyles = {
    basic: (0, $hgUW1$css)({
        display: "flex",
        alignItems: "center",
        borderRadius: "3.125rem",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        color: (0, $hgUW1$token)("color.text"),
        border: `0.125rem solid ${(0, $hgUW1$token)("color.border")}`,
        cursor: "pointer",
        outline: "none",
        background: "transparent",
        [(0, $hgUW1$media1).below.xs]: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 1rem"
        },
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest"),
            borderColor: (0, $hgUW1$token)("color.border"),
            color: (0, $hgUW1$token)("color.text")
        },
        "&:focus-visible": {
            border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
        }
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.bold.pressed"),
        color: (0, $hgUW1$token)("color.text.inverse"),
        border: "0.125rem solid",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.brand.boldest"),
            color: (0, $hgUW1$token)("color.text.inverse"),
            border: "0.125rem solid"
        }
    })
};
const $731a4fd527bab680$var$tabSpacingStyles = {
    medium: (0, $hgUW1$css)({
        padding: "0.375rem 1.5rem"
    }),
    "medium-icon-before": (0, $hgUW1$css)({
        padding: "0.375rem 1.5rem 0.375rem 1rem"
    }),
    "medium-icon-after": (0, $hgUW1$css)({
        padding: "0.375rem 1rem 0.375rem 1.5rem"
    }),
    large: (0, $hgUW1$css)({
        padding: "0.625rem 1.5rem"
    }),
    "large-icon-before": (0, $hgUW1$css)({
        padding: "0.625rem 1.5rem 0.625rem 1rem"
    }),
    "large-icon-after": (0, $hgUW1$css)({
        padding: "0.625rem 1rem 0.625rem 1.5rem"
    })
};
const $731a4fd527bab680$var$tabIconContainerStyles = (0, $hgUW1$css)({
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});


var $5cf70e33bfc6ce73$exports = {};

$parcel$export($5cf70e33bfc6ce73$exports, "Tag", () => $5cf70e33bfc6ce73$export$3288d34c523a1192);
$parcel$export($5cf70e33bfc6ce73$exports, "tagListStyles", () => $5cf70e33bfc6ce73$export$f40d73b6f7f951e9);




const $5cf70e33bfc6ce73$export$3288d34c523a1192 = ({ inspectMode: inspectMode , label: label , onClick: onClick , selected: selected , iconAfter: iconAfter , iconBefore: iconBefore  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("tag", inspectMode),
        tabIndex: -1,
        css: [
            $5cf70e33bfc6ce73$var$tagStyles,
            selected && $5cf70e33bfc6ce73$var$selectedTagStyles,
            onClick && $5cf70e33bfc6ce73$var$hoverableTagStyles,
            iconBefore && $5cf70e33bfc6ce73$var$beforeIconTagStyles,
            iconAfter && $5cf70e33bfc6ce73$var$afterIconTagStyles
        ],
        onClick: onClick,
        children: [
            iconBefore && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $5cf70e33bfc6ce73$var$iconStyles,
                    $5cf70e33bfc6ce73$var$beforeIconStyles
                ],
                children: iconBefore
            }),
            label,
            iconAfter && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $5cf70e33bfc6ce73$var$iconStyles,
                    $5cf70e33bfc6ce73$var$afterIconStyles
                ],
                children: iconAfter
            })
        ]
    });
const $5cf70e33bfc6ce73$export$f40d73b6f7f951e9 = (0, $hgUW1$css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $hgUW1$token)("space.100")
});
const $5cf70e33bfc6ce73$var$tagStyles = (0, $hgUW1$css)({
    display: "flex",
    height: "24px",
    padding: `4px ${(0, $hgUW1$token)("space.100")}`,
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    borderRadius: "4px",
    alignItems: "center",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $hgUW1$token)("color.text"),
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $5cf70e33bfc6ce73$var$hoverableTagStyles = (0, $hgUW1$css)({
    "&:hover": {
        borderColor: (0, $hgUW1$token)("color.border.accent.gray"),
        cursor: "pointer"
    }
});
const $5cf70e33bfc6ce73$var$selectedTagStyles = (0, $hgUW1$css)({
    borderColor: (0, $hgUW1$token)("color.border.selected")
});
const $5cf70e33bfc6ce73$var$iconStyles = (0, $hgUW1$css)({
    span: {
        width: "14px",
        height: "14px",
        marginBottom: "2px"
    }
});
const $5cf70e33bfc6ce73$var$beforeIconStyles = (0, $hgUW1$css)({
    marginRight: "0.125rem"
});
const $5cf70e33bfc6ce73$var$afterIconStyles = (0, $hgUW1$css)({
    marginLeft: "0.125rem"
});
const $5cf70e33bfc6ce73$var$beforeIconTagStyles = (0, $hgUW1$css)({
    paddingLeft: "0.375rem"
});
const $5cf70e33bfc6ce73$var$afterIconTagStyles = (0, $hgUW1$css)({
    paddingRight: "0.375rem"
});


var $8b54d37779d052e8$exports = {};

$parcel$export($8b54d37779d052e8$exports, "Text", () => $8b54d37779d052e8$export$5f1af8db9871e1d6);






const $8b54d37779d052e8$export$5f1af8db9871e1d6 = ({ fontWeight: fontWeight = "regular" , size: size = "regular" , color: color = (0, $hgUW1$token)("color.text.accent.gray.bolder") , children: children , backgroundColor: backgroundColor  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
        css: [
            $8b54d37779d052e8$var$textDefaultStyles,
            backgroundColor && (0, $hgUW1$css)({
                backgroundColor: backgroundColor,
                padding: "4px"
            }),
            color && (0, $hgUW1$css)({
                color: color
            }),
            $8b54d37779d052e8$var$variantsStyles.fontWeight[fontWeight],
            $8b54d37779d052e8$var$variantsStyles.size[size]
        ],
        children: children
    });
const $8b54d37779d052e8$var$textDefaultStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    blockquote: (0, $660bd1c6cb41002a$export$7a77f8e9665fa6b2),
    ul: (0, $800df40a54823a3f$export$6427468642e6e9fe).list.unordered,
    ol: (0, $800df40a54823a3f$export$6427468642e6e9fe).list.ordered
});
const $8b54d37779d052e8$var$variantsStyles = {
    size: {
        small: (0, $hgUW1$css)({
            fontSize: "14px",
            lineHeight: "20px",
            [(0, $hgUW1$media).above.sm]: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }),
        regular: (0, $hgUW1$css)({
            fontSize: "14px",
            lineHeight: "22px",
            [(0, $hgUW1$media).above.sm]: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }),
        large: (0, $hgUW1$css)({
            fontSize: "16px",
            lineHeight: "24px",
            [(0, $hgUW1$media).above.sm]: {
                fontSize: "20px",
                lineHeight: "32px"
            }
        })
    },
    fontWeight: {
        regular: (0, $hgUW1$css)({
            fontWeight: 400
        }),
        semibold: (0, $hgUW1$css)({
            fontWeight: 600
        }),
        bold: (0, $hgUW1$css)({
            fontWeight: 700
        })
    }
};


var $9cfa05d02afa3952$exports = {};

$parcel$export($9cfa05d02afa3952$exports, "AccordionSize", () => $9cfa05d02afa3952$export$8f89d78db9c8c41f);
$parcel$export($9cfa05d02afa3952$exports, "Accordion", () => $9cfa05d02afa3952$export$a766cd26d0d69044);








const $51f57eef4d47f918$var$NAVBAR_HEIGHT = 124;
const $51f57eef4d47f918$export$10e5e64ea66c812f = ({ title: title , index: index , children: children , isFirstTab: isFirstTab , isExpanded: isExpanded , shouldSingleTabBeOpen: shouldSingleTabBeOpen , setTabState: setTabState , setExpansionMap: setExpansionMap  })=>{
    const tabRef = (0, $hgUW1$useRef)(null);
    const handleExpand = (0, $hgUW1$useCallback)(()=>{
        if (!setExpansionMap) return;
        setExpansionMap((prevState)=>prevState.map((tab, i)=>{
                if (setTabState && index !== undefined && i === index) setTabState({
                    [index + 1]: !tab.isExpanded ? "expand" : "collapse"
                });
                return {
                    ...tab,
                    isExpanded: i === index ? !tab.isExpanded : shouldSingleTabBeOpen ? false : tab.isExpanded
                };
            }));
    }, [
        setExpansionMap,
        title
    ]);
    const disableClickEventBubbling = (event)=>event.stopPropagation();
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                handleExpand();
            }
        }
    }, [
        handleExpand
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (isExpanded && tabRef.current) {
            const topPosition = tabRef.current.getBoundingClientRect().top + window.scrollY - $51f57eef4d47f918$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        ref: tabRef,
        onKeyDown: handleKeyDown,
        css: [
            $51f57eef4d47f918$var$accordionTabStyles,
            isFirstTab && $51f57eef4d47f918$var$firstTabStyles,
            isExpanded && $51f57eef4d47f918$var$expandedTabStyles
        ],
        onClick: handleExpand,
        "data-testid": `accordion-tab-${title}`,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    isExpanded && $51f57eef4d47f918$var$expandedTabContentStyles
                ],
                children: isExpanded ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-down",
                    alt: "Chevron down"
                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-right",
                    alt: "Chevron right"
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $51f57eef4d47f918$var$contentContainer,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $51f57eef4d47f918$var$titleStyles,
                        children: title
                    }),
                    isExpanded && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        onClick: disableClickEventBubbling,
                        css: $51f57eef4d47f918$var$contentStyles,
                        "data-testid": "accordion-tab-content",
                        children: children
                    })
                ]
            })
        ]
    });
};
const $51f57eef4d47f918$var$accordionTabStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "flex-start",
    padding: "24px",
    cursor: "pointer",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $51f57eef4d47f918$var$firstTabStyles = (0, $hgUW1$css)({
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $51f57eef4d47f918$var$expandedTabStyles = (0, $hgUW1$css)({
    borderLeft: `${(0, $hgUW1$token)("space.100")} solid ${(0, $hgUW1$token)("color.border.accent.blue")}`
});
const $51f57eef4d47f918$var$expandedTabContentStyles = (0, $hgUW1$css)({
    marginLeft: "-0.5rem"
});
const $51f57eef4d47f918$var$contentContainer = (0, $hgUW1$css)({
    marginLeft: "0.75rem"
});
const $51f57eef4d47f918$var$titleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    color: (0, $hgUW1$token)("color.text")
});
const $51f57eef4d47f918$var$contentStyles = (0, $hgUW1$css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    color: (0, $hgUW1$token)("color.text"),
    ol: {
        margin: 0
    },
    ul: {
        margin: 0
    },
    a: {
        fontSize: "20px !important",
        lineHeight: "28px !important"
    }
});



let $9cfa05d02afa3952$export$8f89d78db9c8c41f;
(function(AccordionSize) {
    AccordionSize["DEFAULT"] = "default";
    AccordionSize["WIDE"] = "wide";
})($9cfa05d02afa3952$export$8f89d78db9c8c41f || ($9cfa05d02afa3952$export$8f89d78db9c8c41f = {}));
const $9cfa05d02afa3952$export$a766cd26d0d69044 = ({ tabsContent: tabsContent , size: size , shouldSingleTabBeOpen: shouldSingleTabBeOpen , onChange: onChange  })=>{
    const [expansionMap, setExpansionMap] = (0, $hgUW1$useState)([]);
    const [tabState, setTabState] = (0, $hgUW1$useState)();
    (0, $hgUW1$useEffect)(()=>{
        const initialExpansionMap = tabsContent.map((tabContent)=>({
                ...tabContent,
                isExpanded: false
            }));
        setExpansionMap(initialExpansionMap);
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        if (!tabState) return;
        onChange(tabState);
    }, [
        expansionMap,
        setExpansionMap
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $9cfa05d02afa3952$var$baseAccordionStyles,
            $9cfa05d02afa3952$export$8f89d78db9c8c41f.DEFAULT === size && $9cfa05d02afa3952$var$accordionDefaultStyles,
            $9cfa05d02afa3952$export$8f89d78db9c8c41f.WIDE === size && $9cfa05d02afa3952$var$accordionWideStyles
        ],
        "data-testid": "lesson-accordion",
        children: expansionMap.map(({ title: title , children: children , isExpanded: isExpanded  }, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $51f57eef4d47f918$export$10e5e64ea66c812f), {
                title: title,
                isFirstTab: index === 0,
                index: index,
                isExpanded: isExpanded,
                shouldSingleTabBeOpen: shouldSingleTabBeOpen,
                setTabState: setTabState,
                setExpansionMap: setExpansionMap,
                children: children
            }, title))
    });
};
const $9cfa05d02afa3952$var$baseAccordionStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column"
});
const $9cfa05d02afa3952$var$accordionDefaultStyles = (0, $hgUW1$css)({
    maxWidth: "720px"
});
const $9cfa05d02afa3952$var$accordionWideStyles = (0, $hgUW1$css)({
    maxWidth: "1020px",
    [(0, $hgUW1$media).below.md]: {
        maxWidth: "720px"
    }
});


var $7d458ed59bb9c6a8$exports = {};

$parcel$export($7d458ed59bb9c6a8$exports, "InlineCode", () => $7d458ed59bb9c6a8$export$7f1bf47c7f50a6aa);






const $7d458ed59bb9c6a8$export$7f1bf47c7f50a6aa = ({ code: code = ""  })=>{
    const lines = code ? code.split(/\r\n|\r|\n/) : null;
    const [isCopied, setIsCopied] = (0, $hgUW1$useState)(false);
    const copy = (code)=>{
        navigator.clipboard.writeText(code);
        setIsCopied(true);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("code", {
        "data-testid": "code-block",
        css: $7d458ed59bb9c6a8$var$inlineCodeStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                css: [
                    $7d458ed59bb9c6a8$var$inlineCodeButtonStyles,
                    isCopied ? (0, $hgUW1$css)({
                        backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
                        border: "2px solid"
                    }) : (0, $hgUW1$css)({
                        backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest"),
                        border: `2px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
                        "&:hover": {
                            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.hovered"),
                            border: "2px solid transparent"
                        }
                    })
                ],
                "aria-label": "Copy",
                "aria-haspopup": "true",
                type: "button",
                tabIndex: 0,
                onClick: ()=>copy(code),
                onMouseOut: ()=>setIsCopied(false),
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        className: "tooltipText",
                        css: $7d458ed59bb9c6a8$var$tooltipTextStyles,
                        children: isCopied ? "Copied!" : "Copy"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "copy",
                        color: isCopied ? (0, $hgUW1$N0) : (0, $hgUW1$N800)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                children: lines?.map((line, index)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                        css: $7d458ed59bb9c6a8$var$codeLinesStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $7d458ed59bb9c6a8$var$lineNumberStyles,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $7d458ed59bb9c6a8$var$lineTextStyles,
                                children: line
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $7d458ed59bb9c6a8$var$inlineCodeStyles = (0, $hgUW1$css)({
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    margin: "20px 0",
    flexDirection: "column",
    borderRadius: "3px",
    overflowWrap: "normal",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
});
const $7d458ed59bb9c6a8$var$inlineCodeButtonStyles = (0, $hgUW1$css)({
    position: "absolute",
    right: "8px",
    top: "6px",
    display: "flex",
    padding: "2px",
    borderRadius: "4px",
    transition: "opacity 0.2s ease 0s",
    opacity: 0,
    zIndex: 1,
    cursor: "pointer",
    "&:hover .tooltipText": {
        opacity: 1
    },
    "&:hover": {
        opacity: 1
    }
});
const $7d458ed59bb9c6a8$var$tooltipTextStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: "-30px",
    padding: "2px 6px",
    marginLeft: "-5px",
    borderRadius: "6px",
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
    color: (0, $hgUW1$token)("color.text.inverse"),
    textAlign: "center",
    fontSize: "11px",
    opacity: 0,
    zIndex: 1,
    transition: "opacity 0.4s ease 0s",
    "&:hover": {
        opacity: 1
    }
});
const $7d458ed59bb9c6a8$var$codeLinesStyles = (0, $hgUW1$css)({
    display: "flex",
    lineHeight: "20px",
    whiteSpace: "pre",
    fontSize: "12px"
});
const $7d458ed59bb9c6a8$var$lineNumberStyles = (0, $hgUW1$css)({
    padding: "4px 8px",
    marginRight: "8px",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtler")
});
const $7d458ed59bb9c6a8$var$lineTextStyles = (0, $hgUW1$css)({
    padding: "4px 8px 4px 0"
});


var $a467abe0c2c1750b$exports = {};

$parcel$export($a467abe0c2c1750b$exports, "Lozenge", () => $a467abe0c2c1750b$export$a31cbe1bf5463979);



const $a467abe0c2c1750b$export$a31cbe1bf5463979 = ({ appearance: appearance = "default" , text: text , isBold: isBold  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitlozenge), {
        isBold: isBold,
        appearance: appearance,
        testId: "lozenge",
        children: text?.toUpperCase()
    });


var $52124b9ae1d78e04$exports = {};

$parcel$export($52124b9ae1d78e04$exports, "SectionMessageAppearance", () => $52124b9ae1d78e04$export$710836885d72543c);
$parcel$export($52124b9ae1d78e04$exports, "SectionMessage", () => $52124b9ae1d78e04$export$a36903bd214cec06);






let $52124b9ae1d78e04$export$710836885d72543c;
(function(SectionMessageAppearance) {
    SectionMessageAppearance["INFORMATION"] = "information";
    SectionMessageAppearance["INFORMATION_WHITE"] = "information_white";
})($52124b9ae1d78e04$export$710836885d72543c || ($52124b9ae1d78e04$export$710836885d72543c = {}));
const $52124b9ae1d78e04$export$a36903bd214cec06 = ({ children: children , appearance: appearance , fullWidth: fullWidth = false  })=>{
    const isInfoWhite = appearance === $52124b9ae1d78e04$export$710836885d72543c.INFORMATION_WHITE;
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $52124b9ae1d78e04$var$sectionMessageContainerStyles,
            isInfoWhite && $52124b9ae1d78e04$var$informationWhiteStyles,
            !isInfoWhite && $52124b9ae1d78e04$var$informationStyles,
            !fullWidth && (0, $hgUW1$css)({
                maxWidth: "720px"
            })
        ],
        "data-testid": `section-message${isInfoWhite ? "-white" : ""}`,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $52124b9ae1d78e04$var$iconContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "info",
                    alt: "info icon",
                    color: (0, $hgUW1$token)("color.icon.accent.blue")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $52124b9ae1d78e04$var$descriptionStyles,
                children: children
            })
        ]
    });
};
const $52124b9ae1d78e04$var$sectionMessageContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    borderRadius: "3px",
    padding: (0, $hgUW1$token)("space.300")
});
const $52124b9ae1d78e04$var$informationStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.information")
});
const $52124b9ae1d78e04$var$informationWhiteStyles = (0, $hgUW1$css)({
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    backgroundColor: (0, $hgUW1$token)("elevation.surface")
});
const $52124b9ae1d78e04$var$iconContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.050"),
    marginRight: (0, $hgUW1$token)("space.300"),
    [(0, $hgUW1$media).below.md]: {
        marginRight: (0, $hgUW1$token)("space.200")
    }
});
const $52124b9ae1d78e04$var$descriptionStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "32px",
    marginTop: 0,
    marginBottom: 0,
    p: {
        marginTop: 0,
        marginBottom: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $hgUW1$media).below.md]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});


var $6e2eae4c8556b5b9$exports = {};

$parcel$export($6e2eae4c8556b5b9$exports, "DropdownMenuCheckbox", () => $6e2eae4c8556b5b9$export$2393c31da95977ae);





const $6e2eae4c8556b5b9$export$2393c31da95977ae = ({ items: items , placement: placement , onItemClick: onItemClick  })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $hgUW1$useState)(false);
    const [itemsList, setItemList] = (0, $hgUW1$useState)(items);
    const handleItemClick = (label)=>{
        setItemList((prev)=>{
            const updatedState = {
                ...prev
            };
            Object.keys(updatedState).forEach((key)=>{
                updatedState[key].isSelected = key === label;
            });
            return updatedState;
        });
        onItemClick(label);
    };
    const getFirstSelectedItem = (itemsChecked)=>{
        const selectedItem = Object.keys(itemsChecked).find((key)=>itemsChecked[key].isSelected);
        return selectedItem || Object.keys(itemsChecked)[0];
    };
    const isAnyItemSelected = Object.values(items).some(({ isSelected: isSelected  })=>isSelected);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $6e2eae4c8556b5b9$var$triggerRewriteStyles,
            isAnyItemSelected && isDropdownOpen && $6e2eae4c8556b5b9$var$triggerSelectedRewriteStyles
        ],
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitdropdownmenu), {
            onOpenChange: ({ isOpen: isOpen  })=>setIsDropdownOpen(isOpen),
            trigger: getFirstSelectedItem(itemsList),
            shouldRenderToParent: true,
            placement: placement,
            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItemRadioGroup), {
                id: "actions",
                children: Object.entries(itemsList).map(([label, value])=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItemRadio), {
                        testId: `dropdown-item-checkbox-${label}`,
                        isDisabled: value.isDisabled,
                        id: label,
                        onClick: ()=>handleItemClick(label),
                        isSelected: itemsList[label].isSelected,
                        children: label
                    }, label))
            })
        })
    });
};
const $6e2eae4c8556b5b9$var$triggerRewriteStyles = (0, $hgUW1$css)({
    "& > button": {
        border: `1px solid ${(0, $hgUW1$token)("color.border.brand")}`,
        padding: `${(0, $hgUW1$token)("space.100")} ${(0, $hgUW1$token)("space.100")} ${(0, $hgUW1$token)("space.100")} ${(0, $hgUW1$token)("space.150")}`,
        background: "#fff",
        alignItems: "center",
        height: "40px",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif",
        color: (0, $hgUW1$token)("color.text.brand"),
        borderRadius: "4px",
        ":hover": {
            background: (0, $hgUW1$token)("color.background.selected"),
            color: (0, $hgUW1$token)("color.text.selected")
        }
    },
    "#actions": {
        "button[disabled]": {
            background: (0, $hgUW1$token)("color.background.disabled"),
            span: {
                color: (0, $hgUW1$token)("color.text.disabled"),
                ":hover": {
                    color: (0, $hgUW1$token)("color.text.disabled")
                }
            },
            rect: {
                stroke: (0, $hgUW1$token)("color.border.disabled")
            }
        },
        ":before, :after": {
            display: "none"
        },
        button: {
            padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} 24px`,
            width: "220px",
            height: "48px",
            '[aria-checked="true"]:before': {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "2px",
                height: "100%",
                background: `${(0, $hgUW1$token)("color.text.selected")}`
            },
            span: {
                gap: 0,
                span: {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                }
            }
        }
    },
    svg: {
        width: "30px",
        height: "30px"
    }
});
const $6e2eae4c8556b5b9$var$triggerSelectedRewriteStyles = (0, $hgUW1$css)({
    "& > button": {
        border: 0,
        background: (0, $hgUW1$token)("color.background.selected")
    }
});


var $4366d2b05f9f8f6b$exports = {};

$parcel$export($4366d2b05f9f8f6b$exports, "GreetingCard", () => $4366d2b05f9f8f6b$export$e52b3c28ffecde23);






const $7a335ab395aac0f5$export$6b53fc34987132a8 = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        viewBox: "0 0 406 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                clipPath: "url(#clip0_511_7308)",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M396.155 27.8221H394.244L388.065 11.4229H391.206L396.667 26.4205L402.129 11.4229H405.269L398.818 28.3828C396.906 33.3937 395.814 35.9867 391.479 35.9867C390.011 35.9867 389.192 35.8465 388.338 35.4961V32.9031C389.328 33.2185 390.455 33.3236 391.308 33.3236C393.697 33.3236 394.756 31.6416 396.155 27.8221Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M382.705 23.5062C382.705 25.048 383.593 26.0992 385.402 26.0992C386.085 26.0992 386.733 25.9591 387.245 25.854V28.7624C386.733 28.9025 386.153 29.0427 385.265 29.0427C381.613 29.0427 379.838 26.8351 379.838 23.5763V14.2203H377.073V11.417H379.838V7.70264H382.705V11.417H387.245V14.2203H382.705V23.5062Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M370.731 6.79681C370.731 5.46524 371.585 4.69434 372.779 4.69434C373.974 4.69434 374.827 5.46524 374.827 6.79681C374.827 8.12837 373.974 8.89928 372.779 8.89928C371.585 8.89928 370.731 8.12837 370.731 6.79681ZM371.278 28.9428V11.4222H374.213V28.9428H371.278Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M367.184 18.6738V28.9408H364.248V18.3584C364.248 15.2047 363.019 13.803 360.22 13.803C357.49 13.803 355.612 15.6602 355.612 19.1994V28.9408H352.677V11.4202H355.612V14.2936C356.705 12.2262 358.718 11.0698 361.005 11.0698C364.931 11.0698 367.184 13.8381 367.184 18.6738Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M333.733 21.6899V11.4229H336.669V22.0053C336.669 25.159 337.898 26.5606 340.697 26.5606C343.427 26.5606 345.305 24.7035 345.305 21.1643V11.4229H348.24V28.9434H345.305V26.0701C344.212 28.1375 342.199 29.2938 339.912 29.2938C335.986 29.2938 333.733 26.5256 333.733 21.6899Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M318.416 19.1994V28.9408H315.48V18.3584C315.48 15.2047 314.252 13.803 311.453 13.803C308.722 13.803 306.845 15.6602 306.845 19.1994V28.9408H303.909V11.4202H306.845V14.2936C307.937 12.2262 309.951 11.0698 312.238 11.0698C315.139 11.0698 317.119 12.5766 317.972 15.3448C318.928 12.6467 321.215 11.0698 324.048 11.0698C327.871 11.0698 329.987 13.733 329.987 18.6738V28.9408H327.052V19.1994C327.052 15.5901 325.823 13.803 323.024 13.803C320.293 13.803 318.416 15.6602 318.416 19.1994Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M288.249 19.1994V28.9408H285.314V18.3584C285.314 15.2047 284.085 13.803 281.286 13.803C278.555 13.803 276.678 15.6602 276.678 19.1994V28.9408H273.742V11.4202H276.678V14.2936C277.77 12.2262 279.784 11.0698 282.071 11.0698C284.972 11.0698 286.952 12.5766 287.805 15.3448C288.761 12.6467 291.048 11.0698 293.881 11.0698C297.704 11.0698 299.82 13.733 299.82 18.6738V28.9408H296.885V19.1994C296.885 15.5901 295.656 13.803 292.857 13.803C290.126 13.803 288.249 15.6602 288.249 19.1994Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M262.275 29.2912C257.155 29.2912 254.151 25.4017 254.151 20.1455C254.151 14.8893 257.155 11.0698 262.275 11.0698C267.361 11.0698 270.331 14.8893 270.331 20.1455C270.331 25.4017 267.361 29.2912 262.275 29.2912ZM262.275 13.8731C258.623 13.8731 257.019 16.8166 257.019 20.1455C257.019 23.4744 258.623 26.4879 262.275 26.4879C265.893 26.4879 267.464 23.4744 267.464 20.1455C267.464 16.8166 265.893 13.8731 262.275 13.8731Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M251.998 24.88V27.9285C250.598 28.8746 248.38 29.2951 246.059 29.2951C238.686 29.2951 234.521 24.7398 234.521 17.4863C234.521 10.478 238.686 5.57227 245.99 5.57227C248.175 5.57227 250.36 5.99276 251.964 7.18416V10.2327C250.36 9.18151 248.585 8.62085 245.99 8.62085C240.734 8.62085 237.594 12.195 237.594 17.4863C237.594 22.7775 240.836 26.2816 246.161 26.2816C248.516 26.2816 250.36 25.7209 251.998 24.88Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M119.605 12.4499C119.605 15.8465 121.102 18.5153 127.168 19.7284C130.713 20.5371 131.501 21.1032 131.501 22.3163C131.501 23.5294 130.713 24.2572 128.192 24.2572C125.277 24.2572 121.811 23.2059 119.526 21.8311V27.3304C121.338 28.22 123.702 29.2713 128.192 29.2713C134.494 29.2713 136.936 26.3599 136.936 22.1546M136.936 22.2354C136.936 18.1918 134.888 16.3318 128.98 15.0378C125.75 14.3099 124.962 13.5821 124.962 12.5308C124.962 11.2368 126.144 10.6707 128.271 10.6707C130.87 10.6707 133.391 11.4794 135.833 12.6116V7.35493C134.1 6.46534 131.501 5.81836 128.428 5.81836C122.599 5.81836 119.605 8.40627 119.605 12.6116",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M200.274 5.979V29.0276H205.08V11.4783L207.049 16.088L213.824 29.0276H219.811V5.979H215.085V20.8595L213.273 16.4924L207.837 5.979H200.274Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M169.865 5.979H164.666V29.0276H169.865V5.979Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M158.679 22.1554C158.679 18.1117 156.631 16.2517 150.723 14.9577C147.493 14.2299 146.705 13.502 146.705 12.4507C146.705 11.1567 147.887 10.5906 150.014 10.5906C152.614 10.5906 155.134 11.3993 157.577 12.5316V7.27485C155.843 6.38526 153.244 5.73828 150.171 5.73828C144.342 5.73828 141.348 8.32619 141.348 12.5316C141.348 15.9282 142.845 18.597 148.911 19.8101C152.456 20.6188 153.244 21.1849 153.244 22.398C153.244 23.6111 152.456 24.3389 149.935 24.3389C147.02 24.3389 143.554 23.2876 141.27 21.9127V27.412C143.081 28.3016 145.445 29.353 149.935 29.353C156.159 29.353 158.679 26.4416 158.679 22.1554Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M79.1143 5.979V29.0276H89.828L91.4824 24.0135H84.3136V5.979H79.1143Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M57.9219 5.979V10.9122H63.6727V29.0276H68.9508V10.9122H75.1742V5.979H57.9219Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M50.2806 5.97412H43.4269L35.6279 29.0227H41.615L42.7179 25.1408C44.0572 25.5452 45.4752 25.7878 46.8932 25.7878C48.3112 25.7878 49.7292 25.5452 51.0684 25.1408L52.1713 29.0227H58.1584C58.0796 29.0227 50.2806 5.97412 50.2806 5.97412ZM46.8144 20.9355C45.7903 20.9355 44.8449 20.7737 43.9784 20.5311L46.8144 10.503L49.6504 20.5311C48.7838 20.7737 47.8385 20.9355 46.8144 20.9355Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M108.339 5.97363H101.485L93.6074 29.0222H99.5945L100.697 25.1404C102.037 25.5447 103.455 25.7873 104.873 25.7873C106.291 25.7873 107.709 25.5447 109.048 25.1404L110.151 29.0222H116.138L108.339 5.97363ZM104.873 20.935C103.849 20.935 102.903 20.7733 102.037 20.5306L104.873 10.5025L107.709 20.5306C106.842 20.7733 105.897 20.935 104.873 20.935Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M188.694 5.97363H181.84L174.041 29.0222H180.028L181.131 25.1404C182.47 25.5447 183.888 25.7873 185.306 25.7873C186.724 25.7873 188.142 25.5447 189.481 25.1404L190.584 29.0222H196.571L188.694 5.97363ZM185.306 20.935C184.282 20.935 183.337 20.7733 182.47 20.5306L185.306 10.5025L188.142 20.5306C187.276 20.7733 186.252 20.935 185.306 20.935Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                        clipPath: "url(#clip1_511_7308)",
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                            d: "M25.4715 28.1859L13.6868 3.70842C13.4549 3.1784 13.2229 3.08203 12.9445 3.08203C12.7125 3.08203 12.4342 3.1784 12.1558 3.66024C10.4855 6.40673 9.74318 9.58688 9.74318 12.9116C9.74318 17.5372 12.0166 21.8738 15.3571 28.8605C15.7283 29.6314 16.0067 29.776 16.6562 29.776H24.8219C25.4251 29.776 25.7498 29.5351 25.7498 29.0532C25.7498 28.8123 25.7034 28.6678 25.4715 28.1859ZM8.3513 16.6217C7.42338 15.1762 7.145 15.0799 6.91302 15.0799C6.68104 15.0799 6.54185 15.1762 6.12429 16.0435L0.231981 28.2823C0.0463961 28.6678 0 28.8123 0 29.005C0 29.3905 0.324773 29.776 1.02071 29.776H9.32562C9.88237 29.776 10.2999 29.2941 10.5319 28.3786C10.8103 27.2222 10.9031 26.2104 10.9031 25.0058C10.9031 21.6329 9.4648 18.3564 8.3513 16.6217Z",
                            fill: "#1868DB"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                        id: "clip0_511_7308",
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                            width: "406",
                            height: "37",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                        id: "clip1_511_7308",
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                            width: "25.7498",
                            height: "26.694",
                            fill: "white",
                            transform: "translate(0 3.08154)"
                        })
                    })
                ]
            })
        ]
    });






const $0467da094044eefe$export$590b8cc7d4f1d823 = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        viewBox: "0 0 112 113",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "icon-launched-new",
                clipPath: "url(#clip0_608_7795)",
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                    id: "Clip path group",
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("mask", {
                            id: "mask0_608_7795",
                            "mask-type": "luminance",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "112",
                            height: "113",
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                                id: "clip0_10_2524",
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                    id: "Vector",
                                    d: "M112 0.5H0V112.5H112V0.5Z",
                                    fill: "white"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                            mask: "url(#mask0_608_7795)",
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                id: "Group",
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_2",
                                        "fill-rule": "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.4245 80.4295C67.168 95.2604 53.3169 105.459 38.486 103.203C23.6551 100.946 13.456 87.0952 15.7126 72.2643C17.9691 57.4334 31.8202 47.2344 46.6512 49.4909C61.4821 51.7475 71.6811 65.5986 69.4245 80.4295ZM39.5994 70.0078C39.926 67.8848 38.4711 65.9103 36.3482 65.5837C34.2253 65.2571 32.2508 66.712 31.9242 68.8349C31.5976 70.9579 33.0524 72.9324 35.1754 73.259C37.2983 73.5856 39.2728 72.1307 39.5994 70.0078ZM54.9499 72.3385C55.2765 70.2156 53.8217 68.2411 51.6987 67.9145C49.5758 67.5879 47.6013 69.0428 47.2747 71.1657C46.9481 73.2887 48.403 75.2632 50.5259 75.5898C52.6488 75.9164 54.6233 74.4615 54.9499 72.3385ZM33.8541 82.7454L32.132 80.3998L27.4407 83.844L29.1628 86.1896C34.6112 93.5828 45.0181 95.1713 52.4262 89.7229L54.7718 88.0008L51.3276 83.3096L48.9819 85.0317C44.1719 88.565 37.4022 87.5406 33.869 82.7306L33.8541 82.7454Z",
                                        fill: "#1868DB"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_3",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M67.8214 26.5393C53.0795 29.3006 43.3555 43.4932 46.1169 58.2499C48.8782 72.9917 63.0707 82.7157 77.8125 79.9544C92.5544 77.1931 102.293 63.0005 99.5319 48.2587C96.7706 33.5168 82.5632 23.7929 67.8214 26.5393ZM78.6588 42.2758C80.7669 41.875 82.7859 43.2705 83.1867 45.3786C83.5875 47.4867 82.1921 49.5057 80.084 49.9066C77.9759 50.3074 75.9568 48.9119 75.556 46.8038C75.1552 44.6957 76.5507 42.6767 78.6588 42.2758ZM63.3973 45.1262C65.5054 44.7254 67.5244 46.1209 67.9253 48.229C68.3261 50.3371 66.9306 52.3561 64.8225 52.7569C62.7144 53.1578 60.6954 51.7623 60.2946 49.6542C59.8937 47.5461 61.2892 45.5271 63.3973 45.1262ZM76.3428 72.0713C68.9496 73.4519 61.8534 68.5974 60.4727 61.2339L87.1802 56.2308C88.5609 63.6092 83.6915 70.6906 76.328 72.0713H76.3428Z",
                                        fill: "#82B536"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_4",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_5",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_6",
                                        d: "M37.1105 18.5589C35.4939 18.8626 33.943 19.3745 32.443 19.9453C32.443 19.9453 31.9357 20.0403 31.129 20.2877C30.3129 20.4878 29.2409 20.8857 28.0837 21.3496C25.7784 22.3248 23.3235 23.9635 22.2601 25.3038C18.8575 27.6207 15.8953 30.6524 13.728 34.2501C13.728 34.2501 13.6005 34.5506 13.3796 35.0267C13.172 35.4954 12.8711 36.1395 12.6779 36.8806C12.4487 37.5894 12.2232 38.3664 12.138 39.0812C12.0319 39.7904 11.9544 40.3955 12.0307 40.8082C12.1735 41.8321 12.4667 42.4724 12.8105 42.6457C13.1619 42.8321 13.577 42.5438 13.99 41.6956C14.1653 41.2628 14.3883 40.6978 14.6648 39.9797C14.8788 39.2444 15.2371 38.3922 15.6052 37.3413C15.6582 37.3111 15.7874 37.1677 15.863 37.1775C16.5848 34.9263 18.0622 33.0179 19.7393 31.3996C21.4298 29.7737 23.3598 28.4153 25.3445 27.0607C25.1727 26.9127 25.2076 26.665 25.3929 26.6826L25.5019 26.9363C26.7066 25.8143 27.936 25.2919 29.1048 24.7864C30.2944 24.2867 31.425 23.8377 32.7028 22.9372C32.7028 22.9372 32.4877 23.3925 32.4745 23.4001C34.8719 22.6182 37.6167 22.0775 40.4373 22.1955C43.2427 22.2869 46.1201 22.9688 48.4691 24.5119C50.8752 25.97 52.5652 28.3606 53.6246 30.9689C53.8516 31.6469 54.0785 32.3249 54.2715 33.0045C54.3962 33.6879 54.6001 34.449 54.6797 35.0528C54.8203 36.1657 54.6543 37.2947 54.118 38.2656L54.1709 38.2354L54.2011 38.2884C54.5424 38.0246 55.2229 36.9369 55.3721 35.7473C55.4646 35.1686 55.434 34.5896 55.3732 34.0806C55.3273 33.5979 55.2903 33.2857 55.2903 33.2857C55.5313 33.7102 55.7664 34.1555 55.9486 34.6309C56.0816 35.0815 56.188 35.5472 56.1791 36.0258C56.182 36.9888 55.8574 37.9623 55.2989 38.7703C54.191 40.4338 52.3157 41.2704 50.6424 41.536L50.6095 41.1688C52.0421 41.0046 52.9986 39.9706 53.223 39.5627C52.2579 40.3033 50.7995 40.8856 49.2811 40.5898C48.5361 40.4515 47.7197 40.1255 47.3784 39.7405C47.0447 39.3686 46.8665 38.8385 46.8708 38.0117C46.8985 36.3298 47.86 34.2232 48.8355 32.512C49.8283 30.7383 50.9433 29.211 51.8152 27.9971C51.4767 27.9261 50.7999 29.7309 49.8072 29.5578C50.7472 28.3402 51.6439 27.0771 52.6818 26.0321C53.0988 26.4268 52.386 26.9015 52.3552 27.0943C52.8898 26.7383 55.478 24.1295 59.4933 21.2541C63.5031 18.3996 69.0286 15.4039 74.4857 13.8324C79.9467 12.2062 85.1646 12.1912 88.1909 12.4555C91.1868 12.7897 92.2788 12.6434 89.3823 11.3409L89.7669 11.1225C86.5833 10.3337 83.8919 10.0724 80.3945 9.8125C79.908 9.91315 79.8439 9.86194 79.8865 10.1534C79.7671 10.2212 79.5682 10.334 79.6283 10.4402C79.7549 11.1575 78.6865 10.9748 78.2284 11.0944C78.351 9.91998 75.6295 10.2545 72.8735 11.3625C71.487 11.8865 70.1322 12.6203 69.0219 13.1979C67.9359 13.8492 67.1077 14.3369 66.7535 14.4854C66.0124 13.6432 64.1295 15.7642 63.1568 15.8426C63.1872 15.7728 63.4117 15.3647 63.4497 15.3081C62.9108 15.193 60.0007 17.2655 57.7814 19.2266C55.5546 21.1746 53.9377 22.899 54.9247 21.1462C53.2247 22.1988 51.4934 23.5672 49.7915 25.2347C48.1027 26.8946 46.436 28.8403 45.0442 31.2087C44.369 32.3987 43.6976 33.6567 43.277 35.1406C42.8754 36.5962 42.5394 38.2601 43.0769 40.165C43.2648 40.6195 43.4204 41.11 43.6821 41.5403C43.9836 41.9478 44.2736 42.397 44.6529 42.7255C45.038 43.0331 45.4249 43.3748 45.846 43.5916C46.2598 43.7953 46.6793 43.9782 47.1119 44.1534C48.7601 44.7088 50.6331 44.7333 52.3051 44.1876C55.7004 43.155 58.0935 39.9553 58.4079 36.5849C58.4804 35.7544 58.4471 34.8615 58.3055 34.1175C58.1656 33.4076 58.0184 32.6845 57.8785 31.9745C57.6573 31.2759 57.4569 30.5828 57.2433 29.8973C56.9823 29.2211 56.6814 28.5676 56.4072 27.8989C55.1699 25.2864 53.2694 23.0503 51.087 21.43C48.9049 19.8099 46.507 18.7681 44.2577 18.0804L44.3555 18.2528C44.2347 18.1635 43.7768 18.1603 43.679 17.9879C42.7253 18.0381 41.0604 18.071 39.6751 18.2259C38.2821 18.3675 37.1464 18.5912 37.1464 18.5912L37.1105 18.5589ZM50.547 43.0983C50.547 43.0983 50.5297 43.1608 50.5507 43.1665C50.5355 43.14 49.968 43.1289 49.3872 43.1252C48.7971 43.0743 48.2184 42.9818 48.1883 42.9288L48.2858 42.5753C48.8516 42.5523 49.5324 42.6394 50.2474 42.7248C50.6105 42.7466 50.968 42.7894 51.2971 42.813C51.6319 42.8158 51.9534 42.8262 52.2278 42.8459C52.7538 42.8456 53.1037 42.875 52.9613 43.026C52.8247 43.1561 52.1654 43.4778 50.8016 43.3924C50.6366 43.5035 50.594 43.212 50.547 43.0983ZM48.7248 28.3305C48.9904 28.0569 49.2619 27.7627 49.5787 27.4249C48.4351 29.7051 46.7257 32.0082 45.4672 34.7042C44.9032 36.0592 44.4354 37.5524 44.6239 39.0589C44.6303 39.4411 44.7788 39.7953 44.9272 40.1495C45.0283 40.5131 45.2962 40.7995 45.5166 41.0953C46.0031 41.6434 46.6452 42.0331 47.3106 42.2168C47.0285 42.3067 46.6746 42.3321 46.3172 42.2895C45.9844 42.1978 45.6066 42.0263 45.2194 41.8076C44.8968 41.5172 44.5439 41.1739 44.2898 40.7569C44.1094 40.3155 43.8119 39.853 43.8 39.3686C43.4767 37.3774 44.2801 35.6412 44.7204 34.5319C45.2518 32.0379 47.2732 29.8209 48.738 28.3229L48.7248 28.3305ZM75.3293 11.3017L75.292 11.1124L75.4605 11.0693C75.4605 11.0693 75.4734 11.1848 75.4336 11.2074C75.4222 11.249 75.3634 11.2999 75.3218 11.2885L75.3293 11.3017ZM39.9067 19.252C40.2934 18.9447 41.7287 19.2176 40.7452 19.7406C40.5072 19.6301 39.8026 19.8723 39.9067 19.252ZM52.7887 24.428C52.3491 23.9935 53.6243 22.6559 54.1751 23.2553C53.7406 23.6949 53.2325 24.0358 52.7887 24.428ZM26.807 23.1792C26.6704 23.9581 26.4775 23.2785 26.1416 22.9955C26.2853 23.0016 26.7001 22.8364 26.7504 23.1412L26.807 23.1792ZM20.0624 28.3223C20.1883 28.6368 19.9807 29.1055 19.8459 29.2696C19.2644 29.5119 19.686 28.3081 20.0624 28.3223ZM12.8127 39.961C13.1396 40.0737 13.1576 40.4142 12.8019 40.4056C12.5581 40.3159 12.4933 39.8617 12.8923 39.9158C12.8923 39.9158 12.845 39.9252 12.826 39.9535L12.8127 39.961ZM59.9658 20.1089C60.1746 21.2182 58.4067 21.5025 57.8937 22.2673C57.4082 21.3502 59.1026 20.9673 59.526 20.4464C59.7175 20.3202 59.8616 20.2033 59.9658 20.1089ZM51.5342 25.7714C51.2097 26.0959 50.8889 25.8395 50.5815 25.4527C50.2554 25.0941 49.8839 24.656 49.6192 24.5607L49.8434 24.2757C50.2098 24.4886 50.5195 24.6636 50.8161 24.8461C51.0936 25.0569 51.3198 25.3318 51.5191 25.7448L51.5342 25.7714ZM48.7068 31.8834C48.8548 32.3607 48.2335 32.6255 48.0926 32.9336C47.6072 32.6655 48.3318 31.3773 48.7068 31.8834ZM49.8278 41.2441C49.8866 41.8421 49.2689 41.5263 49.0854 41.5428C49.237 41.4392 49.4801 41.1258 49.6106 41.1394C49.6996 41.1415 49.7239 41.2154 49.8278 41.2441ZM52.2354 25.9873C52.6331 26.5333 53.1404 27.0872 53.4601 27.7125L53.1417 27.8932C52.8087 27.2754 52.3316 26.7745 51.9396 26.2077L52.2221 25.9948L52.2354 25.9873ZM54.8127 32.2588L54.4625 32.3525C53.8595 31.5372 54.7063 31.1442 54.7977 32.2324L54.8127 32.2588ZM44.6137 21.8595C44.7044 21.8958 44.8517 21.97 44.9482 21.9854C46.2715 22.3392 44.0824 23.0555 44.6137 21.8595ZM37.2998 21.7663C37.1672 21.8416 36.9889 21.9602 36.8452 21.9541C35.8442 22.0136 36.8308 21.0328 37.2998 21.7663Z",
                                        fill: "#09326C"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("defs", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                    id: "clip0_608_7795",
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                        width: "112",
                        height: "112",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });


const $4366d2b05f9f8f6b$export$e52b3c28ffecde23 = ({ onClickLogIn: onClickLogIn , onClickContinue: onClickContinue  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $4366d2b05f9f8f6b$var$overlayStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $4366d2b05f9f8f6b$var$containerStyles,
            children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Stack), {
                alignInline: "center",
                alignBlock: "center",
                grow: "fill",
                xcss: $4366d2b05f9f8f6b$var$containerStackStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $4366d2b05f9f8f6b$var$logoStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0467da094044eefe$export$590b8cc7d4f1d823), {})
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Stack), {
                        alignInline: "center",
                        alignBlock: "center",
                        space: "space.200",
                        xcss: $4366d2b05f9f8f6b$var$middleStackStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4366d2b05f9f8f6b$var$communityLogoStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $7a335ab395aac0f5$export$6b53fc34987132a8), {})
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                                level: 3,
                                children: "We've launched something new"
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                children: "We’ve logged you out. Log back in to see what’s changed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Inline), {
                        space: "space.200",
                        shouldWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                                    label: "Continue without logging in",
                                    fullWidth: true,
                                    onClick: onClickContinue
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                    label: "Log back in",
                                    fullWidth: true,
                                    onClick: onClickLogIn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $4366d2b05f9f8f6b$var$overlayStyles = (0, $hgUW1$css)({
    position: "fixed",
    zIndex: (0, $hgUW1$layers).blanket(),
    inset: 0,
    backgroundColor: "white",
    overflowY: "auto",
    pointerEvents: "initial",
    fontFamily: "Charlie Display, sans-serif"
});
const $4366d2b05f9f8f6b$var$containerStackStyles = (0, $hgUW1$xcss)({
    height: "100%"
});
const $4366d2b05f9f8f6b$var$middleStackStyles = (0, $hgUW1$xcss)({
    marginBottom: "space.500"
});
const $4366d2b05f9f8f6b$var$containerStyles = (0, $hgUW1$css)({
    position: "absolute",
    width: "100%",
    marginLeft: (0, $hgUW1$token)("space.200"),
    marginRight: (0, $hgUW1$token)("space.200"),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "@media(min-width: 1280px)": {
        width: "720px",
        height: "480px"
    },
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "656px"
    }
});
const $4366d2b05f9f8f6b$var$communityLogoStyles = (0, $hgUW1$css)({
    width: "406px",
    "@media(max-width: 767px)": {
        width: "90%"
    }
});
const $4366d2b05f9f8f6b$var$logoStyles = (0, $hgUW1$css)({
    width: "112px",
    height: "112px",
    borderRadius: "50%",
    border: "1px solid black",
    marginBottom: "24px"
});
const $4366d2b05f9f8f6b$var$buttonContainerStyles = (0, $hgUW1$css)({
    "@media(max-width: 767px)": {
        width: "100%"
    }
});


var $be203e745bcefb12$exports = {};

$parcel$defineInteropFlag($be203e745bcefb12$exports);

$parcel$export($be203e745bcefb12$exports, "Error", () => $be203e745bcefb12$export$edf27be85e5f6da0);
$parcel$export($be203e745bcefb12$exports, "default", () => $be203e745bcefb12$export$2e2bcd8739ae039);





const $72560d06a87aac8e$export$87321d307719eaf2 = (props)=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        width: "96",
        height: "89",
        viewBox: "0 0 96 89",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M0.576172 88.4576L0.628536 88.5623H95.366L95.4242 88.4576L48.0002 0.8125L0.576172 88.4576Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M48.1641 32.2012V64.207",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M50.4025 74.1797C50.4316 74.0284 50.4433 73.8655 50.4433 73.6968C50.4433 73.528 50.4316 73.3593 50.4025 73.208C50.2396 72.2946 49.6054 71.736 48.7153 71.5906C48.564 71.5673 48.4069 71.5557 48.2382 71.5557C48.0694 71.5557 47.9007 71.5673 47.7436 71.5964C46.8534 71.7418 46.2251 72.3062 46.0564 73.2138C46.0273 73.3651 46.0156 73.528 46.0156 73.7026C46.0156 73.8771 46.0273 74.0342 46.0564 74.1855C46.2193 75.0931 46.8534 75.6517 47.7436 75.8029C47.9007 75.832 48.0694 75.8437 48.2382 75.8437C48.4069 75.8437 48.564 75.832 48.7153 75.8088C49.6054 75.6633 50.2396 75.0989 50.4025 74.1913V74.1797Z",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            })
        ]
    });
};



const $be203e745bcefb12$export$edf27be85e5f6da0 = ({ onClickLogout: onClickLogout , errorMessage: errorMessage  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $be203e745bcefb12$var$pageStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $be203e745bcefb12$var$containerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $72560d06a87aac8e$export$87321d307719eaf2), {}),
                /*#__PURE__*/ (0, $hgUW1$jsx)("h1", {
                    css: $be203e745bcefb12$var$headingStyles,
                    children: "Error"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $be203e745bcefb12$var$descriptionStyles,
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    label: "Log out",
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).LINK,
                    onClick: onClickLogout
                })
            ]
        })
    });
};
var $be203e745bcefb12$export$2e2bcd8739ae039 = $be203e745bcefb12$export$edf27be85e5f6da0;
const $be203e745bcefb12$var$pageStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $be203e745bcefb12$var$containerStyles = (0, $hgUW1$css)({
    maxWidth: "800px",
    minWidth: "375px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: (0, $hgUW1$token)("space.600")
});
const $be203e745bcefb12$var$headingStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.300"),
    marginBottom: (0, $hgUW1$token)("space.200"),
    fontFamily: (0, $hgUW1$token)("font.family.brand.heading"),
    fontSize: "24px",
    fontWeight: (0, $hgUW1$token)("font.weight.semibold"),
    lineHeight: "32px",
    textAlign: "center"
});
const $be203e745bcefb12$var$descriptionStyles = (0, $hgUW1$css)({
    marginBottom: (0, $hgUW1$token)("space.200"),
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "center",
    fontSize: "16px"
});


var $a0eced43682c2d75$exports = {};

$parcel$export($a0eced43682c2d75$exports, "LicenseModal", () => $a0eced43682c2d75$export$bd0c6e28f5d6b66e);









const $a0eced43682c2d75$export$bd0c6e28f5d6b66e = ({ modalTitle: modalTitle , bodyTitle: bodyTitle , bodyDescription: bodyDescription , closeModal: closeModal , licenses: licenses  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: closeModal,
        shouldScrollInViewport: false,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ModalHeader), {
                children: modalTitle && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                    level: 3,
                    fontWeight: 600,
                    children: modalTitle
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$ModalBody), {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: (0, $hgUW1$css)({
                            color: (0, $hgUW1$token)("color.icon.brand")
                        }),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianLogo), {
                            testId: "desktop"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: 4,
                            fontWeight: 500,
                            children: bodyTitle
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Text), {
                            children: bodyDescription
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: 4,
                            fontWeight: 500,
                            children: "Attributions for Open Source Libraries"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: licenses?.length && licenses.map((license)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: (0, $hgUW1$css)({
                                    padding: `${(0, $hgUW1$token)("space.100")} 0`
                                }),
                                children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Text), {
                                    children: [
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                            css: $a0eced43682c2d75$var$licenseTitleStyles,
                                            href: license.link,
                                            children: `${license.packageName} ${license.version}`
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                            css: (0, $hgUW1$css)({
                                                margin: 0
                                            }),
                                            children: license.description
                                        })
                                    ]
                                }, license.packageName)
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ModalFooter), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
};
const $a0eced43682c2d75$var$spacingContainerStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.100")} 0`
});
const $a0eced43682c2d75$var$licenseTitleStyles = (0, $hgUW1$css)({
    fontWeight: 600
});


$parcel$exportWildcard($5d4509b60606b6df$exports, $660bd1c6cb41002a$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $fec02fc26c7e145d$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $d501466973a9f0a6$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $c4979bfceee73878$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $0903e93de01b205a$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a950778dc3003c4a$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $582583ec420fce57$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a02a6f7de308273b$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $1298c86a7e6a9fc7$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $4fce8dfc4ce8f546$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $800df40a54823a3f$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $25cbe9fdb2d8d071$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $3fbcb32390ca7008$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $731a4fd527bab680$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $5cf70e33bfc6ce73$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $8b54d37779d052e8$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $9cfa05d02afa3952$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $7d458ed59bb9c6a8$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a467abe0c2c1750b$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $52124b9ae1d78e04$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $6e2eae4c8556b5b9$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $4366d2b05f9f8f6b$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $be203e745bcefb12$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a0eced43682c2d75$exports);


var $6e379ec2eca3d7d3$exports = {};
var $83fc18f8199a12ff$exports = {};

$parcel$export($83fc18f8199a12ff$exports, "AudioPlayer", () => $83fc18f8199a12ff$export$832cc5475f11d8b4);







const $83fc18f8199a12ff$export$832cc5475f11d8b4 = ({ source: source , isOpened: isOpened , onClose: onClose , onControlClick: onControlClick , onProgressUpdate: onProgressUpdate , onError: onError  })=>{
    const audioRef = (0, $hgUW1$useRef)(null);
    const focusRef = (0, $hgUW1$useRef)(null);
    const playerSource = {
        type: "audio",
        sources: [
            {
                src: source
            }
        ]
    };
    const playerOptions = {
        hideControls: true,
        controls: [
            "play",
            "progress",
            "current-time"
        ]
    };
    const addEvents = (0, $hgUW1$useCallback)((instance)=>{
        addEvent(instance, "play");
        addEvent(instance, "pause");
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onError
    ]);
    const addEvent = (0, $hgUW1$useCallback)((instance, event)=>{
        instance.on(event, ()=>onControlClick && onControlClick(event));
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2));
        });
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        const player = new (0, $hgUW1$plyrdistplyr)(audioRef.current, playerOptions);
        player.source = playerSource;
        addEvents(player);
        //To avoid: aria-label attribute is not well supported on a div with no valid role attribute.
        const plyrTimer = document.getElementsByClassName("plyr__time")[0];
        if (plyrTimer) plyrTimer.removeAttribute("aria-label");
        if (isOpened) focusRef.current?.focus();
        const plyrAudioContainer = document.getElementsByClassName("plyr--audio")[0];
        if (plyrAudioContainer) plyrAudioContainer.role = "presentation";
    }, [
        isOpened
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClose();
        }
    }, [
        onClose
    ]);
    return isOpened && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        ref: focusRef,
        tabIndex: 0,
        css: $83fc18f8199a12ff$var$audioPlayerStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("figure", {
            "data-testid": "audio-player",
            css: $83fc18f8199a12ff$var$figureStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("audio", {
                    tabIndex: 0,
                    role: "presentation",
                    ref: audioRef
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    onClick: onClose,
                    css: $83fc18f8199a12ff$var$closeIconStyles,
                    "data-testid": "close-audio",
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "cross",
                        color: (0, $hgUW1$token)("color.icon.subtle"),
                        alt: "close-audio"
                    })
                })
            ]
        })
    });
};
const $83fc18f8199a12ff$var$audioPlayerStyles = (0, $hgUW1$css)({
    borderRadius: "8px",
    maxWidth: "340px",
    padding: "24px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    ".plyr--audio": {
        width: "100%",
        "--plyr-color-main": (0, $hgUW1$B300),
        "--plyr-audio-control-color": (0, $hgUW1$N0),
        "--plyr-control-icon-size": "16px",
        "--plyr-range-thumb-height": "8px",
        "--plyr-range-track-height": "8px",
        "--plyr-range-thumb-shadow": "none",
        "--plyr-audio-progress-buffered-background": (0, $hgUW1$N60),
        "--plyr-font-family": "Charlie Text",
        "--plyr-tooltip-background": (0, $hgUW1$N500),
        "--plyr-tooltip-color": (0, $hgUW1$N0),
        "--plyr-tooltip-radius": "8px",
        "--plyr-control-spacing": "16px",
        "--plyr-range-thumb-background": (0, $hgUW1$B300)
    },
    ".plyr--audio > .plyr__controls": {
        padding: 0
    },
    ".plyr--audio > .plyr__controls > .plyr__control": {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        backgroundColor: (0, $hgUW1$token)("color.background.information.bold"),
        borderRadius: "50%"
    },
    ".plyr__progress": {
        marginRight: "16px"
    },
    ".icon--not-pressed": {
        marginRight: "-3px"
    },
    ".plyr__time": {
        fontFamily: "Inter, sans-serif",
        color: (0, $hgUW1$token)("color.text.subtlest"),
        fontSize: "14px",
        fontWeight: 600
    },
    ".plyr--audio:focus, .plyr--audio:focus-visible": {
        border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $83fc18f8199a12ff$var$figureStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
});
const $83fc18f8199a12ff$var$closeIconStyles = (0, $hgUW1$css)({
    display: "flex",
    cursor: "pointer",
    marginLeft: "4px"
});


var $389dbaf1c04dd698$exports = {};

$parcel$export($389dbaf1c04dd698$exports, "BadgeCard", () => $389dbaf1c04dd698$export$22da447a4012011);






const $389dbaf1c04dd698$export$22da447a4012011 = ({ image: image , badgeTitle: badgeTitle , earnedDate: earnedDate , link: link , onClick: onClick  })=>{
    const clickHandler = (0, $hgUW1$useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(clickHandler), []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $389dbaf1c04dd698$var$containerStyles,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "badge-card",
        children: [
            image && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                    ...image,
                    width: 64,
                    height: 64,
                    preventModal: true,
                    style: {
                        height: "64px",
                        objectFit: "contain"
                    }
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $389dbaf1c04dd698$var$contentContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $389dbaf1c04dd698$var$badgeTitleStyles,
                        children: badgeTitle
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                        css: $389dbaf1c04dd698$var$earnedDateStyles,
                        children: [
                            "Earned: ",
                            earnedDate
                        ]
                    })
                ]
            })
        ]
    });
};
const $389dbaf1c04dd698$var$containerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: (0, $hgUW1$token)("color.background.input"),
    border: `0 solid ${(0, $hgUW1$token)("color.border")}`,
    borderRadius: "4px",
    padding: "16px 12px",
    transition: "all 0.2s ease-in-out",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    }
});
const $389dbaf1c04dd698$var$contentContainerStyles = (0, $hgUW1$css)({
    marginLeft: "16px"
});
const $389dbaf1c04dd698$var$badgeTitleStyles = (0, $hgUW1$css)({
    paddingBottom: "4px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    lineHeight: "20px",
    color: (0, $hgUW1$token)("color.text"),
    wordBreak: "break-word",
    margin: 0
});
const $389dbaf1c04dd698$var$earnedDateStyles = (0, $hgUW1$css)({
    fontSize: "14px",
    lineHeight: "20px",
    color: (0, $hgUW1$token)("color.text.subtlest"),
    fontFamily: "system-ui",
    fontWeight: "normal",
    wordBreak: "break-word",
    margin: 0
});


var $c18917e553fd2737$exports = {};

$parcel$export($c18917e553fd2737$exports, "CertificateCard", () => $c18917e553fd2737$export$c572aa3e2aa38d2);






const $c18917e553fd2737$export$c572aa3e2aa38d2 = ({ image: image , backgroundColor: backgroundColor , title: title , link: link , onClick: onClick  })=>{
    const clickHandler = (0, $hgUW1$useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(clickHandler), []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        css: $c18917e553fd2737$var$containerStyles,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "certificate-card",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $c18917e553fd2737$var$cardHeaderStyles,
                    (0, $hgUW1$css)({
                        backgroundColor: backgroundColor
                    })
                ],
                "data-testid": "certificate-card-background",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $c18917e553fd2737$var$imageContainerStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                        ...image,
                        width: 112,
                        height: 112,
                        preventModal: true,
                        style: {
                            objectFit: "contain"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $c18917e553fd2737$var$cardTitleStyles,
                children: title
            })
        ]
    });
};
const $c18917e553fd2737$var$containerStyles = (0, $hgUW1$css)({
    maxWidth: "280px",
    background: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "5px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    transition: "box-shadow 0.2s ease",
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    }
});
const $c18917e553fd2737$var$cardHeaderStyles = (0, $hgUW1$css)({
    height: "66px",
    padding: "14px 16px 0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px"
});
const $c18917e553fd2737$var$imageContainerStyles = (0, $hgUW1$css)({
    height: "112px",
    width: "112px"
});
const $c18917e553fd2737$var$cardTitleStyles = (0, $hgUW1$css)({
    padding: "0 16px 24px",
    marginTop: "76px",
    color: "N800",
    lineHeight: "20px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    wordBreak: "break-word"
});


var $3ca3d702a74367ba$exports = {};

$parcel$export($3ca3d702a74367ba$exports, "ContentOverviewCardState", () => $3ca3d702a74367ba$export$84c408eab3fc01b3);
$parcel$export($3ca3d702a74367ba$exports, "ContentOverviewCard", () => $3ca3d702a74367ba$export$cb86f63bb5e77777);







var $ed20910b93d89c3f$exports = {};

$parcel$export($ed20910b93d89c3f$exports, "ContentType", () => $ed20910b93d89c3f$export$e2e108cbe2e4f865);
let $ed20910b93d89c3f$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["LEARNING_PATH"] = "LEARNING_PATH";
    ContentType["COURSE"] = "COURSE";
    ContentType["LESSON"] = "LESSON";
})($ed20910b93d89c3f$export$e2e108cbe2e4f865 || ($ed20910b93d89c3f$export$e2e108cbe2e4f865 = {}));


let $3ca3d702a74367ba$export$84c408eab3fc01b3;
(function(ContentOverviewCardState) {
    ContentOverviewCardState["LOADING"] = "loading";
    ContentOverviewCardState["DEFAULT"] = "default";
    ContentOverviewCardState["IN_PROGRESS"] = "in_progress";
    ContentOverviewCardState["FINISHED"] = "finished";
})($3ca3d702a74367ba$export$84c408eab3fc01b3 || ($3ca3d702a74367ba$export$84c408eab3fc01b3 = {}));
const $3ca3d702a74367ba$export$cb86f63bb5e77777 = ({ inspectMode: inspectMode , state: state = $3ca3d702a74367ba$export$84c408eab3fc01b3.DEFAULT , heading: heading , subheading: subheading , tags: tags = [] , collapsedSectionItems: itemsSectionCollapsed = [] , collapsedSectionContent: infoSectionCollapsed = "" , collapsedSectionTitle: titleSectionCollapsed , contentType: contentType , onClickButton: onClickButton  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const handleClickButton = (0, $hgUW1$useCallback)(()=>{
        if (onClickButton) onClickButton();
    }, [
        onClickButton
    ]);
    const handleToggleVisibility = (0, $hgUW1$useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("article", {
        "aria-label": heading,
        css: [
            $3ca3d702a74367ba$var$articleContainerStyles,
            state === $3ca3d702a74367ba$export$84c408eab3fc01b3.FINISHED && (0, $hgUW1$css)({
                borderLeftColor: (0, $hgUW1$token)("color.border.success")
            })
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $3ca3d702a74367ba$var$containerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                        "data-testid": "toggle-visibility",
                        "aria-label": isOpen ? "collapse" : "expand",
                        onClick: handleToggleVisibility,
                        css: $3ca3d702a74367ba$var$buttonStyles,
                        children: isOpen ? /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                type: "chevron-down"
                            })
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                type: "chevron-right"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $3ca3d702a74367ba$var$gridContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3ca3d702a74367ba$var$gridItemStyles,
                                children: [
                                    tags.length > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $3ca3d702a74367ba$var$tagContainerStyles,
                                        children: tags?.map((tag, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $3ca3d702a74367ba$var$tagStyles,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                                    inspectMode: tag.inspectMode && {
                                                        tag: tag.inspectMode.duration
                                                    },
                                                    label: tag.label
                                                })
                                            }, `tag-${index}`))
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                                        css: $3ca3d702a74367ba$var$titleContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                                            level: 5,
                                            children: heading
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("description", inspectMode),
                                        css: $3ca3d702a74367ba$var$descriptionStyles,
                                        children: subheading
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3ca3d702a74367ba$var$gridSideItemStyles,
                                children: [
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.LOADING && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "",
                                        isLoading: true
                                    }),
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.DEFAULT && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Get Started",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: handleClickButton
                                    }),
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.IN_PROGRESS && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Continue",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                                        onClick: handleClickButton
                                    }),
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.FINISHED && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $3ca3d702a74367ba$var$finishedStateContainerStyles,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: (0, $hgUW1$css)({
                                                    marginRight: (0, $hgUW1$token)("space.100")
                                                }),
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                                                    link: "#",
                                                    label: `Review ${(0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE === contentType ? "lesson" : "course"}`,
                                                    onClick: handleClickButton
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                type: "check-circle",
                                                color: (0, $hgUW1$token)("color.icon.success")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": "section-expanded",
                css: [
                    $3ca3d702a74367ba$var$sectionExpandedStyles,
                    (0, $hgUW1$css)({
                        display: isOpen ? "block" : "none"
                    })
                ],
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $3ca3d702a74367ba$var$sectionContentStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                            color: (0, $hgUW1$token)("color.border"),
                            height: 1
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("sectionList", inspectMode),
                        css: $3ca3d702a74367ba$var$sectionListStyles,
                        children: [
                            titleSectionCollapsed && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $3ca3d702a74367ba$var$sectionTitleStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                                    level: 6,
                                    children: titleSectionCollapsed
                                })
                            }),
                            itemsSectionCollapsed.length > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                                css: $3ca3d702a74367ba$var$listStyles,
                                "aria-label": "collapsed section items",
                                children: itemsSectionCollapsed?.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                                        css: $3ca3d702a74367ba$var$itemStyles,
                                        children: item
                                    }, `item-${index}`))
                            }),
                            infoSectionCollapsed && infoSectionCollapsed
                        ]
                    })
                ]
            })
        ]
    });
};
const $3ca3d702a74367ba$var$articleContainerStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderLeft: `8px solid ${(0, $hgUW1$token)("color.border.brand")}`,
    borderRadius: "8px",
    padding: "16px 24px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised")
});
const $3ca3d702a74367ba$var$containerStyles = (0, $hgUW1$css)({
    padding: "16px 0",
    display: "flex",
    alignItems: "flex-start"
});
const $3ca3d702a74367ba$var$buttonStyles = (0, $hgUW1$css)({
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer"
});
const $3ca3d702a74367ba$var$buttonIconSpanStyles = (0, $hgUW1$css)({
    marginRight: "16px"
});
const $3ca3d702a74367ba$var$gridContainerStyles = (0, $hgUW1$css)({
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    [(0, $hgUW1$media).above.sm]: {
        columnGap: "16px",
        alignItems: "center"
    }
});
const $3ca3d702a74367ba$var$gridItemStyles = (0, $hgUW1$css)({
    gridColumn: "span 12",
    color: (0, $hgUW1$token)("color.text"),
    [(0, $hgUW1$media).above.sm]: {
        gridColumn: "span 9",
        color: (0, $hgUW1$token)("color.text")
    }
});
const $3ca3d702a74367ba$var$tagContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexWrap: "wrap"
});
const $3ca3d702a74367ba$var$tagStyles = (0, $hgUW1$css)({
    marginRight: "12px",
    "&:last-of-type": {
        marginRight: 0
    }
});
const $3ca3d702a74367ba$var$titleContainerStyles = (0, $hgUW1$css)({
    margin: "16px auto",
    [(0, $hgUW1$media).above.sm]: {
        marginRight: "1px"
    }
});
const $3ca3d702a74367ba$var$descriptionStyles = (0, $hgUW1$css)({
    display: "none",
    fontSize: "16px",
    margin: 0,
    color: (0, $hgUW1$token)("color.text"),
    [(0, $hgUW1$media).above.sm]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5",
        color: (0, $hgUW1$token)("color.text")
    }
});
const $3ca3d702a74367ba$var$gridSideItemStyles = (0, $hgUW1$css)({
    gridColumn: "span 12",
    [(0, $hgUW1$media).above.sm]: {
        gridColumn: "span 3",
        justifySelf: "end"
    }
});
const $3ca3d702a74367ba$var$finishedStateContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    marginRight: "4px"
});
const $3ca3d702a74367ba$var$sectionExpandedStyles = (0, $hgUW1$css)({
    overflow: "hidden",
    transition: "ease-in-out 1000ms",
    paddingLeft: "40px"
});
const $3ca3d702a74367ba$var$sectionContentStyles = (0, $hgUW1$css)({
    margin: "8px 0"
});
const $3ca3d702a74367ba$var$sectionListStyles = (0, $hgUW1$css)({
    padding: "24px 0"
});
const $3ca3d702a74367ba$var$sectionTitleStyles = (0, $hgUW1$css)({
    marginBottom: "8px",
    textTransform: "uppercase"
});
const $3ca3d702a74367ba$var$listStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontSize: "14px",
    lineHeight: "20px",
    listStyleType: "disc",
    listStylePosition: "inside",
    paddingLeft: "4px",
    marginTop: 0,
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "16px",
        lineHeight: "1.714"
    }
});
const $3ca3d702a74367ba$var$itemStyles = (0, $hgUW1$css)({
    marginTop: 0,
    marginLeft: "20px",
    textIndent: "-20px"
});


var $e018ab7ed2648ae8$exports = {};

$parcel$export($e018ab7ed2648ae8$exports, "EmptyState", () => $e018ab7ed2648ae8$export$fddf379e22a74b00);







const $e018ab7ed2648ae8$export$fddf379e22a74b00 = ({ image: image , description: description , redirectLink: redirectLink  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        css: $e018ab7ed2648ae8$var$containerStyles,
        "data-testid": "empty-state",
        children: [
            image && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $e018ab7ed2648ae8$var$imageContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                    src: image.src,
                    alt: image.alt,
                    preventModal: true,
                    height: 96
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $e018ab7ed2648ae8$var$descriptionContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $e018ab7ed2648ae8$var$descriptionStyles,
                        children: description
                    }),
                    redirectLink && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                        label: redirectLink.label,
                        link: redirectLink.link,
                        style: (0, $4fce8dfc4ce8f546$export$2b77966d73aefa77).SEMIBOLD,
                        fontColor: (0, $hgUW1$token)("color.link"),
                        css: (0, $hgUW1$css)({
                            fontFamily: "system-ui"
                        })
                    })
                ]
            })
        ]
    });
const $e018ab7ed2648ae8$var$containerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    padding: "24px",
    border: "1px dashed",
    borderColor: (0, $hgUW1$N70),
    borderRadius: "4px",
    alignItems: "center"
});
const $e018ab7ed2648ae8$var$imageContainerStyles = (0, $hgUW1$css)({
    width: "64px",
    [(0, $hgUW1$media).above.sm]: {
        width: "96px"
    }
});
const $e018ab7ed2648ae8$var$descriptionContainerStyles = (0, $hgUW1$css)({
    marginLeft: "16px",
    lineHeight: "23px"
});
const $e018ab7ed2648ae8$var$descriptionStyles = (0, $hgUW1$css)({
    paddingBottom: "2px",
    margin: 0,
    fontFamily: "system-ui",
    fontSize: "16px",
    color: (0, $hgUW1$token)("color.text"),
    fontWeight: "normal",
    wordBreak: "break-word",
    lineHeight: 1.714
});


var $81dd635d83decaee$exports = {};

$parcel$export($81dd635d83decaee$exports, "InlineFeedbackMessageAppearance", () => $81dd635d83decaee$export$f9292ef28b7b429a);
$parcel$export($81dd635d83decaee$exports, "InlineFeedbackMessage", () => $81dd635d83decaee$export$f23c56ac9ab316f);






let $81dd635d83decaee$export$f9292ef28b7b429a;
(function(InlineFeedbackMessageAppearance) {
    InlineFeedbackMessageAppearance["INCORRECT"] = "INCORRECT";
    InlineFeedbackMessageAppearance["CORRECT"] = "CORRECT";
})($81dd635d83decaee$export$f9292ef28b7b429a || ($81dd635d83decaee$export$f9292ef28b7b429a = {}));
const $81dd635d83decaee$export$f23c56ac9ab316f = ({ title: title , description: description , appearance: appearance = $81dd635d83decaee$export$f9292ef28b7b429a.CORRECT  })=>{
    const isIncorrectAppearance = appearance === $81dd635d83decaee$export$f9292ef28b7b429a.INCORRECT;
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $81dd635d83decaee$var$feedbackMessageContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $81dd635d83decaee$var$feedbackMessageLeftBorderStyles,
                    (0, $hgUW1$css)({
                        backgroundColor: `${isIncorrectAppearance ? (0, $hgUW1$token)("color.border.danger") : (0, $hgUW1$token)("color.border.success")}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": `feedback-message-${appearance}`,
                css: $81dd635d83decaee$var$feedbackMessageContentContainerStyles,
                children: [
                    isIncorrectAppearance ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "error",
                        color: (0, $hgUW1$token)("color.border.danger")
                    }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "check-circle",
                        color: (0, $hgUW1$token)("color.border.success")
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $81dd635d83decaee$var$feedbackMessageContentStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: $81dd635d83decaee$var$feedbackMessageTitleStyles,
                                children: title
                            }),
                            description && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: $81dd635d83decaee$var$feedbackMessageDescriptionStyles,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $81dd635d83decaee$var$feedbackMessageContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    backgroundColor: (0, $hgUW1$token)("color.background.input")
});
const $81dd635d83decaee$var$feedbackMessageContentContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    padding: "24px 24px 24px 16px",
    display: "flex",
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    borderRadius: "0 3px 3px 0",
    borderLeft: "none",
    [(0, $hgUW1$media).below.xs]: {
        padding: "16px 16px 16px 8px"
    }
});
const $81dd635d83decaee$var$feedbackMessageLeftBorderStyles = (0, $hgUW1$css)({
    maxHeight: "100%",
    width: "8px",
    borderRadius: "3px 0 0 3px"
});
const $81dd635d83decaee$var$feedbackMessageContentStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    [(0, $hgUW1$media).below.xs]: {
        marginLeft: "8px"
    }
});
const $81dd635d83decaee$var$feedbackMessageTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text"),
    margin: 0,
    [(0, $hgUW1$media).below.xs]: {
        fontSize: "16px"
    }
});
const $81dd635d83decaee$var$feedbackMessageDescriptionStyles = (0, $hgUW1$css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    marginBottom: 0,
    p: {
        margin: 0
    },
    [(0, $hgUW1$media).below.xs]: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});


var $8d99d7c025746ac9$exports = {};

$parcel$export($8d99d7c025746ac9$exports, "LearningContentCard", () => $8d99d7c025746ac9$export$c01be50dd5c433fe);






var $2cfa64583f556289$exports = {};

$parcel$export($2cfa64583f556289$exports, "PopupShare", () => $2cfa64583f556289$export$477c64ffaba52edf);






const $2cfa64583f556289$export$477c64ffaba52edf = ({ showCopyLink: showCopyLink = true , shareOnFb: shareOnFb = true , shareOnLinkedin: shareOnLinkedin = true , shareOnPdf: shareOnPdf = false , onGeneratePdf: onGeneratePdf , backgroundColor: backgroundColor = "#FFFFFF" , urlToShare: urlToShare , alignToLeft: alignToLeft = false  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const [isCopied, setIsCopied] = (0, $hgUW1$useState)(false);
    const dropdownRef = (0, $hgUW1$useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleOnGeneratePDF = (event)=>{
        if (onGeneratePdf) {
            event.stopPropagation();
            event.preventDefault();
            onGeneratePdf();
            setIsOpen(!isOpen);
        }
    };
    const handleShare = (url)=>{
        window.open(url, "_blank");
    };
    const shareOnFacebook = ()=>{
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
        handleShare(facebookUrl);
    };
    const shareOnLinkedIn = ()=>{
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}`;
        handleShare(linkedinUrl);
    };
    const copyToClipboard = (0, $hgUW1$useCallback)(()=>{
        navigator.clipboard.writeText(urlToShare).then(()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        });
    }, [
        urlToShare
    ]);
    const onKeyDownLinkedIn = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(shareOnLinkedIn), []);
    const onKeyDownFacebook = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(shareOnFacebook), []);
    const onKeyDownGeneratePdf = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(()=>{
        if (onGeneratePdf) onGeneratePdf();
    }), [
        onGeneratePdf
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: (0, $hgUW1$css)({
            width: "fit-content",
            position: "relative"
        }),
        "data-testid": "popup-share",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                label: "Share",
                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "share"
                }),
                iconType: "share"
            }),
            isOpen && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": "popup-share-dropdown",
                css: [
                    $2cfa64583f556289$var$popupShareDropdownStyles,
                    [
                        alignToLeft && (0, $hgUW1$css)({
                            width: "176px",
                            right: 0
                        }),
                        shareOnPdf && (0, $hgUW1$css)({
                            width: "220px"
                        })
                    ]
                ],
                style: {
                    backgroundColor: backgroundColor
                },
                children: [
                    showCopyLink && /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                        onClick: copyToClipboard,
                        css: $2cfa64583f556289$var$copyToClipboardOptionStyles,
                        "aria-label": "copy to clipboard",
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                type: "link",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontFamily: "Charlie Text, sans-serif",
                                    color: (0, $hgUW1$token)("color.text")
                                }),
                                children: "Copy Link"
                            }),
                            isCopied && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $2cfa64583f556289$var$isCopiedStyles,
                                children: "Copied!"
                            })
                        ]
                    }),
                    shareOnLinkedin && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        tabIndex: 0,
                        css: $2cfa64583f556289$var$shareOnLinkedInOptionStyles,
                        onClick: shareOnLinkedIn,
                        onKeyDown: onKeyDownLinkedIn,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                    id: "g5891",
                                    children: [
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                            d: "M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z",
                                            id: "background",
                                            style: {
                                                fill: "#2867b2"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                            id: "shapes",
                                            children: [
                                                /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                                                    height: "257.962",
                                                    id: "rect11",
                                                    style: {
                                                        fill: "#fff"
                                                    },
                                                    width: "85.76",
                                                    x: "61.053",
                                                    y: "178.667"
                                                }),
                                                /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                    d: "M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z",
                                                    id: "path13-0",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                    d: "M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z",
                                                    id: "path15",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Linkedin"
                            })
                        ]
                    }),
                    shareOnFb && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        tabIndex: 0,
                        css: $2cfa64583f556289$var$shareOnFacebookOptionStyles,
                        onClick: shareOnFacebook,
                        onKeyDown: onKeyDownFacebook,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                    children: [
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                            d: "M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z",
                                            fill: "#1877f2",
                                            fillRule: "nonzero"
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                            d: "M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z",
                                            fill: "#fff",
                                            fillRule: "nonzero"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Facebook"
                            })
                        ]
                    }),
                    shareOnPdf && onGeneratePdf && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        tabIndex: 0,
                        css: $2cfa64583f556289$var$shareOnPdfOptionStyles,
                        onClick: handleOnGeneratePDF,
                        onKeyDown: onKeyDownGeneratePdf,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $2cfa64583f556289$var$shareOnPdfTextStyles,
                            children: "Export to PDF"
                        })
                    })
                ]
            })
        ]
    });
};
const $2cfa64583f556289$var$popupShareDropdownStyles = (0, $hgUW1$css)({
    position: "absolute",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    zIndex: 2,
    color: (0, $hgUW1$token)("color.text"),
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
});
const $2cfa64583f556289$var$copyToClipboardOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$isCopiedStyles = (0, $hgUW1$css)({
    position: "absolute",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtle.pressed"),
    color: (0, $hgUW1$token)("color.text"),
    fontSize: "0.688rem",
    lineHeight: "0.875rem",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginTop: "0.25rem",
    right: "1rem"
});
const $2cfa64583f556289$var$shareOnLinkedInOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$shareOnFacebookOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$shareOnPdfOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} 24px`,
    gap: "8px",
    width: "220px",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$shareOnPdfTextStyles = (0, $hgUW1$css)({
    fontSize: "16px",
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: "400"
});


var $d8ee29df49af8811$exports = {};

$parcel$export($d8ee29df49af8811$exports, "LearningProgressBar", () => $d8ee29df49af8811$export$184a993f673fc83f);








const $d8ee29df49af8811$export$184a993f673fc83f = ({ completedResources: completedResources , resourceCount: resourceCount , completionDate: completionDate , contentType: contentType  })=>{
    const getProgressText = ()=>{
        switch(contentType){
            case (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE:
                return `${completedResources} of ${resourceCount} lessons`;
            case (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).LEARNING_PATH:
                return `${completedResources} of ${resourceCount} courses`;
            default:
                return `${Math.round((0, $fde9406d76ec24a9$export$6e67b290ed5690f6)(completedResources, resourceCount))}%`;
        }
    };
    if (completedResources === resourceCount) return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $d8ee29df49af8811$var$progressBarStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "gap-completed"
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                css: [
                    $d8ee29df49af8811$var$progressTitleStyles,
                    (0, $hgUW1$css)({
                        color: (0, $hgUW1$token)("color.text.success")
                    })
                ],
                children: [
                    "Completed ",
                    completionDate
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $d8ee29df49af8811$var$progressBarStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$CircularProgressbarWithChildren), {
                    strokeWidth: 10,
                    value: (0, $fde9406d76ec24a9$export$6e67b290ed5690f6)(completedResources, resourceCount),
                    styles: (0, $hgUW1$buildStyles)({
                        pathColor: completedResources === 0 ? (0, $hgUW1$token)("color.border") : (0, $hgUW1$token)("color.text.success")
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                css: $d8ee29df49af8811$var$progressTitleStyles,
                children: getProgressText()
            })
        ]
    });
};
const $d8ee29df49af8811$var$progressBarContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $hgUW1$token)("space.100")
});
const $d8ee29df49af8811$var$progressBarStyles = (0, $hgUW1$css)({
    display: "flex",
    maxWidth: "20px",
    width: "100%"
});
const $d8ee29df49af8811$var$progressTitleStyles = (0, $hgUW1$css)({
    marginTop: 0,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    color: (0, $hgUW1$token)("color.text.subtle")
});







const $94fa590b0c9d9421$export$64ef9b8c11710c47 = ({ title: title , description: description , isLearningProgress: isLearningProgress , inspectMode: inspectMode  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "card-content",
        css: $94fa590b0c9d9421$var$titleAndDetailsContainerStyles,
        children: [
            isLearningProgress ? /*#__PURE__*/ (0, $hgUW1$jsx)("h4", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                css: $94fa590b0c9d9421$var$withProgressTitleStyles,
                children: title
            }) : /*#__PURE__*/ (0, $hgUW1$jsx)("h5", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                css: $94fa590b0c9d9421$var$catalogTitleStyles,
                children: title
            }),
            description && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                "data-testid": "description",
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("description", inspectMode),
                css: $94fa590b0c9d9421$var$descriptionStyles,
                children: description
            })
        ]
    });
const $94fa590b0c9d9421$var$titleAndDetailsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.300")}`
});
const $94fa590b0c9d9421$var$baseTitleStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    color: (0, $hgUW1$token)("color.text")
});
const $94fa590b0c9d9421$var$learningProgressTitleStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginTop: "20px !important",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    height: "64px"
});
const $94fa590b0c9d9421$var$withProgressTitleStyles = (0, $hgUW1$css)([
    $94fa590b0c9d9421$var$learningProgressTitleStyles,
    {
        fontSize: "24px",
        lineHeight: "32px",
        marginTop: "0 !important"
    }
]);
const $94fa590b0c9d9421$var$catalogTitleStyles = (0, $hgUW1$css)([
    $94fa590b0c9d9421$var$baseTitleStyles,
    {
        fontSize: "20px",
        lineHeight: "28px",
        marginTop: `${(0, $hgUW1$token)("space.150")} !important`
    }
]);
const $94fa590b0c9d9421$var$descriptionStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    marginTop: (0, $hgUW1$token)("space.250"),
    marginBottom: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text.subtle")
});






const $70542fe329d53412$export$ce572121d239fe86 = 4;
const $70542fe329d53412$export$3b38c99bd0870716 = 290;
const $70542fe329d53412$export$bb4069a5b1582edc = 24;
const $70542fe329d53412$export$9c6eb1f46b993412 = 3;


const $fb345954107134f9$export$331084b24da1eef5 = ({ tags: tags , lastLabelWidth: lastLabelWidth  })=>tags.length > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $fb345954107134f9$var$labelContainerStyles,
        id: "tabs-container",
        children: tags.slice(0, (0, $70542fe329d53412$export$9c6eb1f46b993412)).map((tag, index, arr)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: index === arr.length - 1 && (0, $hgUW1$css)([
                    {
                        "& > div": {
                            width: lastLabelWidth
                        }
                    },
                    $fb345954107134f9$var$truncatedLabelStyles
                ]),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                    ...tag
                })
            }, tag.label + index))
    });
const $fb345954107134f9$var$labelContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${(0, $70542fe329d53412$export$ce572121d239fe86)}px`,
    padding: `0 ${(0, $70542fe329d53412$export$bb4069a5b1582edc)}px`,
    overflow: "hidden"
});
const $fb345954107134f9$var$truncatedLabelStyles = (0, $hgUW1$css)({
    "& > div": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});






const $f73a4551a9d8a3b1$export$8a8c015277a3d77a = ({ imageUrl: imageUrl , backgroundColor: backgroundColor , productIcon: productIcon , isLearningProgress: isLearningProgress  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $f73a4551a9d8a3b1$var$imageBaseStyles,
            !imageUrl && $f73a4551a9d8a3b1$var$noImageStyles,
            (0, $hgUW1$css)({
                backgroundColor: backgroundColor
            }, isLearningProgress && {
                height: "96px"
            }, !isLearningProgress && {
                height: "80px"
            })
        ],
        style: {
            backgroundImage: `url(${imageUrl})`
        },
        "data-testid": "card-image",
        children: productIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
            css: (0, $hgUW1$css)({
                marginLeft: "26px"
            }),
            src: productIcon,
            alt: "product icon"
        })
    });
const $f73a4551a9d8a3b1$var$imageBaseStyles = (0, $hgUW1$css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
});
const $f73a4551a9d8a3b1$var$noImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
});




const $8d99d7c025746ac9$export$c01be50dd5c433fe = ({ inspectMode: inspectMode , title: title , description: description , onClick: onClick , target: target , link: link , tags: tags , minHeight: minHeight = 248 , isLoading: isLoading = false , learningProgress: learningProgress , onGeneratePdf: onGeneratePdf , shouldDisplayShareButton: shouldDisplayShareButton = false , shouldDisplayBookmark: shouldDisplayBookmark = false , productIcon: productIcon , imageUrl: imageUrl , backgroundColor: backgroundColor  })=>{
    const cardRef = (0, $hgUW1$useRef)(null);
    const [lastLabelWidth, setLastLabelWidth] = (0, $hgUW1$useState)("auto");
    const clickHandler = (0, $hgUW1$useCallback)(()=>{
        onClick && onClick();
    }, [
        link,
        target,
        onClick
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(clickHandler), [
        clickHandler
    ]);
    const handleOnSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    (0, $hgUW1$useEffect)(()=>{
        // truncating the last label if it doesn't fit in the card
        if (tags.length && cardRef.current) {
            const card = cardRef.current;
            const tagsContainer = card.querySelector("#tabs-container");
            const maxTagsContainerWidth = (card?.offsetWidth || (0, $70542fe329d53412$export$3b38c99bd0870716)) - (0, $70542fe329d53412$export$bb4069a5b1582edc) * 2;
            let firstTagsWidth = 0;
            let totalTagsWidth = 0;
            if (tagsContainer) {
                Array.from(tagsContainer.children).slice(0, (0, $70542fe329d53412$export$9c6eb1f46b993412)).forEach((tag, i, arr)=>{
                    if (i < arr.length - 1) firstTagsWidth += tag.clientWidth + (0, $70542fe329d53412$export$ce572121d239fe86);
                    totalTagsWidth += tag.clientWidth;
                });
                const shouldTruncate = totalTagsWidth + ((0, $70542fe329d53412$export$ce572121d239fe86) * tagsContainer.children.length - 1) + (0, $70542fe329d53412$export$bb4069a5b1582edc) * 2 > card?.offsetWidth;
                if (shouldTruncate) setLastLabelWidth(maxTagsContainerWidth - firstTagsWidth - 2);
            }
        }
    }, [
        cardRef.current
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $8d99d7c025746ac9$var$learningContentCardContainerStyles,
            $8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles
        ],
        "data-testid": "loading-learning-content-card",
        style: {
            minHeight: `${minHeight}px`
        },
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $8d99d7c025746ac9$var$imageBaseStyles,
                    $8d99d7c025746ac9$var$noImageStyles
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $8d99d7c025746ac9$var$bodyContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $8d99d7c025746ac9$var$labelContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $8d99d7c025746ac9$var$smallPillStyles
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: [
                                        $8d99d7c025746ac9$var$smallPillStyles,
                                        (0, $hgUW1$css)({
                                            marginLeft: "24px"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $8d99d7c025746ac9$var$titleAndDetailsContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: (0, $hgUW1$css)({
                                marginTop: "12px"
                            }),
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: [
                                        $8d99d7c025746ac9$var$bigPillStyles,
                                        (0, $hgUW1$css)({
                                            width: "212px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $8d99d7c025746ac9$var$bigPillStyles
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        css: $8d99d7c025746ac9$var$linkContainerStyles,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            ref: cardRef,
            role: "link",
            css: $8d99d7c025746ac9$var$learningContentCardContainerStyles,
            onClick: clickHandler,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "data-testid": "learning-content-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $f73a4551a9d8a3b1$export$8a8c015277a3d77a), {
                    imageUrl: imageUrl,
                    backgroundColor: backgroundColor,
                    productIcon: productIcon,
                    isLearningProgress: !!learningProgress
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: [
                        $8d99d7c025746ac9$var$bodyContainerStyles,
                        learningProgress && $8d99d7c025746ac9$var$progressBodyContainerStyles
                    ],
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fb345954107134f9$export$331084b24da1eef5), {
                            tags: tags,
                            lastLabelWidth: lastLabelWidth
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $94fa590b0c9d9421$export$64ef9b8c11710c47), {
                            title: title,
                            description: description,
                            inspectMode: inspectMode,
                            isLearningProgress: !!learningProgress
                        }),
                        learningProgress && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $8d99d7c025746ac9$var$learningContentCardProgressContainerStyles,
                            "data-testid": "learning-progress-content",
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d8ee29df49af8811$export$184a993f673fc83f), {
                                        completedResources: learningProgress.completedResources,
                                        resourceCount: learningProgress.resourceCount,
                                        completionDate: learningProgress.completionDate,
                                        contentType: (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).LEARNING_PATH
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $8d99d7c025746ac9$var$learningContentCardIconsContainerStyles,
                                        children: [
                                            shouldDisplayShareButton && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                                urlToShare: link,
                                                alignToLeft: true,
                                                shareOnFb: false,
                                                shareOnLinkedin: false,
                                                showCopyLink: false,
                                                shareOnPdf: true,
                                                onGeneratePdf: onGeneratePdf
                                            }),
                                            shouldDisplayBookmark && /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                "data-testid": "save-content",
                                                css: $8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles,
                                                onClick: handleOnSave,
                                                children: learningProgress.isSaved ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "bookmark-filled"
                                                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "bookmark"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $8d99d7c025746ac9$var$imageBaseStyles = (0, $hgUW1$css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "80px"
});
const $8d99d7c025746ac9$var$noImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
});
const $8d99d7c025746ac9$var$bodyContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: `${(0, $70542fe329d53412$export$bb4069a5b1582edc)}px 0 0`
});
const $8d99d7c025746ac9$var$progressBodyContainerStyles = (0, $hgUW1$css)({
    padding: `21px 0 0`
});
const $8d99d7c025746ac9$var$labelContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${(0, $70542fe329d53412$export$ce572121d239fe86)}px`,
    padding: `0 ${(0, $70542fe329d53412$export$bb4069a5b1582edc)}px`,
    overflow: "hidden"
});
const $8d99d7c025746ac9$var$linkContainerStyles = (0, $hgUW1$css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $8d99d7c025746ac9$var$titleAndDetailsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.300")}`
});
const $8d99d7c025746ac9$var$learningContentCardProgressContainerStyles = (0, $hgUW1$css)({
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `18px ${(0, $hgUW1$token)("space.300")}`
});
const $8d99d7c025746ac9$var$learningContentCardIconsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: (0, $hgUW1$token)("space.300")
});
const $8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles = (0, $hgUW1$css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $8d99d7c025746ac9$var$learningContentCardContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    minWidth: `${(0, $70542fe329d53412$export$3b38c99bd0870716)}px`,
    "&:hover": {
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`,
        border: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`
    }
});
const $8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles = (0, $hgUW1$css)({
    boxShadow: "none",
    border: `1px solid ${(0, $hgUW1$token)("color.background.disabled")}`,
    cursor: "initial",
    "&:hover": {
        boxShadow: "none"
    },
    "&:active": {
        outline: "none",
        border: `1px solid ${(0, $hgUW1$token)("color.background.disabled")}`
    }
});
const $8d99d7c025746ac9$var$smallPillStyles = (0, $hgUW1$css)({
    width: "52px",
    height: "10.5px",
    backgroundColor: (0, $hgUW1$token)("color.background.neutral"),
    borderRadius: "15px",
    marginLeft: (0, $hgUW1$token)("space.100"),
    display: "inline-block"
});
const $8d99d7c025746ac9$var$bigPillStyles = (0, $hgUW1$css)({
    maxWidth: "227px",
    height: "17.5px",
    backgroundColor: (0, $hgUW1$token)("color.background.neutral"),
    borderRadius: "25px",
    marginTop: (0, $hgUW1$token)("space.100")
});


var $1f7c4876f10b107b$exports = {};

$parcel$export($1f7c4876f10b107b$exports, "Modal", () => $1f7c4876f10b107b$export$2b77a92f1a5ad772);







let $1f7c4876f10b107b$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($1f7c4876f10b107b$var$DialogWidth || ($1f7c4876f10b107b$var$DialogWidth = {}));
const $1f7c4876f10b107b$export$2b77a92f1a5ad772 = ({ closeModal: closeModal , width: width = $1f7c4876f10b107b$var$DialogWidth.LARGE , imageLink: imageLink , actionButton: actionButton , heading: heading , subheading: subheading , surveyText: surveyText  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: closeModal,
        width: width,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $1f7c4876f10b107b$var$modalContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    css: $1f7c4876f10b107b$var$modalCloseButtonStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                        label: "close modal button",
                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "cross"
                        }),
                        onClick: closeModal
                    })
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $1f7c4876f10b107b$var$modalBodyStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $1f7c4876f10b107b$var$modalImageContainerStyles,
                            children: imageLink && /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                                src: imageLink,
                                alt: "modal-image",
                                width: 120,
                                height: 120,
                                css: $1f7c4876f10b107b$var$imageStyles
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            "data-testid": "modal-heading",
                            css: $1f7c4876f10b107b$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            "data-testid": "modal-subheading",
                            css: $1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                            children: subheading
                        }),
                        surveyText && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            "data-testid": "modal-survey-text",
                            css: [
                                $1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                                $1f7c4876f10b107b$var$surveyTextStyles
                            ],
                            children: surveyText
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $1f7c4876f10b107b$var$modalActionButtonContainerStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                size: (0, $fec02fc26c7e145d$export$5dd2748b7940a2a0).LARGE,
                                onClick: actionButton.onClick,
                                label: actionButton.label,
                                iconBefore: actionButton.iconBefore,
                                iconAfter: actionButton.iconAfter
                            })
                        })
                    ]
                })
            ]
        })
    });
const $1f7c4876f10b107b$var$imageStyles = (0, $hgUW1$css)({
    borderRadius: "50%"
});
const $1f7c4876f10b107b$var$modalContainerStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.400")} ${(0, $hgUW1$token)("space.500")}`,
    [(0, $hgUW1$media1).below.sm]: {
        padding: "16px"
    }
});
const $1f7c4876f10b107b$var$modalCloseButtonStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    [(0, $hgUW1$media1).below.sm]: {
        padding: "8px"
    }
});
const $1f7c4876f10b107b$var$modalImageContainerStyles = (0, $hgUW1$css)({
    marginBottom: "24px",
    [(0, $hgUW1$media1).below.sm]: {
        marginBottom: "16px"
    }
});
const $1f7c4876f10b107b$var$modalBodyStyles = (0, $hgUW1$css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${(0, $hgUW1$token)("space.200")} auto 0`,
    [(0, $hgUW1$media1).below.sm]: {
        marginTop: 0
    }
});
const $1f7c4876f10b107b$var$modalHeadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    marginTop: 0,
    marginBottom: "24px",
    textAlign: "center",
    [(0, $hgUW1$media1).below.sm]: {
        marginTop: 0,
        marginBottom: "16px",
        fontSize: "24px",
        lineHeight: "32px"
    }
});
const $1f7c4876f10b107b$var$modalSubheadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    textAlign: "center",
    [(0, $hgUW1$media1).below.sm]: {
        marginBottom: "32px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
const $1f7c4876f10b107b$var$surveyTextStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.200"),
    a: {
        fontSize: "20px"
    }
});
const $1f7c4876f10b107b$var$modalActionButtonContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.400"),
    [(0, $hgUW1$media1).below.sm]: {
        margin: 0
    }
});


var $c5616d3f1657fc84$exports = {};

$parcel$export($c5616d3f1657fc84$exports, "LessonsTabContentSize", () => $c5616d3f1657fc84$export$415b2bdf1346d2d4);
$parcel$export($c5616d3f1657fc84$exports, "LessonsTabContent", () => $c5616d3f1657fc84$export$ce96f190f5d3ee14);






let $c5616d3f1657fc84$export$415b2bdf1346d2d4;
(function(LessonsTabContentSize) {
    LessonsTabContentSize["DEFAULT"] = "default";
    LessonsTabContentSize["WIDE"] = "wide";
})($c5616d3f1657fc84$export$415b2bdf1346d2d4 || ($c5616d3f1657fc84$export$415b2bdf1346d2d4 = {}));
const $c5616d3f1657fc84$export$ce96f190f5d3ee14 = ({ tabLinks: tabLinks , activeTab: activeTab = 0 , onClickTab: onClickTab , children: children , size: size = $c5616d3f1657fc84$export$415b2bdf1346d2d4.DEFAULT  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $c5616d3f1657fc84$var$tabsContainerStyles["base"],
            $c5616d3f1657fc84$var$tabsContainerStyles[`${size}-size`]
        ],
        "data-testid": "navtab",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                css: $c5616d3f1657fc84$var$tabsButtonGroupContainerStyles,
                children: tabLinks.map((tab, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                        "data-testid": `button-${tab}${index === activeTab ? "-selected" : ""}`,
                        css: $c5616d3f1657fc84$var$tabsButtonContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $731a4fd527bab680$export$3e41faf802a29e71), {
                            size: (0, $fec02fc26c7e145d$export$5dd2748b7940a2a0).LARGE,
                            label: tab,
                            onClick: ()=>onClickTab(index),
                            selected: index === activeTab
                        })
                    }, `li-navtab-${tab}-${index}`))
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $c5616d3f1657fc84$var$tabsContentContainerStyles,
                children: children
            })
        ]
    });
const $c5616d3f1657fc84$var$tabsContainerStyles = {
    base: (0, $hgUW1$css)({
        width: "100%",
        borderRadius: "8px",
        boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
        [(0, $hgUW1$media1).below.md]: {
            maxWidth: "720px"
        }
    }),
    "default-size": (0, $hgUW1$css)({
        maxWidth: "720px"
    }),
    "wide-size": (0, $hgUW1$css)({
        maxWidth: "1020px"
    })
};
const $c5616d3f1657fc84$var$tabsButtonGroupContainerStyles = (0, $hgUW1$css)({
    padding: "18px",
    overflowX: "auto",
    listStyleType: "none",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    [(0, $hgUW1$media1).below.xs]: {
        padding: "12px"
    }
});
const $c5616d3f1657fc84$var$tabsButtonContainerStyles = (0, $hgUW1$css)({
    margin: "6px",
    [(0, $hgUW1$media1).below.xs]: {
        margin: "4px"
    }
});
const $c5616d3f1657fc84$var$tabsContentContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "-0.06px",
    padding: "24px",
    color: (0, $hgUW1$token)("color.text"),
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $hgUW1$media1).below.xs]: {
        padding: "16px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});


var $eb6f767c51421421$exports = {};

$parcel$export($eb6f767c51421421$exports, "Metadata", () => $eb6f767c51421421$export$e7adebdc1ebd2fed);




const $eb6f767c51421421$export$e7adebdc1ebd2fed = ({ fields: fields  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $eb6f767c51421421$var$metadataContainerStyles,
        "data-testid": "metadata",
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $eb6f767c51421421$var$metadataListStyles,
            children: fields.map((field)=>field.value && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $eb6f767c51421421$var$metadataItemsStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $eb6f767c51421421$var$metadataTitleStyles,
                            children: field.name
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $eb6f767c51421421$var$metadataValueStyles,
                            children: field.value
                        })
                    ]
                }, field.name))
        })
    });
const $eb6f767c51421421$var$metadataContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    padding: (0, $hgUW1$token)("space.400"),
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised")
});
const $eb6f767c51421421$var$metadataListStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $hgUW1$token)("space.200")
});
const $eb6f767c51421421$var$metadataItemsStyles = (0, $hgUW1$css)({
    display: "flex",
    minHeight: "24px",
    gap: (0, $hgUW1$token)("space.300"),
    alignItems: "center"
});
const $eb6f767c51421421$var$metadataTitleStyles = (0, $hgUW1$css)({
    margin: 0,
    minWidth: "88px",
    color: "#000",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    textTransform: "uppercase"
});
const $eb6f767c51421421$var$metadataValueStyles = (0, $hgUW1$css)({
    margin: 0,
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});


var $7fe7e19d380f3d34$exports = {};

$parcel$export($7fe7e19d380f3d34$exports, "ArrowPosition", () => $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9);
$parcel$export($7fe7e19d380f3d34$exports, "Popup", () => $7fe7e19d380f3d34$export$129a32eedafa97c5);









let $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9;
(function(ArrowPosition) {
    ArrowPosition["LEFT_START"] = "leftStart";
    ArrowPosition["LEFT_CENTER"] = "leftCenter";
    ArrowPosition["LEFT_END"] = "leftEnd";
    ArrowPosition["TOP_START"] = "topStart";
    ArrowPosition["TOP_CENTER"] = "topCenter";
    ArrowPosition["TOP_END"] = "topEnd";
    ArrowPosition["RIGHT_START"] = "rightStart";
    ArrowPosition["RIGHT_CENTER"] = "rightCenter";
    ArrowPosition["RIGHT_END"] = "rightEnd";
    ArrowPosition["BOTTOM_START"] = "bottomStart";
    ArrowPosition["BOTTOM_CENTER"] = "bottomCenter";
    ArrowPosition["BOTTOM_END"] = "bottomEnd";
})($7fe7e19d380f3d34$export$2d4c84fdfce6f2a9 || ($7fe7e19d380f3d34$export$2d4c84fdfce6f2a9 = {}));
const $7fe7e19d380f3d34$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ popupHeight: popupHeight , title: title , children: children , step: step , totalSteps: totalSteps , arrowPosition: arrowPosition , onClose: onClose , onPrevious: onPrevious , onNext: onNext , popupStyle: popupStyle  }, popoverRef)=>{
    const CONTAINER_SIZE_PX = 88;
    const handlePrevious = ()=>{
        if (onPrevious) onPrevious();
    };
    const handleNext = ()=>{
        if (onNext) onNext();
    };
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    (0, $hgUW1$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (popoverRef && !popoverRef.current.contains(event.target)) handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        "data-testid": `popup-${arrowPosition}`,
        css: $7fe7e19d380f3d34$var$popupContainerStyles,
        style: popupStyle,
        ref: popoverRef,
        tabIndex: 0,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: [
                $7fe7e19d380f3d34$var$popupContentStyles["base"],
                $7fe7e19d380f3d34$var$popupContentStyles[arrowPosition]
            ],
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $7fe7e19d380f3d34$var$contentHeaderStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $7fe7e19d380f3d34$var$counterContainerStyles,
                            children: [
                                step,
                                "/",
                                totalSteps
                            ]
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $7fe7e19d380f3d34$var$buttonsContainerStyles,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    disabled: step === 1,
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    label: "Previous",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "chevron-left",
                                        alt: "next icon"
                                    }),
                                    onClick: handlePrevious
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    disabled: step === totalSteps,
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    label: "Next",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "chevron-right",
                                        alt: "previous icon"
                                    }),
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: (0, $hgUW1$css)({
                        overflow: "auto",
                        maxHeight: `calc(${popupHeight}px - ${CONTAINER_SIZE_PX}px)`,
                        padding: "0 16px"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $7fe7e19d380f3d34$var$titleContainerStyles,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $7fe7e19d380f3d34$var$descriptionContainerStyles,
                            children: [
                                " ",
                                children
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $7fe7e19d380f3d34$var$popupContainerStyles = (0, $hgUW1$css)({
    width: "340px",
    position: "absolute",
    zIndex: 10,
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        top: "0 !important",
        left: "0 !important"
    },
    [(0, $hgUW1$media1).below.xs]: {
        height: "100%",
        width: "100%",
        border: "1px solid",
        borderColor: (0, $hgUW1$token)("color.border"),
        borderRadius: 0
    }
});
const $7fe7e19d380f3d34$var$popupContentStyles = {
    base: (0, $hgUW1$css)({
        position: "relative",
        padding: "24px 8px",
        color: (0, $hgUW1$token)("color.text"),
        display: "flex",
        flexDirection: "column",
        "&:after": {
            content: '""',
            display: "block",
            position: "absolute",
            border: "16px solid transparent",
            width: 0,
            height: 0,
            marginTop: "-10px"
        },
        [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
            "&:after": {
                display: "none"
            }
        }
    }),
    leftStart: (0, $hgUW1$css)({
        "&::after": {
            top: "35px",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $hgUW1$token)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftCenter: (0, $hgUW1$css)({
        "&::after": {
            top: "calc(50%)",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $hgUW1$token)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftEnd: (0, $hgUW1$css)({
        "&::after": {
            left: "-5px",
            bottom: "35px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $hgUW1$token)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    topStart: (0, $hgUW1$css)({
        "&::after": {
            top: "-21px",
            left: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topCenter: (0, $hgUW1$css)({
        "&::after": {
            top: "-5px",
            left: "calc(50% - 16px)",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topEnd: (0, $hgUW1$css)({
        "&::after": {
            top: "-5px",
            right: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    rightStart: (0, $hgUW1$css)({
        "&::after": {
            top: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightCenter: (0, $hgUW1$css)({
        "&::after": {
            top: "calc(50% - 10px)",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightEnd: (0, $hgUW1$css)({
        "&::after": {
            bottom: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    bottomStart: (0, $hgUW1$css)({
        "&::after": {
            left: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomCenter: (0, $hgUW1$css)({
        "&::after": {
            left: "calc(50% - 16px)",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomEnd: (0, $hgUW1$css)({
        "&::after": {
            right: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    })
};
const $7fe7e19d380f3d34$var$contentHeaderStyles = (0, $hgUW1$css)({
    padding: "0 16px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $7fe7e19d380f3d34$var$titleContainerStyles = (0, $hgUW1$css)({
    marginBottom: "16px",
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px"
});
const $7fe7e19d380f3d34$var$descriptionContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $7fe7e19d380f3d34$var$counterContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    color: (0, $hgUW1$token)("color.text.subtlest")
});
const $7fe7e19d380f3d34$var$buttonsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center"
});


var $915f5687b3b07750$exports = {};

$parcel$export($915f5687b3b07750$exports, "ProgressBar", () => $915f5687b3b07750$export$c17561cb55d4db30);



const $915f5687b3b07750$export$c17561cb55d4db30 = ({ progress: progress  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        "data-testid": "progress-bar",
        css: $915f5687b3b07750$var$progressBarContainerStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            "data-testid": `progress-${progress}`,
            css: [
                $915f5687b3b07750$var$progressBarContentStyles,
                (0, $hgUW1$css)({
                    width: `${progress}%`
                })
            ]
        })
    });
const $915f5687b3b07750$var$progressBarContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "8px",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtler"),
    borderRadius: "100px",
    overflow: "hidden"
});
const $915f5687b3b07750$var$progressBarContentStyles = (0, $hgUW1$css)({
    height: "8px",
    backgroundColor: (0, $hgUW1$token)("color.text.success"),
    borderRadius: "100px"
});


var $579f9ef2424e0bd8$exports = {};

$parcel$export($579f9ef2424e0bd8$exports, "ProgressStatus", () => $579f9ef2424e0bd8$export$fad76899145ca0c7);
$parcel$export($579f9ef2424e0bd8$exports, "defineProgressStatus", () => $579f9ef2424e0bd8$export$aa03ab7e1a208875);
$parcel$export($579f9ef2424e0bd8$exports, "LearningHeader", () => $579f9ef2424e0bd8$export$86f07cccb119409d);









let $579f9ef2424e0bd8$export$fad76899145ca0c7;
(function(ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["IN_PROGRESS"] = "in_progress";
    ProgressStatus["FINISHED"] = "finished";
})($579f9ef2424e0bd8$export$fad76899145ca0c7 || ($579f9ef2424e0bd8$export$fad76899145ca0c7 = {}));
const $579f9ef2424e0bd8$export$aa03ab7e1a208875 = (progressStatus, contentTypeLabel)=>{
    switch(progressStatus){
        case $579f9ef2424e0bd8$export$fad76899145ca0c7.NOT_STARTED:
            return `Start ${contentTypeLabel}`;
        case $579f9ef2424e0bd8$export$fad76899145ca0c7.IN_PROGRESS:
            return `Continue ${contentTypeLabel}`;
        case $579f9ef2424e0bd8$export$fad76899145ca0c7.FINISHED:
            return `Review ${contentTypeLabel}`;
        default:
            return `Start ${contentTypeLabel}`;
    }
};
const $579f9ef2424e0bd8$export$86f07cccb119409d = ({ inspectMode: inspectMode , heading: heading , anonymousView: anonymousView = true , urlToShare: urlToShare , onSignIn: onSignIn , onStartCourse: onStartCourse , isLoading: isLoading , contentType: contentType , progressStatus: progressStatus , tagLine: tagLine , isSaved: isSaved , onSave: onSave , shouldShowFeedback: shouldShowFeedback , onStartFeedback: onStartFeedback  })=>{
    const handleSignIn = ()=>{
        if (onSignIn) onSignIn();
    };
    const handleStartCourse = ()=>{
        if (onStartCourse) onStartCourse();
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    const contentTypeLabel = contentType === (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE ? "course" : "learning path";
    const status = $579f9ef2424e0bd8$export$aa03ab7e1a208875(progressStatus, contentTypeLabel);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("section", {
        "data-testid": "learning-header",
        css: $579f9ef2424e0bd8$var$learningHeaderContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    (0, $5cf70e33bfc6ce73$export$f40d73b6f7f951e9)
                ],
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                    label: contentTypeLabel
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    margin: `${(0, $hgUW1$token)("space.300")} 0`
                }),
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                    level: 1,
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $579f9ef2424e0bd8$var$tagLineStyles,
                    children: tagLine
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    marginTop: (0, $hgUW1$token)("space.300"),
                    marginBottom: (0, $hgUW1$token)("space.400")
                }),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$N50)
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: (0, $hgUW1$css)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }),
                children: [
                    isLoading ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                        label: "",
                        isLoading: isLoading
                    }) : anonymousView ? /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: (0, $hgUW1$css)({
                            display: "flex"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                label: "Sign In",
                                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                onClick: handleSignIn,
                                isLoading: isLoading
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: (0, $hgUW1$token)("space.200")
                                }),
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    label: status,
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                                    onClick: handleStartCourse,
                                    isLoading: isLoading
                                })
                            })
                        ]
                    }) : !anonymousView && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: (0, $hgUW1$css)({
                            display: "flex"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                label: status,
                                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                onClick: handleStartCourse,
                                isLoading: isLoading
                            }),
                            shouldShowFeedback && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: (0, $hgUW1$token)("space.200")
                                }),
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    label: "Take survey",
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                                    onClick: onStartFeedback,
                                    isLoading: isLoading
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: (0, $hgUW1$css)({
                            display: "flex"
                        }),
                        children: [
                            !anonymousView && /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                css: $579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles,
                                onClick: handleOnSave,
                                "aria-label": isSaved ? "unsave" : "save",
                                children: isSaved ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                    type: "bookmark-filled"
                                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                    type: "bookmark"
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $579f9ef2424e0bd8$var$learningHeaderContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    paddingTop: `${(0, $hgUW1$token)("space.600")}`,
    paddingBottom: `${(0, $hgUW1$token)("space.400")}`,
    [(0, $hgUW1$media1).above.lg]: {
        paddingTop: (0, $hgUW1$token)("space.1000"),
        paddingBottom: `${(0, $hgUW1$token)("space.400")}`
    }
});
const $579f9ef2424e0bd8$var$tagLineStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px"
});
const $579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles = (0, $hgUW1$css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none"
});


var $d559b1cc82536c49$exports = {};

$parcel$export($d559b1cc82536c49$exports, "Footer", () => $d559b1cc82536c49$export$a06f1c675e846f6f);





const $d559b1cc82536c49$export$a06f1c675e846f6f = ({ onOpenReportProblemModal: onOpenReportProblemModal  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("footer", {
        "data-testid": "footer",
        css: $d559b1cc82536c49$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                href: "https://www.atlassian.com",
                css: [
                    $d559b1cc82536c49$var$paddingRightStyles,
                    $d559b1cc82536c49$var$logoLinkStyles
                ],
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianLogo), {
                    appearance: "neutral",
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("ul", {
                    css: $d559b1cc82536c49$var$listStyles,
                    "aria-label": "footer navigation",
                    children: [
                        onOpenReportProblemModal && /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: [
                                    $d559b1cc82536c49$var$listItemLinkStyles,
                                    (0, $hgUW1$css)({
                                        cursor: "pointer"
                                    })
                                ],
                                onClick: onOpenReportProblemModal,
                                children: "Report problem"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                css: $d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                children: "Privacy Policy"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                css: $d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://community.atlassian.com/t5/user/termsofservicepage",
                                children: "Terms of Use"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                css: $d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/security",
                                children: "Security"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("li", {
                            css: $d559b1cc82536c49$var$listItemStyles,
                            children: [
                                "\xa9 ",
                                new Date().getUTCFullYear(),
                                " Atlassian"
                            ]
                        })
                    ]
                })
            })
        ]
    });
const $d559b1cc82536c49$var$footerContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "1440px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    zIndex: 4,
    padding: "48px 104px",
    boxSizing: "border-box",
    margin: "0 auto",
    width: "100%",
    [(0, $hgUW1$media1).below.md]: {
        padding: "48px 60px"
    },
    [(0, $hgUW1$media1).below.sm]: {
        padding: "72px 32px",
        flexDirection: "column",
        alignItems: "flex-start"
    }
});
const $d559b1cc82536c49$var$listStyles = (0, $hgUW1$css)({
    display: "flex",
    paddingLeft: 0,
    margin: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    listStyle: "none",
    [(0, $hgUW1$media1).below.sm]: {
        flexDirection: "column"
    }
});
const $d559b1cc82536c49$var$listItemStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    marginTop: 0,
    color: (0, $hgUW1$token)("color.text.subtlest"),
    [(0, $hgUW1$media1).below.sm]: {
        paddingTop: "24px"
    }
});
const $d559b1cc82536c49$var$paddingRightStyles = (0, $hgUW1$css)({
    paddingRight: "24px"
});
const $d559b1cc82536c49$var$logoLinkStyles = (0, $hgUW1$css)({
    lineHeight: "24px"
});
const $d559b1cc82536c49$var$listItemLinkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest"),
    textDecoration: "none",
    "&:hover": {
        color: (0, $hgUW1$token)("color.text.subtlest"),
        textDecoration: "none"
    }
});


var $fa53e9c0a1746730$exports = {};

$parcel$export($fa53e9c0a1746730$exports, "LabelledGraphic", () => $fa53e9c0a1746730$export$12b5e3eab33f219b);






const $fa53e9c0a1746730$export$12b5e3eab33f219b = ({ image: image , markers: markers , onClickMarker: onClickMarker , onClickNext: onClickNext , onClickPrevious: onClickPrevious , onClickDismiss: onClickDismiss , pulseAnimationColor: pulseAnimationColor = (0, $hgUW1$token)("color.background.input")  })=>{
    const [activeId, setActiveId] = (0, $hgUW1$useState)(null);
    const [popoverPosX, setPopoverPosX] = (0, $hgUW1$useState)(null);
    const [popoverPosY, setPopoverPosY] = (0, $hgUW1$useState)(null);
    const [clickedMarkers, setClickedMarkers] = (0, $hgUW1$useState)([]);
    const containerDivRef = (0, $hgUW1$useRef)(null);
    const popupRef = (0, $hgUW1$useRef)(null);
    const imageContainerRef = (0, $hgUW1$useRef)(null);
    const maxPopupHeight = 540;
    const maxPopupWidth = 340;
    const defaultDesktopWidth = 1040;
    const iconNumbers = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero"
    ];
    const handleNextStep = (idx)=>{
        if (onClickNext) onClickNext();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx + 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId + 1 : null;
        });
    };
    const handlePreviousStep = (idx)=>{
        if (onClickPrevious) onClickPrevious();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx - 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId - 1 : null;
        });
    };
    const handleDismiss = (0, $hgUW1$useCallback)(()=>{
        if (onClickDismiss) onClickDismiss();
        setActiveId(null);
    }, []);
    const handleClickMarker = (0, $hgUW1$useCallback)((idx)=>{
        if (onClickMarker) onClickMarker(idx + 1);
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx
            ]);
        setActiveId(idx);
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        if (containerDivRef.current && activeId != null) {
            const parentWidth = containerDivRef.current.clientWidth;
            const parentHeight = containerDivRef.current.clientHeight;
            const popoverHeight = popupRef?.current?.clientHeight ?? 0;
            let posX = parentWidth * markers[activeId].posX / 100;
            let posY = parentHeight * markers[activeId].posY / 100;
            switch(markers[activeId].arrowPosition){
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).LEFT_START:
                    posX = posX + 70;
                    posY = posY - 15;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).LEFT_CENTER:
                    posX = posX + 70;
                    posY = posY - Math.ceil(popoverHeight / 2.5) - 15;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).LEFT_END:
                    posX = posX + 70;
                    posY = posY - popoverHeight + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).TOP_START:
                    posX = posX - 24;
                    posY = posY + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).TOP_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 27;
                    posY = posY + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).TOP_END:
                    posX = posX - maxPopupWidth + 60;
                    posY = posY + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).RIGHT_START:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - 13;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).RIGHT_CENTER:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - Math.ceil(popoverHeight / 2) + 32;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).RIGHT_END:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - popoverHeight + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).BOTTOM_START:
                    posX = posX - 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).BOTTOM_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).BOTTOM_END:
                    posX = posX - maxPopupWidth + 70;
                    posY = posY - popoverHeight - 18;
                    break;
                default:
                    break;
            }
            setPopoverPosX(posX / parentWidth * 100);
            setPopoverPosY(posY / parentHeight * 100);
            // Focus the popup when it is opened
            popupRef.current?.focus();
        }
    }, [
        activeId,
        markers,
        imageContainerRef.current?.clientHeight
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            handleClickMarker(Number(event.currentTarget.getAttribute("data-marker-index")));
        }
    }, [
        handleClickMarker
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $fa53e9c0a1746730$var$labelledGraphicContainerStyles,
        ref: containerDivRef,
        children: [
            markers?.map((marker, idx)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    "data-testid": "graphic-marker",
                    css: [
                        $fa53e9c0a1746730$var$markerPulseStyles,
                        clickedMarkers.includes(idx) && "none",
                        !clickedMarkers.includes(idx) && pulseAnimationColor === "#FFFFFF" && (0, $hgUW1$css)({
                            animation: `${$fa53e9c0a1746730$var$pulseWhiteAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        }),
                        !clickedMarkers.includes(idx) && pulseAnimationColor !== "#FFFFFF" && (0, $hgUW1$css)({
                            animation: `${$fa53e9c0a1746730$var$pulsePurpleAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        })
                    ],
                    style: {
                        left: marker.posX + "%",
                        top: marker.posY + "%"
                    },
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickMarker(idx);
                        },
                        draggable: true,
                        css: [
                            $fa53e9c0a1746730$var$graphicMarkerContainerStyles["base"],
                            activeId === idx && $fa53e9c0a1746730$var$graphicMarkerContainerStyles["selected"],
                            (0, $hgUW1$css)({
                                border: `2px solid ${pulseAnimationColor}`
                            })
                        ],
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
                            children: [
                                marker.icon && iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: [
                                        activeId === idx && (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text.inverse")
                                        }),
                                        activeId !== idx && (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text")
                                        })
                                    ],
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: marker.icon
                                    })
                                }),
                                marker.icon && !iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        size: "small",
                                        color: `${activeId === idx ? (0, $hgUW1$token)("color.icon.inverse") : (0, $hgUW1$token)("color.icon.warning.inverse")}`,
                                        type: marker.icon
                                    })
                                })
                            ]
                        })
                    })
                }, `marker-${idx}`)),
            activeId != null && imageContainerRef.current && containerDivRef.current && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $7fe7e19d380f3d34$export$129a32eedafa97c5), {
                popupHeight: imageContainerRef.current.clientHeight > 540 ? 540 : imageContainerRef.current.clientHeight,
                title: markers[activeId].title,
                totalSteps: markers.length,
                step: activeId + 1,
                popupStyle: {
                    position: "absolute",
                    left: popoverPosX + "%",
                    top: popoverPosY + "%",
                    maxHeight: `${maxPopupHeight}px`,
                    maxWidth: `${maxPopupWidth}px`
                },
                arrowPosition: markers[activeId].arrowPosition,
                onNext: ()=>handleNextStep(activeId),
                onPrevious: ()=>handlePreviousStep(activeId),
                onClose: handleDismiss,
                ref: popupRef,
                children: markers[activeId].children
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                ref: imageContainerRef,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                    ...image,
                    css: [
                        $fa53e9c0a1746730$var$imageStyles,
                        (0, $hgUW1$css)({
                            maxWidth: `${defaultDesktopWidth}px`
                        })
                    ],
                    preventModal: true
                })
            })
        ]
    });
};
const $fa53e9c0a1746730$var$labelledGraphicContainerStyles = (0, $hgUW1$css)({
    position: "relative",
    cursor: "default"
});
const $fa53e9c0a1746730$var$pulseWhiteAnimationStyles = (0, $hgUW1$keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 ${(0, $hgUW1$token)("color.border.inverse")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 ${(0, $hgUW1$token)("color.border.inverse")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 10px ${(0, $hgUW1$token)("color.border.inverse")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 10px ${(0, $hgUW1$token)("color.border.inverse")}`
    }
});
const $fa53e9c0a1746730$var$pulsePurpleAnimationStyles = (0, $hgUW1$keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 ${(0, $hgUW1$token)("color.text.discovery")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 ${(0, $hgUW1$token)("color.text.discovery")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 10px ${(0, $hgUW1$token)("color.text.discovery")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 10px ${(0, $hgUW1$token)("color.text.discovery")}`
    }
});
const $fa53e9c0a1746730$var$markerPulseStyles = (0, $hgUW1$css)({
    height: "46px",
    width: "46px",
    padding: "6px 12px",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    borderRadius: "50%",
    zIndex: 2,
    cursor: "pointer"
});
const $fa53e9c0a1746730$var$graphicMarkerContainerStyles = {
    base: (0, $hgUW1$css)({
        height: "40px",
        width: "40px",
        padding: "6px 12px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: (0, $hgUW1$token)("color.background.accent.yellow.subtle"),
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        color: (0, $hgUW1$token)("color.text"),
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.yellow.subtle.hovered")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.yellow.subtle.pressed")
        }
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.text"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.text")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.text")
        }
    })
};
const $fa53e9c0a1746730$var$imageStyles = (0, $hgUW1$css)({
    height: "auto",
    width: "100%"
});


var $9225344cd5d1f99b$exports = {};

$parcel$export($9225344cd5d1f99b$exports, "LessonHeader", () => $9225344cd5d1f99b$export$7bee7638d150bc04);






const $9225344cd5d1f99b$export$7bee7638d150bc04 = ({ heading: heading , tags: tags , description: description , urlToShare: urlToShare , onListenClick: onListenClick  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9225344cd5d1f99b$var$headingWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                    level: 1,
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $9225344cd5d1f99b$var$metadataStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $9225344cd5d1f99b$var$flexContainerStyles,
                        children: tags.map((tag, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $9225344cd5d1f99b$var$tagStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                    ...tag
                                })
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $9225344cd5d1f99b$var$flexContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                                css: $9225344cd5d1f99b$var$listenButtonStyles,
                                onClick: ()=>onListenClick && onListenClick(),
                                "data-testid": "listen-button",
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.5 17.3333V13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5V15.6667C6.5 16.6792 7.32081 17.5 8.33333 17.5C8.42538 17.5 8.5 17.4254 8.5 17.3333ZM7.5 11C6.11929 11 5 12.1193 5 13.5V15.6667C5 17.5076 6.49238 19 8.33333 19C9.25381 19 10 18.2538 10 17.3333V13.5C10 12.1193 8.88071 11 7.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M15.5 17.3333V13.5C15.5 12.9477 15.9477 12.5 16.5 12.5C17.0523 12.5 17.5 12.9477 17.5 13.5V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5C15.5746 17.5 15.5 17.4254 15.5 17.3333ZM16.5 11C17.8807 11 19 12.1193 19 13.5V15.6667C19 17.5076 17.5076 19 15.6667 19C14.7462 19 14 18.2538 14 17.3333V13.5C14 12.1193 15.1193 11 16.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12 5.5C8.96243 5.5 6.5 7.96243 6.5 11V14.25H5V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V14.25H17.5V11C17.5 7.96243 15.0376 5.5 12 5.5Z",
                                                fill: "#44546F"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                        css: $9225344cd5d1f99b$var$listenTextWrapperStyles,
                                        children: "Listen"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9225344cd5d1f99b$var$lineWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$token)("color.border")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9225344cd5d1f99b$var$descriptionStyles,
                children: description
            })
        ]
    });
const $9225344cd5d1f99b$var$metadataStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $9225344cd5d1f99b$var$flexContainerStyles = (0, $hgUW1$css)({
    display: "flex"
});
const $9225344cd5d1f99b$var$listenButtonStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    marginRight: "1.5rem",
    cursor: "pointer",
    padding: 0,
    border: "none",
    background: "transparent"
});
const $9225344cd5d1f99b$var$listenTextWrapperStyles = (0, $hgUW1$css)({
    marginLeft: "0.25rem",
    color: (0, $hgUW1$token)("color.text.subtle"),
    fontSize: "16px",
    fontFamily: "Charlie Text, sans-serif"
});
const $9225344cd5d1f99b$var$tagStyles = (0, $hgUW1$css)({
    marginRight: "0.5rem"
});
const $9225344cd5d1f99b$var$lineWrapperStyles = (0, $hgUW1$css)({
    padding: "1.5rem 0 2.5rem 0"
});
const $9225344cd5d1f99b$var$headingWrapperStyles = (0, $hgUW1$css)({
    padding: "5rem 0 1.5rem 0"
});
const $9225344cd5d1f99b$var$descriptionStyles = (0, $hgUW1$css)({
    paddingBottom: (0, $hgUW1$token)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    p: {
        margin: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    ul: {
        paddingLeft: "20px",
        marginTop: 0,
        marginBottom: 0,
        li: {
            marginTop: "16px"
        },
        "li + li": {
            marginTop: "16px !important"
        }
    }
});


var $3b9afd8fe4435353$exports = {};

$parcel$export($3b9afd8fe4435353$exports, "LessonList", () => $3b9afd8fe4435353$export$962a95c44e73eb25);











const $057799a99c9f255f$export$b7cafc9b9fbb48b2 = ({ isCompleted: isCompleted , size: size  })=>isCompleted ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
        type: "check-circle-filled",
        size: size,
        color: (0, $hgUW1$token)("color.icon.success")
    }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
        type: "check-circle-outline",
        size: size,
        color: (0, $hgUW1$token)("color.background.accent.gray.subtler.pressed")
    });








const $7e5a668c3a5a9ea8$export$2c301aad86da9f9a = ({ sectionTitle: sectionTitle , slug: slug , lessonSlug: lessonSlug , isCompleted: isCompleted , onNavigation: onNavigation  })=>{
    const handleKeyDown = (0, $hgUW1$useCallback)((event, onNavigation, slug, lessonSlug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                sectionSlug: slug,
                lessonSlug: lessonSlug
            });
        }
    }, [
        onNavigation,
        slug,
        lessonSlug
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $7e5a668c3a5a9ea8$var$sectionStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $057799a99c9f255f$export$b7cafc9b9fbb48b2), {
                isCompleted: isCompleted,
                size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).SMALL
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $7e5a668c3a5a9ea8$var$sectionLinkStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    role: "link",
                    tabIndex: 0,
                    onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug, lessonSlug),
                    onClick: ()=>onNavigation({
                            sectionSlug: slug,
                            lessonSlug: lessonSlug
                        }),
                    children: sectionTitle
                })
            })
        ]
    });
};
const $7e5a668c3a5a9ea8$var$sectionStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem"
});
const $7e5a668c3a5a9ea8$var$sectionLinkStyles = (0, $hgUW1$css)({
    marginLeft: "11px",
    span: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: (0, $hgUW1$token)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $hgUW1$token)("color.text.selected"),
            textDecoration: "none"
        }
    }
});




const $fc302bf0bdbf0587$export$e4e5e6361d1b89e2 = ({ lessonTitle: lessonTitle , slug: slug , duration: duration , isCompleted: isCompleted , isCurrentLesson: isCurrentLesson , hasDivider: hasDivider , sections: sections , onNavigation: onNavigation  })=>{
    const [isExpanded, setIsExpanded] = (0, $hgUW1$useState)(isCurrentLesson);
    const expandByCard = (event)=>{
        if (event.target === event.currentTarget) setIsExpanded(!isExpanded);
    };
    const expandByButton = ()=>{
        setIsExpanded(!isExpanded);
    };
    (0, $hgUW1$useEffect)(()=>{
        setIsExpanded(isCurrentLesson);
    }, [
        isCurrentLesson
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((event, onNavigation, slug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                lessonSlug: slug
            });
        }
    }, [
        onNavigation,
        slug
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("section", {
        tabIndex: 0,
        css: [
            $fc302bf0bdbf0587$var$lessonCardContainerStyles,
            !hasDivider && (0, $hgUW1$css)({
                marginBottom: "16px"
            })
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: [
                    $fc302bf0bdbf0587$var$lessonCardStyles,
                    isCurrentLesson && $fc302bf0bdbf0587$var$currentLessonStyles,
                    !isCurrentLesson && $fc302bf0bdbf0587$var$hoverLessonStyles
                ],
                onClick: expandByCard,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                        tabIndex: 0,
                        "aria-label": "expand lesson button",
                        css: [
                            $fc302bf0bdbf0587$var$expandButtonStyles,
                            !isCurrentLesson && (0, $hgUW1$css)({
                                borderColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.hovered")
                            })
                        ],
                        "data-testid": "expand-button",
                        onClick: expandByButton,
                        children: isExpanded ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "chevron-down",
                            size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).MEDIUM,
                            color: isCurrentLesson ? (0, $hgUW1$token)("color.icon.selected") : (0, $hgUW1$token)("color.icon.subtle")
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "chevron-right",
                            size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).MEDIUM,
                            color: isCurrentLesson ? (0, $hgUW1$token)("color.icon.selected") : (0, $hgUW1$token)("color.icon.subtle")
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $fc302bf0bdbf0587$var$mainContentColumnStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: [
                                    $fc302bf0bdbf0587$var$durationStyles,
                                    !isCurrentLesson && (0, $hgUW1$css)({
                                        color: (0, $hgUW1$token)("color.text.subtlest")
                                    })
                                ],
                                children: duration.toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $fc302bf0bdbf0587$var$lessonContainer,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $fc302bf0bdbf0587$var$lessonTitleStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug),
                                            onClick: ()=>onNavigation({
                                                    lessonSlug: slug
                                                }),
                                            children: lessonTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: (0, $hgUW1$css)({
                                            marginLeft: "1.5rem",
                                            display: "flex"
                                        }),
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $057799a99c9f255f$export$b7cafc9b9fbb48b2), {
                                            isCompleted: isCompleted,
                                            size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).MEDIUM
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: (0, $hgUW1$css)({
                                    marginTop: "0.75rem"
                                }),
                                children: isExpanded && sections.map((section)=>/*#__PURE__*/ (0, $hgUW1$createElement)((0, $7e5a668c3a5a9ea8$export$2c301aad86da9f9a), {
                                        ...section,
                                        lessonSlug: slug,
                                        onNavigation: onNavigation,
                                        key: `section-${section.slug}`
                                    }))
                            })
                        ]
                    })
                ]
            }),
            hasDivider && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    marginTop: "16px",
                    marginBottom: "16px"
                }),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    height: 2,
                    color: (0, $hgUW1$token)("color.border")
                })
            })
        ]
    }, slug);
};
const $fc302bf0bdbf0587$var$lessonCardContainerStyles = (0, $hgUW1$css)({
    maxWidth: "25.25rem",
    [(0, $hgUW1$media).below.sm]: {
        maxWidth: "100%",
        paddingRight: "16px"
    }
});
const $fc302bf0bdbf0587$var$lessonCardStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    padding: "16px",
    borderRadius: "0.25rem",
    cursor: "pointer"
});
const $fc302bf0bdbf0587$var$currentLessonStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected"),
    borderLeft: `4px solid ${(0, $hgUW1$token)("color.text.brand")}`
});
const $fc302bf0bdbf0587$var$hoverLessonStyles = (0, $hgUW1$css)({
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
    },
    ":hover button": {
        borderColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.pressed")
    }
});
const $fc302bf0bdbf0587$var$mainContentColumnStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem"
});
const $fc302bf0bdbf0587$var$expandButtonStyles = (0, $hgUW1$css)({
    width: "1.5rem",
    height: "1.5rem",
    padding: 0,
    border: `1px solid ${(0, $hgUW1$token)("color.background.accent.blue.subtlest.pressed")}`,
    borderRadius: "0.25rem",
    boxSizing: "content-box",
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    ":focus-visible": {
        border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $fc302bf0bdbf0587$var$durationStyles = (0, $hgUW1$css)({
    width: "100%",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    color: (0, $hgUW1$token)("color.text.selected"),
    marginTop: 0,
    marginBottom: (0, $hgUW1$token)("space.075")
});
const $fc302bf0bdbf0587$var$lessonContainer = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center"
});
const $fc302bf0bdbf0587$var$lessonTitleStyles = (0, $hgUW1$css)({
    width: "100%",
    fontFamily: "Charlie Display",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1.5rem",
    span: {
        color: (0, $hgUW1$token)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $hgUW1$token)("color.text.selected"),
            textDecoration: "none"
        }
    }
});


const $3b9afd8fe4435353$export$962a95c44e73eb25 = ({ lessons: lessons  })=>{
    const currentLessonIndx = lessons.findIndex((lesson)=>lesson.isCurrentLesson);
    const updatedLessons = lessons.map((lesson, indx)=>({
            ...lesson,
            hasDivider: !(indx === currentLessonIndx || indx === currentLessonIndx - 1)
        }));
    return updatedLessons.map((lesson)=>/*#__PURE__*/ (0, $hgUW1$createElement)((0, $fc302bf0bdbf0587$export$e4e5e6361d1b89e2), {
            ...lesson,
            key: `lesson-${lesson.slug}`
        }));
};


var $65703ff0bcd12648$exports = {};

$parcel$export($65703ff0bcd12648$exports, "LessonSidebar", () => $65703ff0bcd12648$export$c2bf8d11366d1eb0);









const $bae5a7f2c1ae6bce$export$7ded8628b71ba75 = ({ progress: progress , pathColor: pathColor , trailColor: trailColor = (0, $hgUW1$token)("color.border") , image: image , title: title , onCourseNavigation: onCourseNavigation  })=>{
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onCourseNavigation && onCourseNavigation();
        }
    }, [
        onCourseNavigation
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $bae5a7f2c1ae6bce$var$progressBadgeContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    maxWidth: "64px",
                    [(0, $hgUW1$media1).above.sm]: {
                        maxWidth: "85px"
                    }
                }),
                "data-testid": "progress-circle",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$CircularProgressbarWithChildren), {
                    strokeWidth: 4,
                    value: progress,
                    styles: (0, $hgUW1$buildStyles)({
                        pathColor: pathColor,
                        trailColor: trailColor
                    }),
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $bae5a7f2c1ae6bce$var$imageBadgeContainerStyles,
                        children: image ? /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                            css: $bae5a7f2c1ae6bce$var$imageStyles,
                            "data-testid": "badge-image",
                            src: image.src,
                            alt: image.alt
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: [
                                (0, $hgUW1$css)({
                                    backgroundColor: trailColor
                                }),
                                $bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    css: $bae5a7f2c1ae6bce$var$titleStyles,
                    onClick: onCourseNavigation,
                    children: title
                })
            })
        ]
    });
};
const $bae5a7f2c1ae6bce$var$progressBadgeContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    gap: "16px"
});
const $bae5a7f2c1ae6bce$var$imageBadgeContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    padding: "8px"
});
const $bae5a7f2c1ae6bce$var$imageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles = (0, $hgUW1$css)({
    borderRadius: "9999px",
    width: "100%",
    height: "100%"
});
const $bae5a7f2c1ae6bce$var$titleStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    fontFamily: "Charlie Display, sans-serif",
    paddingRight: "16px",
    margin: 0,
    "&:hover": {
        cursor: "pointer",
        color: (0, $hgUW1$token)("color.text.selected")
    }
});



const $65703ff0bcd12648$export$c2bf8d11366d1eb0 = ({ lessons: lessons , progress: progress , pathColor: pathColor , title: title , image: image , isVisible: isVisible , onChangeMenuVisibility: onChangeMenuVisibility , onCourseNavigation: onCourseNavigation  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)((0, $9c3f769544bb2079$export$1ba59dacbcbf90fe), {
        isVisible: isVisible,
        onChangeMenuVisibility: onChangeMenuVisibility,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: (0, $hgUW1$css)({
                    marginLeft: "16px"
                }),
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: (0, $hgUW1$css)({
                            marginBottom: "16px",
                            lineHeight: "24px"
                        }),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: [
                                $65703ff0bcd12648$var$subheadingStyles,
                                (0, $hgUW1$css)({
                                    marginBottom: "24px",
                                    marginTop: "24px"
                                })
                            ],
                            children: "Current course"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $bae5a7f2c1ae6bce$export$7ded8628b71ba75), {
                        progress: progress,
                        pathColor: pathColor,
                        title: title,
                        image: image,
                        onCourseNavigation: onCourseNavigation
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: (0, $hgUW1$css)({
                            marginBottom: "24px",
                            marginTop: "24px",
                            lineHeight: "24px"
                        }),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $65703ff0bcd12648$var$subheadingStyles,
                            children: "Lessons in this course"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3b9afd8fe4435353$export$962a95c44e73eb25), {
                lessons: lessons
            })
        ]
    });
const $65703ff0bcd12648$var$subheadingStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text, sens-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $hgUW1$token)("color.text")
});


var $dbb9d5792c296a49$exports = {};

$parcel$export($dbb9d5792c296a49$exports, "SubmitFeedback", () => $dbb9d5792c296a49$export$f6dc54b55657f29f);








const $dbb9d5792c296a49$export$f6dc54b55657f29f = ({ onSubmit: onSubmit , onChange: onChange , isLoading: isLoading , isSubmitted: isSubmitted , hasError: hasError , opinion: opinion  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const [isYesSelected, setIsYesSelected] = (0, $hgUW1$useState)(false);
    const [isNoSelected, setIsNoSelected] = (0, $hgUW1$useState)(false);
    const handleChange = (0, $hgUW1$useCallback)((e)=>{
        e.preventDefault();
        if (onChange) onChange(e);
    }, [
        onChange
    ]);
    const handleYes = (0, $hgUW1$useCallback)(()=>{
        setIsOpen(true);
        setIsYesSelected(true);
        setIsNoSelected(false);
    }, []);
    const handleNo = (0, $hgUW1$useCallback)(()=>{
        setIsOpen(true);
        setIsNoSelected(true);
        setIsYesSelected(false);
    }, []);
    const handleCancel = (0, $hgUW1$useCallback)(()=>{
        setIsOpen(false);
        setIsYesSelected(false);
        setIsNoSelected(false);
    }, []);
    const renderButtons = ()=>{
        if (isLoading && !isSubmitted) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$LoadingButton), {
            appearance: "primary",
            isLoading: true,
            children: "Submit"
        });
        if (isSubmitted) return null;
        return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    type: "submit",
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                    label: "Submit",
                    onClick: onSubmit
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).LINK,
                    label: "Cancel",
                    onClick: handleCancel
                })
            ]
        });
    };
    const renderFeedbackBox = ()=>{
        if (!isOpen) return null;
        if (!isSubmitted) return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: {
                label: {
                    fontSize: "13.7143px",
                    color: (0, $hgUW1$token)("color.text.subtlest")
                },
                textArea: {
                    borderColor: `${(0, $hgUW1$token)("color.border")} !important`,
                    "&:focus": {
                        borderColor: `${(0, $hgUW1$token)("color.border.focused")} !important`
                    }
                }
            },
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Label), {
                    htmlFor: "area",
                    children: "Send us your opinion"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskittextarea), {
                    placeholder: "Begin typing in here...",
                    defaultValue: opinion,
                    onChange: handleChange
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$FormFooter), {
                    children: renderButtons()
                })
            ]
        });
        if (!hasError) return /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
            css: $dbb9d5792c296a49$var$feedbackStyles,
            children: "Thanks for your feedback!"
        });
        return /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
            css: $dbb9d5792c296a49$var$feedbackStyles,
            children: "Error submitting feedback. Try again later."
        });
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
        children: [
            !isSubmitted && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: (0, $hgUW1$css)({
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $dbb9d5792c296a49$var$labelStyles,
                            children: "Was this content helpful?"
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: (0, $hgUW1$css)({
                                marginLeft: "1rem",
                                display: "flex"
                            }),
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        marginRight: "0.5rem"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Yes",
                                        onClick: handleYes,
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        disabled: isYesSelected
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    label: "No",
                                    onClick: handleNo,
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                    disabled: isNoSelected
                                })
                            ]
                        })
                    ]
                })
            }),
            renderFeedbackBox()
        ]
    });
};
const $dbb9d5792c296a49$var$labelStyles = (0, $hgUW1$css)({
    marginTop: 0,
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    color: (0, $hgUW1$token)("color.text")
});
const $dbb9d5792c296a49$var$feedbackStyles = (0, $hgUW1$css)({
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    width: "13.813rem",
    height: "1.563rem"
});



var $44303f6c3c81eeac$exports = {};

$parcel$export($44303f6c3c81eeac$exports, "QuestionType", () => $44303f6c3c81eeac$export$51940fbbacba35d4);
$parcel$export($44303f6c3c81eeac$exports, "QuizStatus", () => $44303f6c3c81eeac$export$bf1c1ed72daa392b);
$parcel$export($44303f6c3c81eeac$exports, "QuestionStatus", () => $44303f6c3c81eeac$export$602daccbd963b20);
$parcel$export($44303f6c3c81eeac$exports, "MatchingAnswerStatus", () => $44303f6c3c81eeac$export$85e3e62cc743c830);
$parcel$export($44303f6c3c81eeac$exports, "ActionDescription", () => $44303f6c3c81eeac$export$cb9c858407602327);
$parcel$export($44303f6c3c81eeac$exports, "Quiz", () => $44303f6c3c81eeac$export$76709845c4fea6cd);






var $3ced3ef7e9864bf1$exports = {};

$parcel$export($3ced3ef7e9864bf1$exports, "useDeviceSize", () => $3ced3ef7e9864bf1$export$4616d33c54ae5baf);

// Default to a common desktop device width (is used to handle window object not being available during SSR)
const $3ced3ef7e9864bf1$var$DEFAULT_WIDTH = 1440;
const $3ced3ef7e9864bf1$export$4616d33c54ae5baf = ()=>{
    const [width, setWidth] = (0, $hgUW1$useState)(typeof window !== "undefined" ? window.innerWidth : $3ced3ef7e9864bf1$var$DEFAULT_WIDTH);
    const handleWindowResize = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $hgUW1$useEffect)(()=>{
        if (typeof window === "undefined") return;
        if (width === $3ced3ef7e9864bf1$var$DEFAULT_WIDTH && width !== window.innerWidth) handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    return width;
};









let $b55544cdfa85935b$export$1bd2035254432789;
(function(InputStatus) {
    InputStatus["CORRECT"] = "CORRECT";
    InputStatus["INCORRECT"] = "INCORRECT";
    InputStatus["SELECTED"] = "SELECTED";
    InputStatus["DEFAULT"] = "DEFAULT";
    InputStatus["DISABLED"] = "DISABLED";
})($b55544cdfa85935b$export$1bd2035254432789 || ($b55544cdfa85935b$export$1bd2035254432789 = {}));
const $b55544cdfa85935b$export$56e6c05354470c53 = ({ inspectMode: inspectMode , text: text , elementId: elementId , inputStatus: inputStatus = $b55544cdfa85935b$export$1bd2035254432789.DEFAULT , onClick: onClick  })=>{
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        css: [
            $b55544cdfa85935b$var$quizInputsContainerStyles,
            $b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $b55544cdfa85935b$var$quizInputBorderStyles["DEFAULT"],
                    $b55544cdfa85935b$var$quizInputBorderStyles[inputStatus],
                    $b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                id: elementId ? elementId + "-quiz-input" : "",
                css: [
                    $b55544cdfa85935b$var$quizInputsContentStyles,
                    $b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ],
                onClick: onClick,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    css: $b55544cdfa85935b$var$quizInputsTextStyles,
                    children: text
                })
            })
        ]
    });
};
const $b55544cdfa85935b$var$quizInputsContainerStyles = (0, $hgUW1$css)({
    width: "50%",
    display: "flex",
    cursor: "pointer",
    borderRadius: "8px",
    boxShadow: "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    justifyContent: "center"
});
const $b55544cdfa85935b$var$quizInputsContentStyles = (0, $hgUW1$css)({
    maxWidth: "300px",
    width: "100%",
    padding: "16px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(9, 30, 66, 0.14)",
    borderLeft: "none",
    borderRadius: "0 8px 8px 0"
});
const $b55544cdfa85935b$var$quizInputsTextStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
    [(0, $hgUW1$media1).below.xs]: {
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $b55544cdfa85935b$var$quizInputBorderStyles = {
    DEFAULT: (0, $hgUW1$css)({
        maxHeight: "100%",
        width: "8px",
        borderRadius: "8px 0 0 8px",
        border: "1px solid rgba(9, 30, 66, 0.14)",
        borderRight: "none",
        backgroundColor: (0, $hgUW1$N0),
        [(0, $hgUW1$media1).below.xs]: {
            width: "4px"
        }
    }),
    CORRECT: (0, $hgUW1$css)({
        backgroundColor: "#22A06B",
        border: "1px solid #22A06B"
    }),
    INCORRECT: (0, $hgUW1$css)({
        backgroundColor: "#E2483D",
        border: "1px solid #E2483D"
    }),
    SELECTED: (0, $hgUW1$css)({
        backgroundColor: "#0C66E4",
        border: "1px solid #0C66E4"
    })
};
const $b55544cdfa85935b$var$quizInputsVariantStyles = {
    DEFAULT: (0, $hgUW1$css)({
        color: "#000000",
        backgroundColor: (0, $hgUW1$N0),
        fontWeight: 400
    }),
    CORRECT: (0, $hgUW1$css)({
        fontWeight: 700
    }),
    INCORRECT: (0, $hgUW1$css)({
        fontWeight: 700
    }),
    SELECTED: (0, $hgUW1$css)({
        fontWeight: 700
    }),
    DISABLED: (0, $hgUW1$css)({
        color: "#626F86",
        fontWeight: 400,
        backgroundColor: "#F7F8F9",
        border: "1px solid #F7F8F9",
        boxShadow: "none",
        transition: "all",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        pointerEvents: "none"
    })
};



let $44303f6c3c81eeac$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
    QuestionType["MATCHING"] = "MATCHING";
})($44303f6c3c81eeac$export$51940fbbacba35d4 || ($44303f6c3c81eeac$export$51940fbbacba35d4 = {}));
let $44303f6c3c81eeac$export$bf1c1ed72daa392b;
(function(QuizStatus) {
    QuizStatus["DEFAULT"] = "DEFAULT";
    QuizStatus["ERROR"] = "ERROR";
    QuizStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuizStatus["SUCCESS"] = "SUCCESS";
})($44303f6c3c81eeac$export$bf1c1ed72daa392b || ($44303f6c3c81eeac$export$bf1c1ed72daa392b = {}));
let $44303f6c3c81eeac$export$602daccbd963b20;
(function(QuestionStatus) {
    QuestionStatus["INCORRECT"] = "INCORRECT";
    QuestionStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuestionStatus["CORRECT"] = "CORRECT";
})($44303f6c3c81eeac$export$602daccbd963b20 || ($44303f6c3c81eeac$export$602daccbd963b20 = {}));
let $44303f6c3c81eeac$export$85e3e62cc743c830;
(function(MatchingAnswerStatus) {
    MatchingAnswerStatus["DEFAULT"] = "DEFAULT";
    MatchingAnswerStatus["INCORRECT"] = "INCORRECT";
    MatchingAnswerStatus["CORRECT"] = "CORRECT";
})($44303f6c3c81eeac$export$85e3e62cc743c830 || ($44303f6c3c81eeac$export$85e3e62cc743c830 = {}));
let $44303f6c3c81eeac$export$cb9c858407602327;
(function(ActionDescription) {
    ActionDescription["SINGLE_SELECT"] = "Select the correct answer.";
    ActionDescription["MULTI_SELECT"] = "Select all correct answers.";
    ActionDescription["MATCHING"] = "Select the matching pairs.";
})($44303f6c3c81eeac$export$cb9c858407602327 || ($44303f6c3c81eeac$export$cb9c858407602327 = {}));
const $44303f6c3c81eeac$var$QuizStatusToCheckboxType = {
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $44303f6c3c81eeac$var$QuizStatusToRadioType = {
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH = 480;
const $44303f6c3c81eeac$var$NAVBAR_HEIGHT = 124;
const $44303f6c3c81eeac$export$76709845c4fea6cd = ({ inspectMode: inspectMode , title: title , questions: questions = [] , onCompletion: onCompletion , step: step = 0 , setStep: setStep , onInteraction: onInteraction , isCompleted: isCompleted = false , setIsCompleted: setIsCompleted , isLoggedInUser: isLoggedInUser , handleUserLogin: handleUserLogin , lessonId: lessonId , onAnswerSubmit: onAnswerSubmit  })=>{
    const [questionAnswers, setQuestionAnswers] = (0, $hgUW1$useState)([]);
    const [selectedAnswers, setSelectedAnswers] = (0, $hgUW1$useState)([]);
    const [status, setStatus] = (0, $hgUW1$useState)($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
    const [answersStatus, setAnswersStatus] = (0, $hgUW1$useState)({});
    const [matchingAnswersStatus, setMatchingAnswersStatus] = (0, $hgUW1$useState)($44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT);
    const [correctAnswersArray, setCorrectAnswersArray] = (0, $hgUW1$useState)([]);
    const [incorrectAnswersArray, setIncorrectAnswersArray] = (0, $hgUW1$useState)([]);
    const [lastSubmittedQuestion, setLastSubmittedQuestion] = (0, $hgUW1$useState)({
        lessonId: "",
        step: 0
    });
    const width = (0, $3ced3ef7e9864bf1$export$4616d33c54ae5baf)();
    const isNextButtonDisabled = step + 1 !== questions.length ? !isCompleted && status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS : true;
    const isMatchingFeedbackVisible = questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && matchingAnswersStatus !== $44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT && !isCompleted;
    //set quiz status after initialization
    (0, $hgUW1$useEffect)(()=>{
        if (lastSubmittedQuestion.lessonId !== lessonId) setLastSubmittedQuestion({
            lessonId: lessonId,
            step: 0
        });
        if (isCompleted && lessonId && questions.length) {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
            onSubmittedQuestionsRecheck(questions.length - 1);
        } else {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
        }
    }, [
        lessonId,
        isCompleted
    ]);
    //set quiz last submitted question step after initialization
    (0, $hgUW1$useEffect)(()=>{
        setLastSubmittedQuestion((prevState)=>{
            if (prevState.lessonId === lessonId && !prevState.step) return {
                ...prevState,
                step: step
            };
            else return {
                ...prevState
            };
        });
    }, [
        step,
        lastSubmittedQuestion.lessonId
    ]);
    (0, $hgUW1$useEffect)(()=>{
        checkMatchingQuestionCompleted();
    }, [
        correctAnswersArray
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const isLastCompletedQuestion = status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS && lastSubmittedQuestion.step === questions.length;
        if (questions.length && !isLastCompletedQuestion) setQuestionAnswers(questions[step]?.answers);
    }, [
        step,
        questions
    ]);
    const handleOnAnswerSubmit = (type, status)=>{
        if (onAnswerSubmit) onAnswerSubmit(type, status);
    };
    const toggleAnswer = (answer)=>{
        onInteraction();
        if (status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT) return;
        if (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.SINGLE_SELECT) setSelectedAnswers([
            answer
        ]);
        if (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MULTI_SELECT) {
            if (selectedAnswers.includes(answer)) setSelectedAnswers((a)=>a.filter((ans)=>ans !== answer));
            else setSelectedAnswers((a)=>[
                    ...a,
                    answer
                ]);
        }
        if (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING) {
            if (isLoggedInUser) toggleMatchingQuestion(answer);
            else handleUserLogin();
        }
    };
    const toggleMatchingQuestion = (answer)=>{
        if (selectedAnswers.length && selectedAnswers[0].title !== answer.title && selectedAnswers[0].isLeftMatchingAnswer !== answer.isLeftMatchingAnswer) {
            if (selectedAnswers[0].matchingAnswer?.title === answer.title && !correctAnswersArray.includes(answer)) {
                const correctAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING, $44303f6c3c81eeac$export$602daccbd963b20.CORRECT);
                setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.CORRECT);
                setSelectedAnswers([
                    ...correctAnswers
                ]);
                setCorrectAnswersArray((a)=>[
                        ...a,
                        ...correctAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            } else {
                const incorrectAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING, $44303f6c3c81eeac$export$602daccbd963b20.INCORRECT);
                setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.INCORRECT);
                setSelectedAnswers([
                    ...incorrectAnswers
                ]);
                setIncorrectAnswersArray((a)=>[
                        ...a,
                        ...incorrectAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            }
        } else {
            setSelectedAnswers([
                answer
            ]);
            setIncorrectAnswersArray([]);
        }
    };
    const checkMatchingQuestionCompleted = ()=>{
        const leftAnswers = questions[step]?.leftAnswers;
        const rightAnswers = questions[step]?.rightAnswers;
        if (correctAnswersArray.length === leftAnswers?.length + rightAnswers?.length) {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
            const questionOnCompletion = questions[step]?.onCompletion;
            if (questionOnCompletion) questionOnCompletion();
            if (onCompletion && step + 1 === questions.length) {
                onCompletion();
                setIsCompleted(true);
            }
        }
    };
    const handleAnswerSubmit = ()=>{
        if (isLoggedInUser) onSubmit();
        else handleUserLogin();
    };
    const onSubmit = ()=>{
        const answers = questions[step]?.answers;
        const correctAnswers = answers.filter((ans)=>ans.correct);
        const totalSteps = questions.length;
        const questionOnCompletion = questions[step]?.onCompletion;
        const atLeastOneCorrectAnswer = !!correctAnswers.filter((ans)=>selectedAnswers.includes(ans)).length;
        if (correctAnswers.length === selectedAnswers.length && correctAnswers.every((ans)=>selectedAnswers.includes(ans))) {
            if (step + 1 === totalSteps) {
                /** completed quiz */ setIsCompleted(true);
                if (questionOnCompletion) questionOnCompletion();
                if (onCompletion) onCompletion();
            } else /** unfinished quiz */ if (questionOnCompletion) questionOnCompletion();
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
            handleOnAnswerSubmit(questions[step]?.type, $44303f6c3c81eeac$export$602daccbd963b20.CORRECT);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
        } else if (atLeastOneCorrectAnswer) {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT);
            handleOnAnswerSubmit(questions[step]?.type, $44303f6c3c81eeac$export$602daccbd963b20.PARTLY_CORRECT);
        } else {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR);
            handleOnAnswerSubmit(questions[step]?.type, $44303f6c3c81eeac$export$602daccbd963b20.INCORRECT);
        }
        setAnswersStatus(selectedAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: answers.find((a)=>a.title === curr.title)?.correct ? $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS : $44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onTryAgain = ()=>{
        const element = document.getElementById("quiz-question-container");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
        setSelectedAnswers([]);
        setAnswersStatus({});
        setQuestionAnswers((prevState)=>(0, $hgUW1$lodashshuffle)(prevState));
    };
    const onSubmittedQuestionsRecheck = (step)=>{
        const prevQuestionAnswers = questions[step].answers;
        const correctAnswers = prevQuestionAnswers.filter((answer)=>answer.correct);
        setStep(step);
        setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
        setSelectedAnswers(correctAnswers);
        setAnswersStatus(correctAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: questions[step].answers.find((a)=>a.title === curr.title)?.correct ? $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS : $44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onNextQuestionClick = ()=>{
        const nextQuestionStep = step + 1;
        const element = document.getElementById("quiz-question-container");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        if (nextQuestionStep < lastSubmittedQuestion.step || isCompleted) onSubmittedQuestionsRecheck(step + 1);
        else {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
            setCorrectAnswersArray([]);
            setStep(step + 1);
            setAnswersStatus({});
        }
    };
    const onPrevQuestionClick = ()=>{
        onInteraction();
        onSubmittedQuestionsRecheck(step - 1);
    };
    const getQuizProgress = ()=>{
        const progress = isCompleted ? questions.length : lastSubmittedQuestion.step;
        return progress / questions.length * 100;
    };
    const getInputStatus = (answer)=>{
        if (correctAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return (0, $b55544cdfa85935b$export$1bd2035254432789).CORRECT;
        if (incorrectAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return (0, $b55544cdfa85935b$export$1bd2035254432789).INCORRECT;
        if (correctAnswersArray.includes(answer) || status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS) return (0, $b55544cdfa85935b$export$1bd2035254432789).DISABLED;
        if (selectedAnswers.includes(answer)) return (0, $b55544cdfa85935b$export$1bd2035254432789).SELECTED;
        return (0, $b55544cdfa85935b$export$1bd2035254432789).DEFAULT;
    };
    const getAnswerStatus = (answer)=>!!selectedAnswers.find((a)=>a.title === answer.title);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $44303f6c3c81eeac$var$quizContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                css: $44303f6c3c81eeac$var$quizTitleStyles,
                children: title
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $44303f6c3c81eeac$var$quizContentContainerStyles,
                id: "quiz-question-container",
                "data-testid": "quiz-question-container",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $44303f6c3c81eeac$var$quizHeaderContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $44303f6c3c81eeac$var$quizActionPanelContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "back-button",
                                        disabled: !step,
                                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "arrow-left-circle"
                                        }),
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                        onClick: onPrevQuestionClick,
                                        iconType: "arrow-left-circle"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                                        css: $44303f6c3c81eeac$var$questionsStepStyles,
                                        children: [
                                            "QUESTION ",
                                            step + 1,
                                            " 0F ",
                                            questions.length
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                        css: $44303f6c3c81eeac$var$desktopScreenProgressContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $915f5687b3b07750$export$c17561cb55d4db30), {
                                            progress: getQuizProgress()
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "next-button",
                                        disabled: isNextButtonDisabled,
                                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "arrow-right-circle"
                                        }),
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                        onClick: onNextQuestionClick,
                                        iconType: "arrow-right-circle"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $44303f6c3c81eeac$var$mobileScreenProgressContainerStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $915f5687b3b07750$export$c17561cb55d4db30), {
                                    progress: getQuizProgress()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", questions[step]?.inspectMode),
                        css: $44303f6c3c81eeac$var$questionTitleStyles,
                        children: questions[step]?.title
                    }),
                    questions[step] && questions[step].imageUrl && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $44303f6c3c81eeac$var$questionImageStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                            src: questions[step].imageUrl,
                            alt: questions[step]?.title.props.children
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $44303f6c3c81eeac$var$chooseCorrectAnswerStyles,
                        children: $44303f6c3c81eeac$export$cb9c858407602327[questions[step]?.type]
                    }),
                    questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        children: questions[step]?.leftAnswers?.map((leftAnswer, index)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $44303f6c3c81eeac$var$quizInputsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $b55544cdfa85935b$export$56e6c05354470c53), {
                                        inspectMode: leftAnswer?.inspectMode,
                                        elementId: leftAnswer.title,
                                        text: leftAnswer.title,
                                        onClick: ()=>toggleAnswer(leftAnswer),
                                        inputStatus: getInputStatus(leftAnswer)
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $b55544cdfa85935b$export$56e6c05354470c53), {
                                        inspectMode: questions[step]?.rightAnswers?.[index]?.inspectMode,
                                        elementId: questions[step]?.rightAnswers?.[index]?.title,
                                        text: questions[step]?.rightAnswers?.[index]?.title,
                                        onClick: ()=>toggleAnswer(questions[step]?.rightAnswers?.[index]),
                                        inputStatus: getInputStatus(questions[step]?.rightAnswers?.[index])
                                    })
                                ]
                            }, leftAnswer.title + questions[step]?.rightAnswers?.[index]?.title))
                    }),
                    (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.SINGLE_SELECT || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MULTI_SELECT) && questionAnswers?.map((answer)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $44303f6c3c81eeac$var$answerContainerStyles,
                            ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", answer?.inspectMode),
                            children: questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.SINGLE_SELECT ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3fbcb32390ca7008$export$d7b12c4107be0d61), {
                                size: width >= $44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? (0, $3fbcb32390ca7008$export$4da24539a3bb7d98).LARGE : (0, $3fbcb32390ca7008$export$4da24539a3bb7d98).DEFAULT,
                                label: answer.title,
                                isChecked: getAnswerStatus(answer),
                                setIsChecked: ()=>toggleAnswer(answer),
                                type: $44303f6c3c81eeac$var$QuizStatusToRadioType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d501466973a9f0a6$export$48513f6b9f8ce62d), {
                                size: width >= $44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? (0, $d501466973a9f0a6$export$5e435bc8b081a399).LARGE : (0, $d501466973a9f0a6$export$5e435bc8b081a399).DEFAULT,
                                label: answer.title,
                                onChange: ()=>toggleAnswer(answer),
                                isChecked: getAnswerStatus(answer),
                                type: $44303f6c3c81eeac$var$QuizStatusToCheckboxType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            })
                        }, answer.title)),
                    !isCompleted && status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT && questions[step]?.type !== $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: [
                            $44303f6c3c81eeac$var$buttonContainerStyles,
                            (0, $hgUW1$css)({
                                borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`,
                                paddingTop: "32px"
                            })
                        ],
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                            label: "Submit answer",
                            appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                            onClick: handleAnswerSubmit,
                            disabled: selectedAnswers.length === 0 || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING
                        })
                    }),
                    (status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING) && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $44303f6c3c81eeac$var$buttonContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: [
                                $44303f6c3c81eeac$var$feedbackContainerStyles,
                                status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS && (0, $hgUW1$css)({
                                    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
                                })
                            ],
                            children: [
                                status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $81dd635d83decaee$export$f23c56ac9ab316f), {
                                    title: questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING ? "Correct" : "That’s correct",
                                    appearance: (0, $81dd635d83decaee$export$f9292ef28b7b429a).CORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (!isCompleted || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && !isCompleted) && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        marginTop: "32px"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        disabled: status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS,
                                        label: "Next question",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: onNextQuestionClick,
                                        iconAfter: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "arrow-right"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR || status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT) && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $44303f6c3c81eeac$var$buttonContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $44303f6c3c81eeac$var$feedbackContainerStyles,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $81dd635d83decaee$export$f23c56ac9ab316f), {
                                    title: status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT ? "That’s partly correct" : "That’s not correct",
                                    appearance: (0, $81dd635d83decaee$export$f9292ef28b7b429a).INCORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        marginTop: "32px"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Try again",
                                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "refresh"
                                        }),
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: onTryAgain
                                    })
                                })
                            ]
                        })
                    }),
                    isCompleted && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $44303f6c3c81eeac$var$completionMessageStyles,
                        children: "\uD83C\uDF89 Quiz complete! Great work."
                    })
                ]
            }),
            isMatchingFeedbackVisible && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $44303f6c3c81eeac$var$matchingFeedbackContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $81dd635d83decaee$export$f23c56ac9ab316f), {
                    title: matchingAnswersStatus === $44303f6c3c81eeac$export$85e3e62cc743c830.INCORRECT ? "That’s incorrect" : "That’s correct",
                    appearance: matchingAnswersStatus === $44303f6c3c81eeac$export$85e3e62cc743c830.INCORRECT ? (0, $81dd635d83decaee$export$f9292ef28b7b429a).INCORRECT : (0, $81dd635d83decaee$export$f9292ef28b7b429a).CORRECT
                })
            })
        ]
    });
};
const $44303f6c3c81eeac$var$quizContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $44303f6c3c81eeac$var$quizContentContainerStyles = (0, $hgUW1$css)({
    padding: "32px 48px",
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    maxWidth: "720px",
    width: "100%",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    [(0, $hgUW1$media1).below.md]: {
        maxWidth: "720px",
        width: "100%"
    },
    [(0, $hgUW1$media1).below.xs]: {
        padding: "24px 16px"
    }
});
const $44303f6c3c81eeac$var$quizHeaderContainerStyles = (0, $hgUW1$css)({
    marginBottom: "32px",
    paddingBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    flexDirection: "row",
    [(0, $hgUW1$media1).below.sm]: {
        flexDirection: "column"
    },
    [(0, $hgUW1$media1).below.xs]: {
        marginBottom: "24px",
        paddingBottom: "24px"
    }
});
const $44303f6c3c81eeac$var$quizActionPanelContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $44303f6c3c81eeac$var$quizTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
    [(0, $hgUW1$media1).below.xs]: {
        display: "none"
    }
});
const $44303f6c3c81eeac$var$questionTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    color: (0, $hgUW1$token)("color.text"),
    marginTop: 0,
    marginBottom: "32px",
    [(0, $hgUW1$media1).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "24px"
    }
});
const $44303f6c3c81eeac$var$questionImageStyles = (0, $hgUW1$css)({
    padding: "24px 0"
});
const $44303f6c3c81eeac$var$desktopScreenProgressContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    margin: "0 24px 0 13px",
    [(0, $hgUW1$media1).below.sm]: {
        display: "none"
    }
});
const $44303f6c3c81eeac$var$mobileScreenProgressContainerStyles = (0, $hgUW1$css)({
    [(0, $hgUW1$media1).below.sm]: {
        width: "100%",
        margin: 0,
        marginTop: "12px"
    }
});
const $44303f6c3c81eeac$var$chooseCorrectAnswerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text.subtlest"),
    marginTop: 0,
    marginBottom: "24px",
    [(0, $hgUW1$media1).below.xs]: {
        fontSize: "14px",
        lineHeight: "22px",
        marginBottom: "16px"
    }
});
const $44303f6c3c81eeac$var$answerContainerStyles = (0, $hgUW1$css)({
    marginBottom: "24px",
    [(0, $hgUW1$media1).below.xs]: {
        marginBottom: "20px"
    }
});
const $44303f6c3c81eeac$var$quizInputsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    marginTop: "24px"
});
const $44303f6c3c81eeac$var$buttonContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    [(0, $hgUW1$media1).below.xs]: {
        marginTop: "24px"
    }
});
const $44303f6c3c81eeac$var$feedbackContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $44303f6c3c81eeac$var$questionsStepStyles = (0, $hgUW1$css)({
    minWidth: "115px",
    marginLeft: "24px",
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});
const $44303f6c3c81eeac$var$completionMessageStyles = (0, $hgUW1$css)({
    marginTop: "40px",
    marginBottom: 0,
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center"
});
const $44303f6c3c81eeac$var$matchingFeedbackContainerStyles = (0, $hgUW1$css)({
    marginTop: "40px",
    maxWidth: "624px",
    width: "100%",
    [(0, $hgUW1$media1).below.xs]: {
        display: "none"
    }
});


var $9c3f769544bb2079$exports = {};

$parcel$export($9c3f769544bb2079$exports, "Sidebar", () => $9c3f769544bb2079$export$1ba59dacbcbf90fe);





const $9c3f769544bb2079$export$1ba59dacbcbf90fe = ({ onChangeMenuVisibility: onChangeMenuVisibility , isVisible: isVisible = true , children: children  })=>{
    const toggleMenu = ()=>{
        if (onChangeMenuVisibility) onChangeMenuVisibility(!isVisible);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $9c3f769544bb2079$var$sidebarNavContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                "data-testid": "button-toggle-menu-toggle",
                css: [
                    $9c3f769544bb2079$var$buttonToggleMenuStyles,
                    !isVisible && $9c3f769544bb2079$var$buttonToggleMenuClosedStyles,
                    isVisible && $9c3f769544bb2079$var$buttonToggleMenuOpenStyles
                ],
                onClick: toggleMenu,
                "aria-label": "toggle menu",
                children: isVisible ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-left",
                    color: (0, $hgUW1$token)("color.icon")
                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-right",
                    color: (0, $hgUW1$token)("color.icon")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                    "data-testid": "button-toggle-menu-show",
                    css: $9c3f769544bb2079$var$mobileButtonToggleMenuStyles,
                    onClick: toggleMenu,
                    "aria-label": "show menu",
                    children: [
                        isVisible ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "dropdown-cross",
                            color: (0, $hgUW1$token)("color.icon")
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "menu-icon",
                            color: (0, $hgUW1$token)("color.icon")
                        }),
                        isVisible ? /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: (0, $hgUW1$css)({
                                span: {
                                    color: (0, $hgUW1$token)("color.icon")
                                }
                            }),
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                children: "Close"
                            })
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: (0, $hgUW1$css)({
                                span: {
                                    color: (0, $hgUW1$token)("color.icon")
                                }
                            }),
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                children: "Menu"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    isVisible && $9c3f769544bb2079$var$sidebarOpenStyles,
                    !isVisible && $9c3f769544bb2079$var$sidebarClosedStyles,
                    $9c3f769544bb2079$var$sidebarStyles
                ],
                "data-testid": "sidebar",
                children: isVisible && children
            })
        ]
    });
};
const $9c3f769544bb2079$var$sidebarNavContainerStyles = (0, $hgUW1$css)({
    position: "absolute",
    height: "100%",
    opacity: 1,
    display: "block",
    transform: "translateX(0px)",
    [(0, $hgUW1$media1).below.sm]: {
        width: "100%",
        position: "absolute"
    }
});
const $9c3f769544bb2079$var$sidebarStyles = (0, $hgUW1$css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    height: "100%",
    paddingTop: "1.75rem",
    paddingRight: "7px",
    paddingLeft: "0.5rem",
    top: 0,
    bottom: 0,
    left: 0,
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: (0, $hgUW1$token)("color.border"),
    borderTop: "none",
    borderLeft: "none",
    backgroundColor: (0, $hgUW1$token)("elevation.surface.sunken"),
    overflowY: "auto",
    overflowX: "hidden"
});
const $9c3f769544bb2079$var$sidebarClosedStyles = (0, $hgUW1$css)({
    width: "1.25rem",
    [(0, $hgUW1$media1).below.sm]: {
        top: 0,
        borderRightWidth: 0,
        paddingTop: 0,
        height: 0,
        width: "100%",
        position: "absolute"
    }
});
const $9c3f769544bb2079$var$sidebarOpenStyles = (0, $hgUW1$css)({
    display: "block",
    transform: "translateX(0px)",
    paddingTop: "1.75rem",
    position: "fixed",
    [(0, $hgUW1$media1).below.sm]: {
        width: "100vw",
        marginTop: "3rem",
        position: "absolute"
    },
    [(0, $hgUW1$media1).above.sm]: {
        width: "26.25rem",
        position: "absolute"
    },
    [(0, $hgUW1$media1).below.md]: {
        boxShadow: `0 0 0 10000px ${(0, $hgUW1$token)("color.blanket")}`
    },
    [(0, $hgUW1$media1).above.lg]: {
        position: "relative",
        boxShadow: "none"
    }
});
const $9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles = (0, $hgUW1$css)({
    display: "none",
    alignItems: "center",
    justifyContent: "align-start",
    width: "100vw",
    paddingLeft: "1rem",
    height: "3rem",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    position: "relative",
    zIndex: 200,
    [(0, $hgUW1$media1).below.sm]: {
        display: "flex"
    }
});
const $9c3f769544bb2079$var$mobileButtonToggleMenuStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    outline: "none"
});
const $9c3f769544bb2079$var$buttonToggleMenuStyles = (0, $hgUW1$css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    border: "none",
    borderRadius: "9999px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
    position: "absolute",
    top: "1.75rem",
    zIndex: 200,
    cursor: "pointer",
    [(0, $hgUW1$media1).below.sm]: {
        display: "none"
    }
});
const $9c3f769544bb2079$var$buttonToggleMenuOpenStyles = (0, $hgUW1$css)({
    marginLeft: "25.5rem"
});
const $9c3f769544bb2079$var$buttonToggleMenuClosedStyles = (0, $hgUW1$css)({
    marginLeft: "0.5rem"
});


var $764442aba3de2fce$exports = {};

$parcel$export($764442aba3de2fce$exports, "Video", () => $764442aba3de2fce$export$ae01dedf5c052bb);







const $764442aba3de2fce$var$MOBILE_SCREEN_WIDTH = 480;
const $764442aba3de2fce$export$ae01dedf5c052bb = ({ brandfolderUrl: brandfolderUrl , orangeUrl: orangeUrl , vimeoUrl: vimeoUrl , youtubeUrl: youtubeUrl , captions: captions , chapters: chapters , controls: controls , width: width , height: height , videoId: videoId , name: name , poster: poster = "" , onControlClick: onControlClick , onProgressUpdate: onProgressUpdate , onError: onError  })=>{
    const videoRef = (0, $hgUW1$useRef)(null);
    const deviceSize = (0, $3ced3ef7e9864bf1$export$4616d33c54ae5baf)();
    const videoSrc = (0, $hgUW1$useMemo)(()=>orangeUrl || brandfolderUrl || vimeoUrl || youtubeUrl, [
        orangeUrl,
        brandfolderUrl,
        vimeoUrl,
        youtubeUrl
    ]);
    const playerSource = {
        type: "video",
        sources: [
            {
                src: videoSrc
            }
        ],
        tracks: [
            {
                kind: "captions",
                label: "English",
                srcLang: "en",
                src: captions,
                default: true
            }
        ]
    };
    const playerOptions = {
        invertTime: false,
        tooltips: {
            controls: true,
            seek: true
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "captions",
            "rewind",
            "fast-forward",
            "mute",
            "volume",
            "settings",
            "pip",
            "fullscreen",
            "seektime"
        ],
        quality: {
            default: 1080,
            options: [
                1080,
                720,
                576,
                480,
                360,
                240
            ]
        },
        markers: {
            enabled: true,
            points: chapters
        }
    };
    const playerOptionsMobile = {
        invertTime: false,
        tooltips: {
            controls: true,
            seek: true
        },
        controls: [
            "play-small",
            "play",
            "progress",
            "current-time",
            "rewind",
            "fast-forward",
            "mute",
            "volume",
            "settings",
            "fullscreen",
            "seektime"
        ],
        quality: {
            default: 1080,
            options: [
                1080,
                720,
                576,
                480,
                360,
                240
            ]
        },
        markers: {
            enabled: true,
            points: chapters
        }
    };
    const addEvents = (0, $hgUW1$useCallback)((instance)=>{
        instance.once("loadeddata", ()=>{
            addEvent(instance, "play");
            addEvent(instance, "pause");
            addEvent(instance, "captionsenabled");
            addEvent(instance, "captionsdisabled");
        });
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2), name, videoId);
        });
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onError
    ]);
    const addEvent = (0, $hgUW1$useCallback)((instance, event)=>instance.on(event, ()=>onControlClick && onControlClick(event)), []);
    (0, $hgUW1$useEffect)(()=>{
        const isMobileSize = deviceSize <= $764442aba3de2fce$var$MOBILE_SCREEN_WIDTH;
        const player = new (0, $hgUW1$plyrdistplyr)(videoRef.current, isMobileSize ? playerOptionsMobile : playerOptions);
        player.source = playerSource;
        player.poster = poster;
        addEvents(player);
        const plyrVideoContainers = document.getElementsByClassName("plyr--video");
        if (plyrVideoContainers.length) Array.from(plyrVideoContainers).forEach((el)=>el.role = "presentation");
    }, []);
    if (videoSrc === vimeoUrl) return /*#__PURE__*/ (0, $hgUW1$jsx)("iframe", {
        role: "document",
        title: "video",
        tabIndex: 0,
        css: (0, $hgUW1$css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
            }
        }),
        src: vimeoUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else if (videoSrc === youtubeUrl) return /*#__PURE__*/ (0, $hgUW1$jsx)("iframe", {
        role: "document",
        title: "video",
        tabIndex: 0,
        css: (0, $hgUW1$css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
            }
        }),
        src: youtubeUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $764442aba3de2fce$var$videoPlayerStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("video", {
            tabIndex: 0,
            ref: videoRef,
            width: width,
            height: height,
            controls: controls,
            crossOrigin: "anonymous",
            title: "video",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("track", {
                    src: captions,
                    kind: "captions",
                    label: "captions",
                    srcLang: "en",
                    default: true
                })
            ]
        })
    });
};
const $764442aba3de2fce$var$videoPlayerStyles = (0, $hgUW1$css)({
    ".plyr__time": {
        fontSize: "12px !important",
        fontWeight: "600 !important"
    },
    "--plyr-color-main": "#1D7AFC",
    "--plyr-badge-background": (0, $hgUW1$N800),
    "--plyr-audio-control-color": (0, $hgUW1$N800),
    "--plyr-menu-color": (0, $hgUW1$N800),
    "--plyr-menu-item-arrow-color": "#758195",
    "--plyr-menu-border-color": "#DCDFE4",
    "--plyr-tooltip-color": (0, $hgUW1$N800),
    ":focus-visible": {
        border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});



var $77282b3961d82199$exports = {};

$parcel$export($77282b3961d82199$exports, "Columns", () => $77282b3961d82199$export$f02cc02ad0e0bba3);
$parcel$export($77282b3961d82199$exports, "LessonColumns", () => $77282b3961d82199$export$2dde675552f76fc5);



let $77282b3961d82199$export$f02cc02ad0e0bba3;
(function(Columns) {
    Columns["TWO"] = "two";
    Columns["THREE"] = "three";
    Columns["FOUR"] = "four";
})($77282b3961d82199$export$f02cc02ad0e0bba3 || ($77282b3961d82199$export$f02cc02ad0e0bba3 = {}));
const $77282b3961d82199$export$2dde675552f76fc5 = ({ columns: columns = $77282b3961d82199$export$f02cc02ad0e0bba3.TWO , children: children  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("section", {
        css: $77282b3961d82199$var$sectionStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            "data-testid": "lesson-columns",
            css: [
                $77282b3961d82199$var$lessonColumnsStyles,
                $77282b3961d82199$var$lessonColumnsMDStyles[columns]
            ],
            children: children
        })
    });
const $77282b3961d82199$var$sectionStyles = (0, $hgUW1$css)({
    textOverflow: "ellipsis",
    [(0, $hgUW1$media1).above.lg]: {
        textOverflow: "clip"
    }
});
const $77282b3961d82199$var$lessonColumnsStyles = (0, $hgUW1$css)({
    display: "grid",
    columnGap: "0.5rem",
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    fontSize: "16px",
    [(0, $hgUW1$media1).above.xs]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
});
const $77282b3961d82199$var$lessonColumnsMDStyles = {
    [$77282b3961d82199$export$f02cc02ad0e0bba3.TWO]: (0, $hgUW1$css)({
        [(0, $hgUW1$media1).above.sm]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }
    }),
    [$77282b3961d82199$export$f02cc02ad0e0bba3.THREE]: (0, $hgUW1$css)({
        [(0, $hgUW1$media1).above.sm]: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }
    }),
    [$77282b3961d82199$export$f02cc02ad0e0bba3.FOUR]: (0, $hgUW1$css)({
        [(0, $hgUW1$media1).above.sm]: {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }
    })
};



var $4c35f7fd4ad5f13f$exports = {};

$parcel$export($4c35f7fd4ad5f13f$exports, "LearningCourseCard", () => $4c35f7fd4ad5f13f$export$5ae3342de8088f07);









const $4c35f7fd4ad5f13f$export$5ae3342de8088f07 = ({ inspectMode: inspectMode , title: title , imageUrl: imageUrl , onClick: onClick , link: link , minHeight: minHeight = 153 , learningProgress: learningProgress , onGeneratePdf: onGeneratePdf , shouldDisplayShareButton: shouldDisplayShareButton , shouldDisplayBookmark: shouldDisplayBookmark  })=>{
    const onClickHandler = (0, $hgUW1$useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick,
        link
    ]);
    const onKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(onClickHandler), [
        onClickHandler
    ]);
    const handleSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const isSaved = learningProgress?.completedResources === learningProgress?.resourceCount || learningProgress?.isSaved;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        href: link,
        css: $4c35f7fd4ad5f13f$var$linkContainerStyles,
        rel: "noopener noreferrer",
        onClick: (e)=>e.preventDefault(),
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles,
            onClick: onClickHandler,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            "data-testid": "learning-course-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $4c35f7fd4ad5f13f$var$bodyContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $4c35f7fd4ad5f13f$var$imageContainerStyles,
                            children: imageUrl ? /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                                css: [
                                    $4c35f7fd4ad5f13f$var$imageStyles
                                ],
                                "data-testid": "learning-course-card-image",
                                src: imageUrl,
                                alt: "course-img"
                            }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                "data-testid": "learning-course-card-no-image",
                                css: $4c35f7fd4ad5f13f$var$noImageStyles
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles,
                            children: title && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                "data-testid": "title",
                                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                                css: $4c35f7fd4ad5f13f$var$titleStyles,
                                children: title
                            })
                        })
                    ]
                }),
                learningProgress && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles,
                    "data-testid": "learning-course-card-progress-content",
                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d8ee29df49af8811$export$184a993f673fc83f), {
                                completedResources: learningProgress.completedResources,
                                resourceCount: learningProgress.resourceCount,
                                completionDate: learningProgress.completionDate,
                                contentType: (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles,
                                children: [
                                    shouldDisplayShareButton && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                        urlToShare: link,
                                        alignToLeft: true,
                                        shareOnFb: false,
                                        shareOnLinkedin: false,
                                        showCopyLink: false,
                                        shareOnPdf: true,
                                        onGeneratePdf: onGeneratePdf
                                    }),
                                    shouldDisplayBookmark && /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                        "data-testid": "save-content",
                                        css: $4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles,
                                        onClick: handleSave,
                                        children: isSaved ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "bookmark-filled"
                                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "bookmark"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    width: "100%",
    height: "153px",
    "&:hover": {
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`,
        border: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`
    }
});
const $4c35f7fd4ad5f13f$var$bodyContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.075")}`,
    gap: (0, $hgUW1$token)("space.200"),
    minHeight: "96px",
    justifyContent: "flex-end",
    "@media (max-width: 1279px)": {
        justifyContent: "flex-start",
        padding: `${(0, $hgUW1$token)("space.050")} ${(0, $hgUW1$token)("space.050")} ${(0, $hgUW1$token)("space.050")} ${(0, $hgUW1$token)("space.200")}`
    }
});
const $4c35f7fd4ad5f13f$var$linkContainerStyles = (0, $hgUW1$css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $4c35f7fd4ad5f13f$var$imageContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "64px",
    height: "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0
});
const $4c35f7fd4ad5f13f$var$imageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%"
});
const $4c35f7fd4ad5f13f$var$noImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("color.background.accent.gray.subtlest"),
    width: "64px",
    height: "64px",
    borderRadius: "50%"
});
const $4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "275px",
    "@media (max-width: 1279px)": {
        width: "232px",
        flexGrow: 1,
        padding: `${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.0")}`
    }
});
const $4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles = (0, $hgUW1$css)({
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.300")}`
});
const $4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: (0, $hgUW1$token)("space.300")
});
const $4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles = (0, $hgUW1$css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $4c35f7fd4ad5f13f$var$titleStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "20px",
    marginBottom: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text")
});



var $27d686e47ff412fd$exports = {};

$parcel$export($27d686e47ff412fd$exports, "FeedbackHeader", () => $27d686e47ff412fd$export$41cd510048068b0c);





const $27d686e47ff412fd$export$41cd510048068b0c = ({ heading: heading , duration: duration , description: description  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("section", {
        "aria-labelledby": "feedback-header",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$headingWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("h1", {
                    css: $27d686e47ff412fd$var$headingStyles,
                    id: "feedback-header",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$metadataStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $27d686e47ff412fd$var$flexContainerStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: (0, $hgUW1$css)({
                            display: "flex"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $27d686e47ff412fd$var$tagStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                    label: duration
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $27d686e47ff412fd$var$tagStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                    label: "survey"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$lineWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$token)("color.border")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$descriptionStyles,
                children: description
            })
        ]
    });
const $27d686e47ff412fd$var$metadataStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $27d686e47ff412fd$var$flexContainerStyles = (0, $hgUW1$css)({
    display: "flex"
});
const $27d686e47ff412fd$var$tagStyles = (0, $hgUW1$css)({
    marginRight: (0, $hgUW1$token)("space.100")
});
const $27d686e47ff412fd$var$lineWrapperStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.300")} 0 ${(0, $hgUW1$token)("space.500")} 0`
});
const $27d686e47ff412fd$var$headingWrapperStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.1000")} 0 ${(0, $hgUW1$token)("space.300")} 0`
});
const $27d686e47ff412fd$var$headingStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "61.333px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "81.778px"
});
const $27d686e47ff412fd$var$descriptionStyles = (0, $hgUW1$css)({
    paddingBottom: (0, $hgUW1$token)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    p: {
        margin: 0
    }
});


var $a4deb03146bf3bfc$exports = {};

$parcel$export($a4deb03146bf3bfc$exports, "ReportIssueModal", () => $a4deb03146bf3bfc$export$448811829c5d1992);











let $a4deb03146bf3bfc$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($a4deb03146bf3bfc$var$DialogWidth || ($a4deb03146bf3bfc$var$DialogWidth = {}));
const $a4deb03146bf3bfc$export$448811829c5d1992 = ({ isParticipatingInResearch: isParticipatingInResearch , consentToContact: consentToContact , selectValue: selectValue , textAreaValues: textAreaValues , heading: heading , width: width = $a4deb03146bf3bfc$var$DialogWidth.LARGE , options: options , isDisabled: isDisabled , closeModal: closeModal , submit: submit , onSelectChange: onSelectChange , onTextChange: onTextChange , onParticipatingInResearch: onParticipatingInResearch , onConsentToContact: onConsentToContact  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: closeModal,
        width: width,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $a4deb03146bf3bfc$var$modalContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $a4deb03146bf3bfc$var$modalBodyStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            "data-testid": "modal-heading",
                            css: $a4deb03146bf3bfc$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $a4deb03146bf3bfc$var$requiredFieldsStyles,
                            children: [
                                "Required fields are marked with an asterisk",
                                " ",
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: [
                                        $a4deb03146bf3bfc$var$requiredFieldsStyles,
                                        (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text.accent.red")
                                        })
                                    ],
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: (0, $hgUW1$css)({
                                marginBottom: (0, $hgUW1$token)("space.050")
                            }),
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Label), {
                                htmlFor: "problem-to-report",
                                children: [
                                    "What problem would you like to report? ",
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                        css: (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text.accent.red")
                                        }),
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $a4deb03146bf3bfc$var$selectContainerStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitselect), {
                                inputId: "problem-to-report",
                                options: options,
                                value: selectValue,
                                onChange: (e)=>onSelectChange(e),
                                placeholder: "Select problem"
                            })
                        }),
                        selectValue && /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: (0, $hgUW1$css)({
                                        marginBottom: (0, $hgUW1$token)("space.050")
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Label), {
                                        htmlFor: "problem-to-report",
                                        children: [
                                            "Provide any other details ",
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                                css: (0, $hgUW1$css)({
                                                    color: (0, $hgUW1$token)("color.text.accent.red")
                                                }),
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $a4deb03146bf3bfc$var$detailsStyles,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskittextarea), {
                                        maxHeight: "156px",
                                        placeholder: "Start typing...",
                                        onChange: onTextChange,
                                        value: textAreaValues
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: (0, $hgUW1$css)({
                                        marginBottom: (0, $hgUW1$token)("space.100")
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d501466973a9f0a6$export$48513f6b9f8ce62d), {
                                        label: "I'd like to participate in product research",
                                        onChange: onParticipatingInResearch,
                                        isChecked: isParticipatingInResearch
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $a4deb03146bf3bfc$var$policyContainerStyles,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d501466973a9f0a6$export$48513f6b9f8ce62d), {
                                        label: /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                                            children: [
                                                "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy",
                                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                                                    label: "Atlassian Privacy Policy.",
                                                    target: "_blank",
                                                    link: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                    onClick: ()=>{
                                                        window.open("https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers", "_blank", "noopener");
                                                    }
                                                })
                                            ]
                                        }),
                                        onChange: onConsentToContact,
                                        isChecked: consentToContact
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                    css: $a4deb03146bf3bfc$var$modalCloseButtonStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $a4deb03146bf3bfc$var$customButtonWrapperStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SUBTLE,
                                onClick: closeModal,
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                            label: "Submit",
                            appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                            disabled: isDisabled,
                            onClick: submit
                        })
                    ]
                })
            ]
        })
    });
const $a4deb03146bf3bfc$var$modalContainerStyles = (0, $hgUW1$css)({
    padding: (0, $hgUW1$token)("space.300"),
    [(0, $hgUW1$media1).below.sm]: {
        padding: (0, $hgUW1$token)("space.200")
    }
});
const $a4deb03146bf3bfc$var$modalHeadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px"
});
const $a4deb03146bf3bfc$var$requiredFieldsStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $a4deb03146bf3bfc$var$selectContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    maxWidth: "420px",
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $a4deb03146bf3bfc$var$detailsStyles = (0, $hgUW1$css)({
    width: "100%",
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $a4deb03146bf3bfc$var$modalCloseButtonStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "flex-end",
    [(0, $hgUW1$media1).below.sm]: {
        padding: (0, $hgUW1$token)("space.100")
    }
});
const $a4deb03146bf3bfc$var$modalBodyStyles = (0, $hgUW1$css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: `${(0, $hgUW1$token)("space.200")} auto 0`,
    [(0, $hgUW1$media1).below.sm]: {
        marginTop: 0
    }
});
const $a4deb03146bf3bfc$var$customButtonWrapperStyles = (0, $hgUW1$css)({
    marginRight: (0, $hgUW1$token)("space.100"),
    button: {
        height: "100%",
        color: (0, $hgUW1$token)("color.text"),
        fontSize: "16px",
        lineHeight: "20px",
        padding: `10px ${(0, $hgUW1$token)("space.150")}`,
        fontWeight: 600
    }
});
const $a4deb03146bf3bfc$var$policyContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    a: {
        marginLeft: "5px"
    }
});


var $0ae392c3008c8a3e$exports = {};

$parcel$export($0ae392c3008c8a3e$exports, "FlatContentCardStyle", () => $0ae392c3008c8a3e$export$f2adaabc3a0295ef);
$parcel$export($0ae392c3008c8a3e$exports, "FlatContentCardType", () => $0ae392c3008c8a3e$export$8023ea0baf29b8db);
$parcel$export($0ae392c3008c8a3e$exports, "FlatContentCard", () => $0ae392c3008c8a3e$export$bc8a9d98c2eabbb7);






let $0ae392c3008c8a3e$export$f2adaabc3a0295ef;
(function(FlatContentCardStyle) {
    FlatContentCardStyle["TALL"] = "tall";
    FlatContentCardStyle["FULL"] = "full";
})($0ae392c3008c8a3e$export$f2adaabc3a0295ef || ($0ae392c3008c8a3e$export$f2adaabc3a0295ef = {}));
let $0ae392c3008c8a3e$export$8023ea0baf29b8db;
(function(FlatContentCardType) {
    FlatContentCardType["ROUND"] = "round";
    FlatContentCardType["SQUARE"] = "square";
    FlatContentCardType["RECTANGLE"] = "rectangle";
})($0ae392c3008c8a3e$export$8023ea0baf29b8db || ($0ae392c3008c8a3e$export$8023ea0baf29b8db = {}));
const $0ae392c3008c8a3e$export$bc8a9d98c2eabbb7 = ({ image: image , title: title , text: text , link: link , linkLabel: linkLabel = "Learn more" , style: style = $0ae392c3008c8a3e$export$f2adaabc3a0295ef.TALL , type: type = $0ae392c3008c8a3e$export$8023ea0baf29b8db.ROUND , headingLevel: headingLevel , bgColor: bgColor = "initial" , onClick: onClick , target: target = "_self" , maxWidth: maxWidth  })=>{
    const isSquareOrRectangle = type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.SQUARE || type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.RECTANGLE;
    const roundStyles = image ? $0ae392c3008c8a3e$var$variantStyles[style].container.withImage : $0ae392c3008c8a3e$var$variantStyles[style].container.withoutImage;
    const additionalContainerStyles = isSquareOrRectangle ? $0ae392c3008c8a3e$var$squareTypeStyles.container : roundStyles;
    const defaultHeadingLevel = isSquareOrRectangle ? 3 : 4;
    const rectangleStyles = type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.RECTANGLE && $0ae392c3008c8a3e$var$variantStyles[$0ae392c3008c8a3e$export$f2adaabc3a0295ef.TALL].container.withImage;
    const handleClick = (title)=>{
        onClick && onClick(title);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $0ae392c3008c8a3e$var$containerStyles,
            additionalContainerStyles,
            rectangleStyles,
            (0, $hgUW1$css)({
                backgroundColor: bgColor
            }),
            maxWidth && (0, $hgUW1$css)({
                maxWidth: maxWidth
            })
        ],
        "data-testid": "learn-more-card",
        children: [
            image && /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                src: image.src,
                alt: image.alt,
                css: [
                    $0ae392c3008c8a3e$var$imageBaseStyles,
                    isSquareOrRectangle && $0ae392c3008c8a3e$var$imageSquareStyles,
                    style === $0ae392c3008c8a3e$export$f2adaabc3a0295ef.FULL && $0ae392c3008c8a3e$var$fullStyleImageStyles
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: [
                    $0ae392c3008c8a3e$var$contentContainerStyles,
                    isSquareOrRectangle && $0ae392c3008c8a3e$var$contentContainerSquareStyles
                ],
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: (0, $hgUW1$css)([
                            $0ae392c3008c8a3e$var$textStyles,
                            type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.ROUND && $0ae392c3008c8a3e$var$variantStyles[style].heading,
                            isSquareOrRectangle && $0ae392c3008c8a3e$var$squareTypeStyles.heading
                        ]),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: headingLevel || defaultHeadingLevel,
                            children: title,
                            fontWeight: 600
                        })
                    }),
                    type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.ROUND && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: [
                            (0, $hgUW1$css)([
                                $0ae392c3008c8a3e$var$textStyles,
                                $0ae392c3008c8a3e$var$variantStyles[style].text,
                                $0ae392c3008c8a3e$var$textContainerStyles
                            ])
                        ],
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                        label: linkLabel,
                        link: link,
                        onClick: ()=>handleClick(title),
                        icon: "arrow-right",
                        fontColor: (0, $hgUW1$token)("color.text.brand"),
                        style: (0, $4fce8dfc4ce8f546$export$2b77966d73aefa77).SEMIBOLD,
                        size: (0, $4fce8dfc4ce8f546$export$be4c932f76c19adf).LARGE,
                        target: target
                    })
                ]
            })
        ]
    });
};
const $0ae392c3008c8a3e$var$containerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: `${(0, $hgUW1$token)("space.400")} 0`,
    [(0, $hgUW1$media).below.sm]: {
        padding: `${(0, $hgUW1$token)("space.300")} 0`
    }
});
const $0ae392c3008c8a3e$var$textStyles = (0, $hgUW1$css)({
    [(0, $hgUW1$media).above.md]: {
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        overflow: "hidden",
        "text-overflow": "ellipsis"
    }
});
const $0ae392c3008c8a3e$var$imageBaseStyles = (0, $hgUW1$css)({
    height: "80px",
    width: "80px",
    objectFit: "contain",
    borderRadius: "50%",
    marginBottom: (0, $hgUW1$token)("space.200"),
    maxWidth: "100%"
});
const $0ae392c3008c8a3e$var$imageSquareStyles = (0, $hgUW1$css)({
    borderRadius: 0,
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $0ae392c3008c8a3e$var$fullStyleImageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "auto",
    maxHeight: "260px",
    marginBottom: (0, $hgUW1$token)("space.500"),
    borderRadius: "initial"
});
const $0ae392c3008c8a3e$var$variantStyles = {
    [$0ae392c3008c8a3e$export$f2adaabc3a0295ef.TALL]: {
        container: {
            withImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "352px !important"
                }
            }),
            withoutImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "264px !important"
                }
            })
        },
        heading: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                "-webkit-line-clamp": "2"
            }
        }),
        text: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                "-webkit-line-clamp": "3"
            }
        })
    },
    [$0ae392c3008c8a3e$export$f2adaabc3a0295ef.FULL]: {
        container: {
            withImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "auto !important"
                }
            }),
            withoutImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "auto !important"
                }
            })
        },
        heading: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                "-webkit-line-clamp": "none"
            }
        }),
        text: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                "-webkit-line-clamp": "none"
            }
        })
    }
};
const $0ae392c3008c8a3e$var$squareTypeStyles = {
    container: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.input"),
        padding: (0, $hgUW1$token)("space.300"),
        height: "320px",
        width: "324px",
        borderRadius: "8px",
        [(0, $hgUW1$media).below.md]: {
            minHeight: "360px",
            maxWidth: "unset",
            height: "100%"
        },
        [(0, $hgUW1$media).below.sm]: {
            minHeight: "264px",
            padding: (0, $hgUW1$token)("space.300")
        }
    }),
    heading: (0, $hgUW1$css)({
        marginBottom: (0, $hgUW1$token)("space.300")
    })
};
const $0ae392c3008c8a3e$var$contentContainerStyles = (0, $hgUW1$css)({
    marginBottom: (0, $hgUW1$token)("space.025"),
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $0ae392c3008c8a3e$var$contentContainerSquareStyles = (0, $hgUW1$css)({
    justifyContent: "space-between",
    a: {
        fontSize: "20px",
        lineHeight: "24px"
    }
});
const $0ae392c3008c8a3e$var$textContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.100"),
    marginBottom: (0, $hgUW1$token)("space.400"),
    [(0, $hgUW1$media).below.sm]: {
        marginBottom: (0, $hgUW1$token)("space.300")
    }
});


var $3c691af970e2b3d8$exports = {};

$parcel$export($3c691af970e2b3d8$exports, "ThumbType", () => $3c691af970e2b3d8$export$e1c6e381de15460b);
$parcel$export($3c691af970e2b3d8$exports, "FeedbackButtonType", () => $3c691af970e2b3d8$export$8eec558e14651de4);
$parcel$export($3c691af970e2b3d8$exports, "THUMBS_UP_FEEDBACK_OPTIONS", () => $3c691af970e2b3d8$export$3e6d4d99e8c08756);
$parcel$export($3c691af970e2b3d8$exports, "THUMBS_DOWN_FEEDBACK_OPTIONS", () => $3c691af970e2b3d8$export$592a942fdddb4b1a);
$parcel$export($3c691af970e2b3d8$exports, "QuickFeedback", () => $3c691af970e2b3d8$export$c6f2bf448101d429);





var $a6a41c835fd01d00$exports = {};
var $1ca64a7075ab6eae$exports = {};

$parcel$export($1ca64a7075ab6eae$exports, "TextField", () => $1ca64a7075ab6eae$export$2c73285ae9390cec);



const $1ca64a7075ab6eae$export$2c73285ae9390cec = ({ isInvalid: isInvalid = false , onChange: onChange = ()=>{
    return null;
} , value: value , isDisabled: isDisabled = false , isRequired: isRequired = false , ...rest })=>/*#__PURE__*/ (0, $hgUW1$jsx)("input", {
        css: [
            $1ca64a7075ab6eae$var$inputStyles,
            isInvalid && $1ca64a7075ab6eae$var$invalidStyles,
            isDisabled && $1ca64a7075ab6eae$var$disabledStyles
        ],
        onChange: onChange,
        disabled: isDisabled,
        value: value,
        required: isRequired,
        ...rest,
        role: "input"
    });
const $1ca64a7075ab6eae$var$inputStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "42px",
    fontWeight: 400,
    display: "flex",
    padding: "8px 12px",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid #8590A2",
    background: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "16px",
    "&:hover": {
        background: "#F7F8F9"
    },
    "&:focus": {
        borderColor: "inherit",
        boxShadow: "none",
        border: "2px solid #388BFF",
        margin: "-1px"
    }
});
const $1ca64a7075ab6eae$var$invalidStyles = (0, $hgUW1$css)({
    border: "2px solid #C9372C",
    margin: "-1px"
});
const $1ca64a7075ab6eae$var$disabledStyles = (0, $hgUW1$css)({
    color: "#091E424F",
    border: "1px solid #091E420F",
    background: "#091E4208"
});


var $60ab015507144a2b$exports = {};

$parcel$export($60ab015507144a2b$exports, "TextFieldMessage", () => $60ab015507144a2b$export$9144c5f9beecc4b7);



const $60ab015507144a2b$export$9144c5f9beecc4b7 = ({ message: message = "Example text here" , type: type = "valid"  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $60ab015507144a2b$var$spacing,
        children: [
            type === "helper" && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$HelperMessage), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $60ab015507144a2b$var$helperMessageStyle,
                    children: message
                })
            }),
            type === "error" && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ErrorMessage), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $60ab015507144a2b$var$errorMessageStyle,
                    children: message
                })
            }),
            type === "valid" && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ValidMessage), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $60ab015507144a2b$var$validMessageStyles,
                    children: message
                })
            })
        ]
    });
const $60ab015507144a2b$var$spacing = (0, $hgUW1$css)({
    marginTop: "2px"
});
const $60ab015507144a2b$var$helperMessageStyle = (0, $hgUW1$css)({
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $60ab015507144a2b$var$errorMessageStyle = (0, $hgUW1$css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    marginTop: "0.5px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $60ab015507144a2b$var$validMessageStyles = (0, $hgUW1$css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});


var $57b1d5df6b5425d4$exports = {};

$parcel$export($57b1d5df6b5425d4$exports, "TextFieldLabel", () => $57b1d5df6b5425d4$export$76375b2580d1f8ac);




const $57b1d5df6b5425d4$export$76375b2580d1f8ac = ({ labelText: labelText = "Example label" , isRequired: isRequired = true  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Label), {
        htmlFor: "basic-textfield",
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
            css: $57b1d5df6b5425d4$var$labelStyles,
            children: [
                labelText,
                isRequired && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$RequiredAsterisk), {})
            ]
        })
    });
const $57b1d5df6b5425d4$var$labelStyles = (0, $hgUW1$css)({
    fontFamily: "Inter",
    color: "#44546F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});


var $4be7278e65b71184$exports = {};

$parcel$export($4be7278e65b71184$exports, "UnifiedAccountCardContent", () => $4be7278e65b71184$export$c031b829a2452999);




var $fc6addd2061b87dd$exports = {};

$parcel$defineInteropFlag($fc6addd2061b87dd$exports);

$parcel$export($fc6addd2061b87dd$exports, "default", () => $fc6addd2061b87dd$export$2e2bcd8739ae039);





const $fc6addd2061b87dd$var$UnifiedMoreDropdownMenu = ({ actions: actions , isDisabled: isDisabled  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitdropdownmenu), {
        trigger: ({ triggerRef: triggerRef , ...props })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $fc6addd2061b87dd$var$buttonWrapperStyle,
                "data-testid": "dropdown-trigger",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$IconButton), {
                    ...props,
                    icon: (0, $hgUW1$atlaskiticonglyphmore),
                    label: "more",
                    ref: triggerRef,
                    appearance: "default",
                    isDisabled: isDisabled
                })
            }),
        placement: "bottom-end",
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItemGroup), {
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItem), {
                    onClick: action.onClick,
                    children: action.text
                }, index))
        })
    });
var $fc6addd2061b87dd$export$2e2bcd8739ae039 = $fc6addd2061b87dd$var$UnifiedMoreDropdownMenu;
const $fc6addd2061b87dd$var$buttonWrapperStyle = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    borderRadius: "3px"
});


const $4be7278e65b71184$export$c031b829a2452999 = ({ email: email , tags: tags , actions: actions , isDisabled: isDisabled  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $4be7278e65b71184$var$contentWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $4be7278e65b71184$var$dropdownWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fc6addd2061b87dd$export$2e2bcd8739ae039), {
                    actions: actions,
                    isDisabled: isDisabled
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $4be7278e65b71184$var$coverImageWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $4be7278e65b71184$var$coverImageStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
                        width: "350",
                        height: "82",
                        viewBox: "0 0 350 82",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                "clip-path": "url(#clip0_985_48434)",
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M167.322 38.821C177.93 34.78 184.789 30.2722 188.858 25.4255C193.11 20.3612 194.263 14.9878 193.538 9.5957C192.822 4.25652 190.271 -1.06544 187.204 -6.12471C185.194 -9.43933 182.915 -12.7134 180.746 -15.8286C179.821 -17.1581 178.915 -18.4586 178.059 -19.7211L221.313 -48.8693C222.054 -47.7618 222.787 -46.6694 223.511 -45.5908C241.665 -18.5315 254.013 -0.126895 247.42 31.5817C243.994 48.0569 230.739 60.1325 218.142 68.1357C211.864 72.1242 205.799 75.0696 201.302 77.0177C199.054 77.9913 197.201 78.7147 195.913 79.1939C195.383 79.3909 194.949 79.5465 194.622 79.6613L167.322 38.821Z",
                                        stroke: "#0C66E4",
                                        "stroke-width": "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M72.3053 -15.1135C82.328 -17.928 92.5012 -22.9961 101.629 -29.5552C110.755 -36.1128 118.158 -43.5947 123.819 -51.8086L166.607 8.14819C159.501 15.3002 151.561 22.0298 142.555 28.5017C133.545 34.9761 124.385 40.4509 115.146 44.9177L72.3053 -15.1135Z",
                                        stroke: "#0C66E4",
                                        "stroke-width": "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M145.593 48.2832L177.327 107.164L160.851 130.97L94.7005 121.821L95.1645 67.6983L145.593 48.2832Z",
                                        stroke: "#0C66E4",
                                        "stroke-width": "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M315.34 72.2206L315.355 72.2331L315.372 72.2449C315.778 72.5416 316.18 72.8355 316.577 73.1258C320.114 75.7149 323.269 78.0239 326.324 79.6083C329.758 81.3894 333.158 82.3068 336.975 81.7093C341.291 81.0335 344.5 78.5429 346.241 74.1008C347.949 69.7418 348.232 63.5491 346.967 55.3884L346.241 50.7055L378.755 45.6149C379.596 48.7568 380.163 52.4046 380.848 56.8254C383.982 77.0371 381.669 92.493 375.423 103.369C369.195 114.213 358.984 120.632 346.012 122.663C327.026 125.636 315.363 118.74 304.711 110.615L304.701 110.608L304.691 110.601C304.22 110.259 303.755 109.92 303.296 109.586C299.84 107.069 296.744 104.815 293.745 103.255C290.311 101.469 286.909 100.54 283.091 101.138L282.103 101.293L282.115 101.369C278.291 102.255 275.438 104.702 273.833 108.804C272.126 113.168 271.843 119.36 273.105 127.5C273.249 128.428 273.503 129.339 273.738 130.185L273.746 130.211C273.89 130.731 274.028 131.226 274.142 131.711L241.242 136.862C240.465 134.058 239.898 130.414 239.159 125.649C236.059 105.652 238.499 90.2821 244.81 79.446C251.105 68.6378 261.321 62.2203 274.06 60.2258C283.596 58.7327 291.242 59.6302 297.818 61.9301C304.407 64.2347 309.975 67.9653 315.34 72.2206Z",
                                        stroke: "#0C66E4",
                                        "stroke-width": "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M292.179 -56.9295L292.37 -57.2966L292.352 -57.3526L301.854 -75.6471L361.496 -44.2691L338.629 -0.241775C322.356 31.0905 300.658 42.9482 277.565 44.2706C265.48 24.4864 262.733 -0.232558 279.024 -31.6005L292.179 -56.9295Z",
                                        stroke: "#0C66E4",
                                        "stroke-width": "2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("defs", {
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                                    id: "clip0_985_48434",
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M0 8C0 3.58172 3.58172 0 8 0H386C390.418 0 394 3.58172 394 8V96H0V8Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $4be7278e65b71184$var$textWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $4be7278e65b71184$var$emailStyles,
                        children: email
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $4be7278e65b71184$var$tagsWrapperStyles,
                        children: tags.map((tag, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4be7278e65b71184$var$tagItemStyles,
                                children: tag
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $4be7278e65b71184$var$contentWrapperStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
    margin: 0,
    height: "100%",
    borderRadius: (0, $hgUW1$token)("space.100")
});
const $4be7278e65b71184$var$coverImageWrapperStyles = (0, $hgUW1$css)({
    width: "100%",
    overflow: "hidden",
    borderTopLeftRadius: (0, $hgUW1$token)("space.100"),
    borderTopRightRadius: (0, $hgUW1$token)("space.100")
});
const $4be7278e65b71184$var$coverImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("elevation.surface.sunken"),
    width: "100%",
    height: "82px",
    objectFit: "cover",
    margin: 0,
    padding: 0,
    display: "block"
});
const $4be7278e65b71184$var$textWrapperStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    boxSizing: "border-box",
    width: "100%"
});
const $4be7278e65b71184$var$emailStyles = (0, $hgUW1$css)({
    fontFamily: "Inter",
    marginBottom: "12px",
    fontSize: "16px",
    color: "#44546F",
    lineHeight: "24px"
});
const $4be7278e65b71184$var$tagsWrapperStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
const $4be7278e65b71184$var$tagItemStyles = (0, $hgUW1$css)({
    display: "inline-block"
});
const $4be7278e65b71184$var$dropdownWrapperStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: (0, $hgUW1$token)("space.150"),
    right: (0, $hgUW1$token)("space.150")
});


var $db9d361cdef36cb6$exports = {};

$parcel$export($db9d361cdef36cb6$exports, "UnifiedAccountContainerCard", () => $db9d361cdef36cb6$export$c9d2f1697787ae74);



const $db9d361cdef36cb6$export$c9d2f1697787ae74 = ({ children: children , testId: testId , onClick: onClick , isAddAccount: isAddAccount = false  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
        "data-testid": testId,
        css: [
            $db9d361cdef36cb6$var$unstyledButtonStyles,
            $db9d361cdef36cb6$var$cardContainerStyles,
            isAddAccount && $db9d361cdef36cb6$var$addAccountStyles,
            isAddAccount ? $db9d361cdef36cb6$var$hoverEffectStyles : $db9d361cdef36cb6$var$noPointerCursorStyles
        ],
        role: "button",
        onClick: isAddAccount ? onClick : undefined,
        children: children
    });
};
const $db9d361cdef36cb6$var$unstyledButtonStyles = (0, $hgUW1$css)({
    display: "flex",
    textAlign: "inherit",
    textDecoration: "none",
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    fontFamily: (0, $hgUW1$token)("font.family.brand.body")
});
const $db9d361cdef36cb6$var$cardContainerStyles = (0, $hgUW1$css)({
    position: "relative",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    borderRadius: (0, $hgUW1$token)("space.100"),
    background: (0, $hgUW1$token)("elevation.surface"),
    alignItems: "center",
    zIndex: 1,
    justifyContent: "center",
    height: "194px",
    transition: "box-shadow 0.2s ease",
    width: "300px",
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "290px"
    },
    "@media (min-width: 1280px)": {
        width: "290px"
    }
});
const $db9d361cdef36cb6$var$hoverEffectStyles = (0, $hgUW1$css)({
    cursor: "pointer",
    "&:hover": {
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $db9d361cdef36cb6$var$noPointerCursorStyles = (0, $hgUW1$css)({
    cursor: "default"
});
const $db9d361cdef36cb6$var$addAccountStyles = (0, $hgUW1$css)({
    border: `1px dashed ${(0, $hgUW1$token)("color.border")}`,
    boxShadow: "none"
});


var $e6da040d2ca2c72a$exports = {};

$parcel$export($e6da040d2ca2c72a$exports, "UnifiedAccountLinkAccountCard", () => $e6da040d2ca2c72a$export$fc13faf098015d3a);








const $5089616a215e9052$var$ellipseStyles = (0, $hgUW1$css)({
    width: "72px",
    height: "72px",
    backgroundColor: "#D3F1A7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $5089616a215e9052$export$f21ab0717a89c77f = ()=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $5089616a215e9052$var$ellipseStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphadd), {
            label: "Add",
            size: "large",
            primaryColor: (0, $hgUW1$token)("color.icon")
        })
    });
};



const $e6da040d2ca2c72a$var$contentStyles = (0, $hgUW1$css)({
    textAlign: "center",
    padding: "17px 48px",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});
const $e6da040d2ca2c72a$var$textStyles = (0, $hgUW1$css)({
    marginTop: "16px",
    color: (0, $hgUW1$token)("color.icon"),
    fontSize: "16px",
    lineHeight: "24px"
});
const $e6da040d2ca2c72a$export$fc13faf098015d3a = ()=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $e6da040d2ca2c72a$var$contentStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5089616a215e9052$export$f21ab0717a89c77f), {}),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $e6da040d2ca2c72a$var$textStyles,
                children: "Link account"
            })
        ]
    });
};


var $9c7edcd33b2e220b$exports = {};

$parcel$export($9c7edcd33b2e220b$exports, "UnifiedAccountTagContainer", () => $9c7edcd33b2e220b$export$b27c6704e245f018);



const $9c7edcd33b2e220b$export$b27c6704e245f018 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $9c7edcd33b2e220b$var$containerStyles,
        children: children
    });
};
const $9c7edcd33b2e220b$var$containerStyles = (0, $hgUW1$css)({
    maxWidth: "84px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    borderRadius: "4px"
});


var $3ec1f71319ba0295$exports = {};

$parcel$export($3ec1f71319ba0295$exports, "UnifiedAccountTagLoggedIn", () => $3ec1f71319ba0295$export$8bee5cfdbbc2fc0c);




const $3ec1f71319ba0295$var$loggedInContentStyles = (0, $hgUW1$css)({
    backgroundColor: "#626F86",
    color: "#FFFFFF"
});
const $3ec1f71319ba0295$export$8bee5cfdbbc2fc0c = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $9c7edcd33b2e220b$export$b27c6704e245f018), {
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: [
                $3ec1f71319ba0295$var$loggedInContentStyles,
                $3ec1f71319ba0295$var$baseContentStyles
            ],
            children: "LOGGED IN"
        })
    });
const $3ec1f71319ba0295$var$baseContentStyles = (0, $hgUW1$css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});


var $7cbc56ac0bc2e1de$exports = {};

$parcel$export($7cbc56ac0bc2e1de$exports, "UnifiedAccountTagPrimary", () => $7cbc56ac0bc2e1de$export$be7f7dedc3a0e1ad);





const $5f6e50d159d7e8e1$var$StarFilledIcon = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
            id: "Icon / <StarFilledIcon>",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                    width: "12",
                    height: "12",
                    rx: "6",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "Vector",
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M6.0357 8.64198L4.0832 9.66848C4.00063 9.7119 3.90755 9.73135 3.8145 9.72463C3.72146 9.71791 3.63214 9.68529 3.55666 9.63046C3.48118 9.57563 3.42255 9.50078 3.38739 9.41437C3.35223 9.32796 3.34194 9.23344 3.3577 9.14149L3.7302 6.96698L2.1507 5.42698C2.08399 5.36186 2.03683 5.27937 2.01452 5.18886C1.99222 5.09834 1.99566 5.00338 2.02447 4.91472C2.05328 4.82605 2.10631 4.74721 2.17756 4.68709C2.24881 4.62697 2.33545 4.58797 2.4277 4.57448L4.6107 4.25698L5.5872 2.27898C5.62846 2.19525 5.69234 2.12474 5.7716 2.07544C5.85087 2.02613 5.94235 2 6.0357 2C6.12905 2 6.22053 2.02613 6.29979 2.07544C6.37906 2.12474 6.44294 2.19525 6.4842 2.27898L7.4602 4.25698L9.6432 4.57448C9.73549 4.58789 9.82219 4.62684 9.89351 4.68693C9.96482 4.74701 10.0179 4.82585 10.0468 4.91453C10.0756 5.00321 10.0791 5.09819 10.0569 5.18875C10.0346 5.2793 9.98741 5.36182 9.9207 5.42698L8.3407 6.96698L8.7137 9.14149C8.72939 9.23337 8.71908 9.32781 8.68394 9.41414C8.64879 9.50048 8.59022 9.57527 8.51482 9.63008C8.43942 9.68488 8.3502 9.71752 8.25724 9.72431C8.16427 9.7311 8.07126 9.71176 7.9887 9.66848L6.0357 8.64198Z",
                    fill: "white"
                })
            ]
        })
    });
var $5f6e50d159d7e8e1$export$2e2bcd8739ae039 = $5f6e50d159d7e8e1$var$StarFilledIcon;


const $7cbc56ac0bc2e1de$var$primaryContentStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $7cbc56ac0bc2e1de$var$iconWrapperStyles = (0, $hgUW1$css)({
    marginRight: "2px",
    display: "flex",
    alignItems: "center"
});
const $7cbc56ac0bc2e1de$export$be7f7dedc3a0e1ad = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $9c7edcd33b2e220b$export$b27c6704e245f018), {
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: [
                $7cbc56ac0bc2e1de$var$primaryContentStyles,
                $7cbc56ac0bc2e1de$var$baseContentStyles
            ],
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $7cbc56ac0bc2e1de$var$iconWrapperStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5f6e50d159d7e8e1$export$2e2bcd8739ae039), {})
                }),
                "PRIMARY"
            ]
        })
    });
const $7cbc56ac0bc2e1de$var$baseContentStyles = (0, $hgUW1$css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});



var $01ef21c48d795edb$exports = {};

$parcel$export($01ef21c48d795edb$exports, "UnifiedAccountTagLinked", () => $01ef21c48d795edb$export$446c53c437a3d14a);




const $01ef21c48d795edb$var$primaryContentStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $01ef21c48d795edb$export$446c53c437a3d14a = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $9c7edcd33b2e220b$export$b27c6704e245f018), {
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: [
                $01ef21c48d795edb$var$primaryContentStyles,
                $01ef21c48d795edb$var$baseContentStyles
            ],
            children: "LINKED"
        })
    });
const $01ef21c48d795edb$var$baseContentStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});


var $80cd39a44f20f361$exports = {};

$parcel$defineInteropFlag($80cd39a44f20f361$exports);

$parcel$export($80cd39a44f20f361$exports, "SharedFooter", () => $80cd39a44f20f361$export$7a92b4adf6bd95bb);
$parcel$export($80cd39a44f20f361$exports, "default", () => $80cd39a44f20f361$export$2e2bcd8739ae039);







var $85d9a99cb49b730f$require$Buffer = $hgUW1$Buffer;
const $85d9a99cb49b730f$var$svgStringDesktopFooterWider = `<svg width="3597" height="220" viewBox="0 0 3597 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1461_26831)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3507.45 240.161L3557.25 236.478L3583.87 196.676L3567.29 150.712L3519.96 133.206L3477.54 157.345L3471.98 204.936L3507.45 240.161Z" fill="#FCA700"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3604.18 274.336L3620.24 305.08C3640.49 343.822 3667.68 358.475 3696.55 359.996C3711.89 335.532 3715.4 304.987 3695.17 266.29L3666.68 211.774L3591.71 250.587L3604.11 274.315L3604.18 274.336Z" fill="#1868DB"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26831">
<rect width="3597" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $85d9a99cb49b730f$export$f3cfc44c4eba4576 = `data:image/svg+xml;base64,${$85d9a99cb49b730f$require$Buffer.from($85d9a99cb49b730f$var$svgStringDesktopFooterWider).toString("base64")}`;
const $85d9a99cb49b730f$var$svgStringDesktopFooterWide = `<svg width="3305" height="220" viewBox="0 0 3305 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1461_26940)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26940">
<rect width="3305" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $85d9a99cb49b730f$export$7d22dc8c5b0cc81c = `data:image/svg+xml;base64,${$85d9a99cb49b730f$require$Buffer.from($85d9a99cb49b730f$var$svgStringDesktopFooterWide).toString("base64")}`;
const $85d9a99cb49b730f$var$svgStringMobileFooter = `<svg width="907" height="139" viewBox="0 0 907 139" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1421_26676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="907" height="139">
<rect width="907" height="138.569" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1421_26676)">
<path d="M395.637 190.948C403.967 189.968 412.814 190.744 422.035 193.4C431.255 196.056 440.048 200.427 447.161 206.052L462.551 139.842C454.685 135.837 446.2 132.507 437.142 129.898C428.085 127.289 419.445 125.62 410.979 124.822L395.603 190.971L395.637 190.948Z" fill="#BF63F3"/>
<path d="M261.469 -6.60718L277.516 22.697C259.386 35.2084 255.368 47.2171 263.392 61.8691C271.415 76.5212 283.086 78.4874 301.57 66.6224L317.617 95.9265C281.308 120.141 257.173 111.36 239.002 78.1771C220.831 44.9945 225.177 17.6384 261.486 -6.57639L261.469 -6.60718Z" fill="#BF63F3"/>
<path d="M703.749 28.8725C702.258 30.8363 700.85 33.0593 699.576 35.505C698.302 37.9507 697.228 40.4904 696.449 42.9439C691.72 57.5278 695.81 70.9912 706.42 80.56C708.221 82.1926 710.233 83.7199 712.408 85.1118C714.584 86.5037 716.96 87.7495 719.23 88.7212C732.041 94.0679 744.608 91.2609 753.601 79.5082C755.128 77.5337 756.55 75.2849 757.851 72.7877C759.152 70.2905 760.158 67.8795 760.948 65.4667C765.623 50.9859 761.533 37.5224 750.963 27.8764C749.082 26.1581 747 24.586 744.731 23.1342C742.462 21.6824 740.379 20.5905 738.179 19.6637C725.396 14.2655 712.792 17.0833 703.796 28.9024L703.749 28.8725Z" fill="#FCA700"/>
<path d="M255.266 143.791C253.96 145.508 252.727 147.453 251.612 149.593C250.497 151.733 249.559 153.956 248.879 156.104C244.752 168.871 248.372 180.679 257.715 189.089C259.3 190.524 261.071 191.867 262.985 193.092C264.9 194.316 266.991 195.414 268.987 196.271C280.255 200.986 291.293 198.557 299.172 188.28C300.511 186.554 301.755 184.587 302.894 182.402C304.032 180.217 304.912 178.106 305.601 175.994C309.681 163.316 306.061 151.509 296.753 143.031C295.097 141.521 293.265 140.139 291.268 138.861C289.271 137.584 287.439 136.622 285.504 135.804C274.26 131.044 263.19 133.482 255.307 143.817L255.266 143.791Z" fill="#1868DB"/>
<path d="M540.511 107.628C513.812 119.693 496.617 108.55 490.798 103.608L486.806 160.563C492.136 165.201 507.271 174.615 533.412 162.8C558.209 151.598 574.807 160.41 581.715 165.678L585.707 108.712C579.388 103.898 564.637 96.7202 540.511 107.628Z" fill="#1868DB"/>
<path d="M291.626 241.918L357.357 223.207L378.319 135.456L330.205 106.579L291.626 241.918Z" fill="#82B536"/>
<path d="M207.772 125.619C185.882 119.093 172.032 113.006 164.139 105.765L161.026 181.102C169.161 184.101 177.976 186.914 187.639 189.515C208.795 195.927 221.563 202.214 228.492 210.032L231.68 132.885C224.3 130.298 216.376 127.866 207.772 125.619Z" fill="#FCA700"/>
<path d="M150.358 70.9821L179.701 64.217L192.375 35.669L178.846 6.8247L149.287 -0.588974L125.967 19.0132L126.445 50.8598L150.358 70.9821Z" fill="#82B536"/>
<path d="M487.144 -14.9153C490.073 -3.54747 491.12 8.90597 490.112 22.2702C489.104 35.6344 486.055 48.7625 481.214 59.8175L559.804 67.3853C562.64 55.6224 564.574 43.1392 565.564 30.0109C566.554 16.8825 566.566 4.53097 565.627 -7.39742L487.11 -14.9582L487.144 -14.9153Z" fill="#82B536"/>
<path d="M750.205 108.277C749.527 110.739 749.028 113.403 748.743 116.215C748.458 119.027 748.402 121.838 748.596 124.441C749.655 139.957 758.761 150.597 772.638 154.801C774.997 155.523 777.517 156.055 780.143 156.391C782.77 156.727 785.533 156.841 788.088 156.748C802.457 156.099 813.458 148.032 817.586 133.27C818.296 130.782 818.798 128.088 819.089 125.217C819.38 122.346 819.421 119.683 819.252 117.113C818.181 101.715 809.075 91.0758 795.207 86.7827C792.738 86.0171 790.133 85.4738 787.394 85.1233C784.655 84.7727 782.233 84.6728 779.762 84.7763C765.4 85.3669 754.367 93.4592 750.262 108.284L750.205 108.277Z" fill="#82B536"/>
<path d="M842.951 81.367C858.788 74.077 869.621 70.6339 877.359 70.9258L847.983 24.3268C841.859 26.6939 835.405 29.5186 828.529 32.904C813.18 39.8871 802.914 42.6573 795.515 41.5283L825.596 89.2466C831.096 87.0197 836.858 84.4222 842.951 81.367Z" fill="#BF63F3"/>
<path d="M21.9939 45.6584C21.3276 48.0755 20.8378 50.6918 20.558 53.4527C20.2782 56.2137 20.2233 58.9739 20.4137 61.5301C21.454 76.7656 30.395 87.2126 44.021 91.3409C46.3368 92.0494 48.8118 92.5722 51.3906 92.9022C53.9694 93.2322 56.6827 93.3439 59.1918 93.2528C73.3009 92.6149 84.1031 84.6944 88.1561 70.199C88.853 67.7564 89.3458 65.111 89.6315 62.292C89.9171 59.4729 89.9574 56.8579 89.7918 54.3344C88.7397 39.2151 79.7987 28.7681 66.1814 24.5527C63.7577 23.8009 61.1995 23.2675 58.5098 22.9233C55.8201 22.5791 53.4424 22.4809 51.0165 22.5826C36.9134 23.1624 26.0805 31.1084 22.0493 45.6655L21.9939 45.6584Z" fill="#FCA700"/>
<path d="M598.85 97.498L620.339 107.794L660.44 71.8259L636.967 32.2385L594.924 40.4365L598.85 97.498Z" fill="#FCA700"/>
<path d="M74.9517 165.961C69.6319 171.216 70.6008 179.656 80.2747 191.657C81.3165 192.95 82.6631 193.996 83.7049 195.289L60.3258 218.385C58.1823 216.412 55.801 213.458 52.6756 209.581C28.5406 179.64 29.7458 152.746 47.2172 135.485C60.2366 122.623 72.3341 121.783 84.5526 123.089C93.5012 123.645 99.8746 124.314 104.634 119.612C109.954 114.356 109.01 105.947 99.3113 93.9154L95.9131 89.6996L119.012 66.8797C121.404 69.1603 123.785 72.1144 126.662 75.6839C151.045 105.933 150.148 132.523 132.369 150.087C119.349 162.95 107.004 163.482 95.0086 162.453C86.0848 161.927 79.6867 161.228 74.9268 165.93L74.9517 165.961Z" fill="#BF63F3"/>
<path d="M688.409 187.332L715.888 172.229L721.763 140.276L701.619 115.521L670.609 116.616L652.097 142.736L660.019 174.202L688.409 187.332Z" fill="#1868DB"/>
<path d="M832.929 175.355C830.063 195.446 825.869 213.432 821.573 228.524L880.295 258.791C886.287 239.018 892.347 214.562 896.327 186.668C900.306 158.775 901.351 133.424 901.158 112.547L836.93 120.874C836.813 136.712 835.795 155.264 832.929 175.355Z" fill="#1868DB"/>
<path d="M334.456 35.1284L365.632 24.3972C372.95 48.8477 383.184 56.7618 398.772 51.3962C414.36 46.0306 418.993 32.9989 412.363 8.3117L443.539 -2.41947C457.409 46.3198 443.431 71.9961 408.128 84.1476C372.826 96.2991 348.359 83.8565 334.489 35.1171L334.456 35.1284Z" fill="#1868DB"/>
</g>
</svg>
`;
const $85d9a99cb49b730f$export$eca0cf64e1927e60 = `data:image/svg+xml;base64,${$85d9a99cb49b730f$require$Buffer.from($85d9a99cb49b730f$var$svgStringMobileFooter).toString("base64")}`;






const $80cd39a44f20f361$var$TABLET_MEDIA_QUERY = "@media (min-width: 768px) and (max-width: 1279px)";
const $80cd39a44f20f361$var$MOBILE_MEDIA_QUERY = "@media (max-width: 767px)";
const $80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY = "@media (min-width: 1280px)";
const $80cd39a44f20f361$var$YEAR = new Date().getFullYear();
const $80cd39a44f20f361$var$COPYRIGHT = `Copyright © ${$80cd39a44f20f361$var$YEAR} Atlassian`;
const $80cd39a44f20f361$var$FooterLink = ({ href: href , onClick: onClick , text: text , styles: styles = []  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        href: href,
        onClick: onClick,
        css: [
            $80cd39a44f20f361$var$linkStyle,
            ...styles
        ],
        children: text
    });
const $80cd39a44f20f361$var$FORUMS_URL = (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).FORUMS];
const $80cd39a44f20f361$var$getForumsUrl = (url, isLoggedIn, email)=>isLoggedIn ? (0, $3dba2111a1a6d39b$export$1db7da00354b15ed)({
        email: email,
        redirectUrl: url
    }) : url;
const $80cd39a44f20f361$export$7a92b4adf6bd95bb = ({ reportAProblemCallback: reportAProblemCallback , isLoggedIn: isLoggedIn = false , showChampions: showChampions = false , email: email , licenseData: licenseData  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const openModal = (0, $hgUW1$useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $hgUW1$useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $80cd39a44f20f361$var$footerBackgroundStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $80cd39a44f20f361$var$footerWrapperStyles,
            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $80cd39a44f20f361$var$footerStyle,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $80cd39a44f20f361$var$innerDivStyle,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $80cd39a44f20f361$var$logoContainerStyle,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $80cd39a44f20f361$var$logoStyle,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianIcon), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $80cd39a44f20f361$var$columnsContainerStyle,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                            css: $80cd39a44f20f361$var$headerStyle,
                                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                href: "/",
                                                css: $80cd39a44f20f361$var$linkStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Community"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $80cd39a44f20f361$var$headerStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                    href: $80cd39a44f20f361$var$getForumsUrl($80cd39a44f20f361$var$FORUMS_URL, isLoggedIn, email),
                                                    css: $80cd39a44f20f361$var$linkStyle,
                                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Forums"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: $80cd39a44f20f361$var$getForumsUrl(`${$80cd39a44f20f361$var$FORUMS_URL}/help/faqpage`, isLoggedIn, email),
                                                text: "FAQs"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: $80cd39a44f20f361$var$getForumsUrl(`${$80cd39a44f20f361$var$FORUMS_URL}/custom/page/page-id/rules-of-engagement`, isLoggedIn, email),
                                                text: "Forums guidelines"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $80cd39a44f20f361$var$headerStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                    href: (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).LEARNING],
                                                    css: $80cd39a44f20f361$var$linkStyle,
                                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Learning"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: "https://university.atlassian.com/student/activity/836764-about-us",
                                                text: "About learning"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: "https://university.atlassian.com/student/activity/1938006-resources-and-support",
                                                text: "Resources"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                            css: $80cd39a44f20f361$var$headerStyle,
                                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                href: (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).EVENTS],
                                                css: $80cd39a44f20f361$var$linkStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Events"
                                                })
                                            })
                                        })
                                    }),
                                    showChampions && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                            css: $80cd39a44f20f361$var$headerStyle,
                                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                href: (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).CHAMPIONS],
                                                css: $80cd39a44f20f361$var$linkStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Champions"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $80cd39a44f20f361$var$bottomDivStyle,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $80cd39a44f20f361$var$bottomContentStyle,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: $80cd39a44f20f361$var$copyrightText,
                                    children: $80cd39a44f20f361$var$COPYRIGHT
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                    css: $80cd39a44f20f361$var$bottomLinksContainerStyle,
                                    children: [
                                        reportAProblemCallback && /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            onClick: reportAProblemCallback,
                                            text: "Report a problem",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                            text: "Privacy Policy",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            href: $80cd39a44f20f361$var$getForumsUrl(`${$80cd39a44f20f361$var$FORUMS_URL}/user/termsofservicepage`, isLoggedIn, email),
                                            text: "Terms",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/trust/data-protection",
                                            text: "Security",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        licenseData && /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                    onClick: openModal,
                                                    text: "About",
                                                    styles: [
                                                        $80cd39a44f20f361$var$bottomLinkStyle
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ModalTransition), {
                                                    children: isOpen && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a0eced43682c2d75$export$bd0c6e28f5d6b66e), {
                                                        ...licenseData,
                                                        closeModal: closeModal
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $80cd39a44f20f361$var$footerBackgroundStyles = (0, $hgUW1$css)({
    width: "100%",
    backgroundImage: `url(${(0, $85d9a99cb49b730f$export$f3cfc44c4eba4576)})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingTop: (0, $hgUW1$token)("space.200"),
    paddingBottom: (0, $hgUW1$token)("space.200"),
    boxSizing: "border-box",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        backgroundImage: `url(${(0, $85d9a99cb49b730f$export$7d22dc8c5b0cc81c)})`
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        backgroundImage: `url(${(0, $85d9a99cb49b730f$export$eca0cf64e1927e60)})`
    }
});
const $80cd39a44f20f361$var$footerWrapperStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "100%",
    fontFamily: "Inter, sans-serif",
    [$80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY]: {
        maxWidth: "1234px"
    },
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        maxWidth: "720px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});
const $80cd39a44f20f361$var$footerStyle = (0, $hgUW1$css)({
    borderRadius: "0px 0px 24px 24px",
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 16px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        textAlign: "left"
    }
});
const $80cd39a44f20f361$var$linkStyle = (0, $hgUW1$css)({
    display: "inline",
    fontSize: "12px",
    fontWeight: 400,
    color: (0, $hgUW1$token)("color.text"),
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: (0, $hgUW1$token)("color.text"),
        color: (0, $hgUW1$token)("color.text"),
        cursor: "pointer"
    }
});
const $80cd39a44f20f361$var$innerDivStyle = (0, $hgUW1$css)({
    padding: "24px 24px",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: "0px",
        paddingBottom: "8px"
    }
});
const $80cd39a44f20f361$var$logoContainerStyle = (0, $hgUW1$css)({
    width: "420px",
    display: "flex",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "120px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginBottom: "16px",
        width: "120px"
    }
});
const $80cd39a44f20f361$var$logoStyle = (0, $hgUW1$css)({
    svg: {
        color: (0, $hgUW1$token)("color.icon.brand"),
        transform: `scale(0.9)`
    },
    marginLeft: "24px",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        marginLeft: "0",
        marginBottom: "8px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0",
        paddingLeft: "0"
    }
});
const $80cd39a44f20f361$var$columnsContainerStyle = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        gap: "16px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        flexDirection: "column",
        gap: "0"
    }
});
const $80cd39a44f20f361$var$columnStyle = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "120px",
    textAlign: "left",
    gap: "12px",
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        marginBottom: "16px"
    }
});
const $80cd39a44f20f361$var$headerStyle = (0, $hgUW1$css)({
    marginBottom: "4px"
});
const $80cd39a44f20f361$var$bottomDivStyle = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 0px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: "0",
        paddingRight: "0"
    }
});
const $80cd39a44f20f361$var$copyrightText = (0, $hgUW1$css)({
    marginLeft: "0px",
    fontSize: "12px",
    color: (0, $hgUW1$token)("color.text.subtle")
});
const $80cd39a44f20f361$var$bottomContentStyle = (0, $hgUW1$css)({
    width: "100%",
    maxWidth: "calc(100% - 48px)",
    paddingTop: "16px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        maxWidth: "100%",
        justifyContent: "flex-start",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        paddingLeft: "24px",
        paddingRight: "0"
    }
});
const $80cd39a44f20f361$var$bottomLinkStyle = (0, $hgUW1$css)({
    display: "inline",
    marginLeft: "32px",
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0"
    }
});
const $80cd39a44f20f361$var$bottomLinksContainerStyle = (0, $hgUW1$css)({
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        // match columnStyle
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        textAlign: "left",
        marginTop: "0",
        marginBottom: "32px",
        gap: "12px"
    }
});
var $80cd39a44f20f361$export$2e2bcd8739ae039 = $80cd39a44f20f361$export$7a92b4adf6bd95bb;


var $fff41b96fcd62262$exports = {};

$parcel$export($fff41b96fcd62262$exports, "WelcomeModal", () => $fff41b96fcd62262$export$9d12d42929c3fcf);






const $fff41b96fcd62262$export$9d12d42929c3fcf = ({ onAccept: onAccept , onCancel: onCancel , coverImageSrc: coverImageSrc  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: onCancel,
        width: "auto",
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        shouldScrollInViewport: true,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $fff41b96fcd62262$var$modalContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $fff41b96fcd62262$var$modalImageContainerStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                        src: coverImageSrc,
                        alt: "cover",
                        css: $fff41b96fcd62262$var$coverImageStyles
                    })
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $fff41b96fcd62262$var$modalBodyStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("h1", {
                            css: $fff41b96fcd62262$var$modalHeadingContainerStyles,
                            children: "Welcome to the new Atlassian Community"
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: "Online forums and learning are now in one easy-to-use experience."
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: [
                                "By continuing, you accept the updated",
                                " ",
                                /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                    href: (0, $1ff01338112cd7fe$export$bc6e44c7f1ae99f6),
                                    target: "_blank",
                                    children: "Community Terms of Use"
                                }),
                                " ",
                                "and acknowledge the",
                                " ",
                                /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                    href: (0, $1ff01338112cd7fe$export$30786e8ac20c09d8),
                                    target: "_blank",
                                    children: "Privacy Policy"
                                }),
                                ". Your public name, photo, and achievements may be publicly visible and available in search engines."
                            ]
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $fff41b96fcd62262$var$modalButtonContainerStyles,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $fff41b96fcd62262$var$buttonStyle,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$atlaskitbuttonnew), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: [
                                            " ",
                                            "Cancel and logout"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $fff41b96fcd62262$var$buttonStyle,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        children: "Accept and continue"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $fff41b96fcd62262$var$buttonStyle = (0, $hgUW1$css)({
    fontSize: "16px",
    "& span": {
        fontWeight: "600"
    }
});
const $fff41b96fcd62262$var$coverImageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "auto",
    display: "block"
});
const $fff41b96fcd62262$var$modalContainerStyles = (0, $hgUW1$css)({
    maxWidth: "600px",
    margin: "0 auto"
});
const $fff41b96fcd62262$var$modalImageContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    overflow: "hidden"
});
const $fff41b96fcd62262$var$modalBodyStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px"
});
const $fff41b96fcd62262$var$modalHeadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    paddingTop: "24px",
    fontWeight: 700,
    textAlign: "center"
});
const $fff41b96fcd62262$var$modalSubheadingContainerStyles = (0, $hgUW1$css)({
    fontSize: "16px",
    marginTop: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    marginBottom: "24px"
});
const $fff41b96fcd62262$var$modalButtonContainerStyles = (0, $hgUW1$css)({
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
});


$parcel$exportWildcard($a6a41c835fd01d00$exports, $1ca64a7075ab6eae$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $60ab015507144a2b$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $57b1d5df6b5425d4$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $4be7278e65b71184$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $db9d361cdef36cb6$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $e6da040d2ca2c72a$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $9c7edcd33b2e220b$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $3ec1f71319ba0295$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $7cbc56ac0bc2e1de$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $fc6addd2061b87dd$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $01ef21c48d795edb$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $80cd39a44f20f361$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $fff41b96fcd62262$exports);



let $3c691af970e2b3d8$export$e1c6e381de15460b;
(function(ThumbType) {
    ThumbType["THUMB_UP"] = "thumb-up";
    ThumbType["THUMB_DOWN"] = "thumb-down";
})($3c691af970e2b3d8$export$e1c6e381de15460b || ($3c691af970e2b3d8$export$e1c6e381de15460b = {}));
let $3c691af970e2b3d8$export$8eec558e14651de4;
(function(FeedbackButtonType) {
    FeedbackButtonType["DISMISS"] = "dismiss";
    FeedbackButtonType["SUBMIT"] = "submit";
})($3c691af970e2b3d8$export$8eec558e14651de4 || ($3c691af970e2b3d8$export$8eec558e14651de4 = {}));
const $3c691af970e2b3d8$export$3e6d4d99e8c08756 = [
    "It was easy to understand",
    "I learned something useful",
    "It was engaging",
    "It improved my confidence in the subject",
    "Other"
];
const $3c691af970e2b3d8$export$592a942fdddb4b1a = [
    "It wasn’t clear",
    "It wasn’t accurate",
    "I didn’t learn what I wanted to know",
    "Other"
];
const $3c691af970e2b3d8$export$c6f2bf448101d429 = ({ onSubmitFeedback: onSubmitFeedback , onChangeThoughts: onChangeThoughts , onChangeOption: onChangeOption , onThumbClick: onThumbClick , shouldShowDivider: shouldShowDivider = true  })=>{
    const [isPopupOpened, setIsPopupOpened] = (0, $hgUW1$react).useState({
        isOpen: false,
        thumbType: null
    });
    const [selectedOption, setSelectedOption] = (0, $hgUW1$react).useState("");
    const [isThumbClicked, setIsThumbClicked] = (0, $hgUW1$react).useState(false);
    const handleThumbClick = (thumbType)=>{
        setIsThumbClicked(true);
        setIsPopupOpened({
            isOpen: true,
            thumbType: thumbType
        });
        onThumbClick(thumbType);
    };
    const toggleAnswer = (option)=>{
        setSelectedOption(option);
        onChangeOption(option);
    };
    const getOptionStatus = (option)=>selectedOption === option;
    const handleChangeThoughts = (0, $hgUW1$useCallback)((e)=>{
        e.preventDefault();
        if (onChangeThoughts) onChangeThoughts(e);
    }, [
        onChangeThoughts
    ]);
    const handleSubmitFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        onSubmitFeedback($3c691af970e2b3d8$export$8eec558e14651de4.SUBMIT);
    };
    const handleDismissFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        setSelectedOption("");
        onChangeThoughts({
            target: {
                value: ""
            }
        });
        onChangeOption("");
        onSubmitFeedback($3c691af970e2b3d8$export$8eec558e14651de4.DISMISS);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "quick-feedback-component",
        css: $3c691af970e2b3d8$var$quickFeedbackStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $3c691af970e2b3d8$var$feedbackContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $3c691af970e2b3d8$var$thumbsContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                "data-testid": "thumb-down-container",
                                css: $3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    tooltip: "Needs improvement",
                                    iconType: "thumb-down",
                                    label: "",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "thumb-down"
                                    }),
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    onClick: ()=>handleThumbClick($3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_DOWN)
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                "data-testid": "thumb-up-container",
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    tooltip: "Good",
                                    iconType: "thumb-up",
                                    label: "",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "thumb-up"
                                    }),
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    onClick: ()=>handleThumbClick($3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_UP)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: 6,
                            color: (0, $hgUW1$token)("color.text.subtle"),
                            children: isThumbClicked ? "Thank you for your feedback!" : "How was this lesson?"
                        })
                    })
                ]
            }),
            shouldShowDivider && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $3c691af970e2b3d8$var$dividerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$token)("color.border"),
                    height: 2
                })
            }),
            isPopupOpened.isOpen && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": "popup",
                css: $3c691af970e2b3d8$var$popupStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                size: "small",
                                fontWeight: "semibold",
                                children: "Why did you choose this response?"
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $3c691af970e2b3d8$var$optionsContentStyles,
                                children: isPopupOpened.thumbType === $3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_UP ? $3c691af970e2b3d8$export$3e6d4d99e8c08756.map((option)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $3c691af970e2b3d8$var$radioContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3fbcb32390ca7008$export$d7b12c4107be0d61), {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-up"
                                        })
                                    }, option)) : $3c691af970e2b3d8$export$592a942fdddb4b1a.map((option)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $3c691af970e2b3d8$var$radioContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3fbcb32390ca7008$export$d7b12c4107be0d61), {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-down"
                                        })
                                    }, option))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $3c691af970e2b3d8$var$feedbackFormStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3c691af970e2b3d8$var$inputContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        fontWeight: "semibold",
                                        children: "Share your thoughts"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1ca64a7075ab6eae$export$2c73285ae9390cec), {
                                        placeholder: "Start typing...",
                                        onChange: handleChangeThoughts
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3c691af970e2b3d8$var$buttonsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Dismiss",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).LINK,
                                        onClick: handleDismissFeedback
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Submit",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: handleSubmitFeedback
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $3c691af970e2b3d8$var$quickFeedbackStyles = (0, $hgUW1$css)({
    position: "relative",
    maxWidth: "720px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
});
const $3c691af970e2b3d8$var$feedbackContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    gap: (0, $hgUW1$token)("space.150"),
    alignItems: "center"
});
const $3c691af970e2b3d8$var$thumbsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: (0, $hgUW1$token)("space.100")
});
const $3c691af970e2b3d8$var$thumbButtonContainerStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.disabled"),
    borderRadius: "3px",
    "button:focus": {
        backgroundColor: (0, $hgUW1$token)("color.background.selected")
    }
});
const $3c691af970e2b3d8$var$dividerStyles = (0, $hgUW1$css)({
    width: "100%",
    margin: `${(0, $hgUW1$token)("space.400")} 0`
});
const $3c691af970e2b3d8$var$popupStyles = (0, $hgUW1$css)({
    position: "absolute",
    bottom: "100px",
    maxWidth: "476px",
    width: "100%",
    padding: (0, $hgUW1$token)("space.200"),
    borderRadius: "8px",
    background: (0, $hgUW1$token)("color.background.input"),
    boxShadow: `0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)`,
    [(0, $hgUW1$media).below.sm]: {
        position: "relative",
        bottom: "60px"
    }
});
const $3c691af970e2b3d8$var$optionsContentStyles = (0, $hgUW1$css)({
    margin: `${(0, $hgUW1$token)("space.100")} 0 ${(0, $hgUW1$token)("space.150")}`
});
const $3c691af970e2b3d8$var$radioContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.050")
});
const $3c691af970e2b3d8$var$feedbackFormStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $hgUW1$token)("space.150")
});
const $3c691af970e2b3d8$var$inputContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $hgUW1$token)("space.050")
});
const $3c691af970e2b3d8$var$buttonsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: (0, $hgUW1$token)("space.100")
});



$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $83fc18f8199a12ff$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $389dbaf1c04dd698$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $c18917e553fd2737$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $3ca3d702a74367ba$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $e018ab7ed2648ae8$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $81dd635d83decaee$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $8d99d7c025746ac9$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $1f7c4876f10b107b$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $c5616d3f1657fc84$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $eb6f767c51421421$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $7fe7e19d380f3d34$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $915f5687b3b07750$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $579f9ef2424e0bd8$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $d559b1cc82536c49$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $fa53e9c0a1746730$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $9225344cd5d1f99b$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $3b9afd8fe4435353$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $65703ff0bcd12648$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $dbb9d5792c296a49$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $2cfa64583f556289$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $44303f6c3c81eeac$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $9c3f769544bb2079$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $764442aba3de2fce$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $77282b3961d82199$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $4c35f7fd4ad5f13f$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $d8ee29df49af8811$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $27d686e47ff412fd$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $a4deb03146bf3bfc$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $0ae392c3008c8a3e$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $3c691af970e2b3d8$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $ed20910b93d89c3f$exports);



var $0cf4554ad00467b5$exports = {};
var $a3d28c94a229f94e$exports = {};

$parcel$export($a3d28c94a229f94e$exports, "CommunityLogo", () => $a3d28c94a229f94e$export$311e5e9ca09eea69);
$parcel$export($a3d28c94a229f94e$exports, "CommunityNavigation", () => $a3d28c94a229f94e$export$901cb8c9de2be2aa);
$parcel$export($a3d28c94a229f94e$exports, "AnalyticsActivityType", () => $1ff01338112cd7fe$export$d778a884eb401313);
$parcel$export($a3d28c94a229f94e$exports, "EventType", () => $1ff01338112cd7fe$export$3d7865934588d77e);
$parcel$export($a3d28c94a229f94e$exports, "CommunityApp", () => $1ff01338112cd7fe$export$93d048dc21eb282a);
$parcel$export($a3d28c94a229f94e$exports, "MenuItemWithAnalytics", () => $e297024529b24fb0$export$92905cc84b82619c);
$parcel$export($a3d28c94a229f94e$exports, "NavBarLinkItem", () => $e297024529b24fb0$export$b18dbc162161ec9c);
$parcel$export($a3d28c94a229f94e$exports, "APP_BUTTONS", () => $1ff01338112cd7fe$export$208c68d48dfc9a12);
$parcel$export($a3d28c94a229f94e$exports, "getAppButtons", () => $1ff01338112cd7fe$export$67e61a6fa639f224);



/**
 * This file contains the sub-components that are wrapped with the OnClickWrapper component to send analytics events
 * with the relevant payload attributes.
 */ 


/**
 * This is a wrapper component that allows passing in an onClick handler to a div. It can be used to wrap components
 * that are meant to be clicked (e.g. buttons and links), for additional click handling.
 */ 

const $d153af7a71e64fa7$export$9c92f94f6e99bc1a = ({ children: children , onClick: onClick  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
        onClick: onClick,
        children: children
    });
};














const $3e3d20b49785004a$export$29d11c0fe2fc51d8 = ({ link: link , shouldRedirect: shouldRedirect , isSelected: isSelected  })=>{
    const { text: text , href: href , onClick: onClick , target: target  } = link;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        css: [
            $3e3d20b49785004a$var$linkStyles.default,
            isSelected && $3e3d20b49785004a$var$linkStyles.selected
        ],
        href: shouldRedirect ? href : undefined,
        onClick: onClick,
        target: target || "_self",
        children: text
    });
};
const $3e3d20b49785004a$export$e76239e22e3abad = ({ isSelected: isSelected = false , link: link , expandableBodyContent: expandableBodyContent , isNested: isNested = false  })=>{
    const isBreakpoint = (0, $6e8a4d5d78071ed7$export$32d5543ab307c01)(`(max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`);
    if (isBreakpoint) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3b7e032fd37ae5a5$export$1229978ae51a03a8), {
        headerContent: /*#__PURE__*/ (0, $hgUW1$jsx)($3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested
    });
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $3e3d20b49785004a$var$buttonDivStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)($3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: true
        })
    });
};
const $3e3d20b49785004a$var$buttonDivStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 12px"
});
const $3e3d20b49785004a$var$linkStyles = {
    default: (0, $hgUW1$css)({
        color: (0, $hgUW1$token)("color.text"),
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "20px",
        "&:hover": {
            color: (0, $hgUW1$token)("color.text.selected"),
            textDecoration: "none"
        },
        "&:active": {
            color: (0, $hgUW1$token)("color.text.information")
        },
        [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
            "&:hover, &:active": {
                color: (0, $hgUW1$token)("color.text.brand"),
                textDecoration: "none"
            }
        }
    }),
    selected: (0, $hgUW1$css)({
        [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
            color: (0, $hgUW1$token)("color.text.selected")
        }
    })
};


const $d97d6cd9a58d7e95$export$bb065923b9250b7b = ({ ...rest })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3e3d20b49785004a$export$e76239e22e3abad), {
        ...rest
    });
};






const $e297024529b24fb0$export$68280dacbbcb94bd = (payload, analyticsInfo)=>{
    payload.source = "communityNavigation";
    payload.attributes = {
        ...payload.attributes || {},
        currentApp: analyticsInfo.currentApp,
        isLoggedIn: analyticsInfo.isLoggedIn,
        isNavMobileOrTablet: analyticsInfo.isMobileOrTablet
    };
    return payload;
};
const $e297024529b24fb0$export$5aa64ab1f07d6e00 = ({ analyticsInfo: analyticsInfo , subtitleHref: subtitleHref , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "logo",
                actionSubjectId: "communityNavigationHome",
                attributes: {
                    href: subtitleHref,
                    destinationApp: (0, $1ff01338112cd7fe$export$93d048dc21eb282a).HOME
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).NAV_LOGO_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $90d3cbebafca1fdb$export$6ce3be5638d8e2a), {
            subtitleHref: subtitleHref,
            ...rest
        })
    });
};
const $e297024529b24fb0$export$b18dbc162161ec9c = ({ analyticsInfo: analyticsInfo , destinationApp: destinationApp , link: link , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "communityNavigationLink",
                attributes: {
                    href: link.href,
                    label: link.text,
                    destinationApp: destinationApp
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).NAV_ITEM_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d97d6cd9a58d7e95$export$bb065923b9250b7b), {
            link: link,
            destinationApp: destinationApp,
            ...rest
        })
    });
};
const $e297024529b24fb0$var$loginSignupWrapperStyles = (isMobile)=>isMobile ? (0, $hgUW1$css)({
        padding: "0 24px"
    }) : undefined;
const $e297024529b24fb0$var$loginButtonStyles = (isMobile)=>isMobile ? (0, $hgUW1$css)({
        button: {
            width: "100%",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Charlie Text",
            color: (0, $hgUW1$token)("color.text.brand"),
            borderColor: (0, $hgUW1$token)("color.border.brand"),
            "&:active": {
                backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
                borderColor: (0, $hgUW1$token)("color.border.selected"),
                color: (0, $hgUW1$token)("color.text.inverse")
            },
            "&:hover": {
                backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.hovered"),
                borderColor: (0, $hgUW1$token)("color.border.selected"),
                color: (0, $hgUW1$token)("color.text.inverse"),
                textDecoration: "none"
            }
        }
    }) : (0, $hgUW1$css)({
        button: {
            fontWeight: 650,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            color: (0, $hgUW1$token)("color.text"),
            width: "auto",
            "&:hover": {
                backgroundColor: "transparent",
                color: (0, $hgUW1$token)("color.text.brand"),
                textDecoration: "none"
            }
        }
    });
const $e297024529b24fb0$var$signupButtonStyles = (isMobile)=>(0, $hgUW1$css)({
        button: {
            fontWeight: 550,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            width: isMobile ? "100%" : "auto"
        }
    });
const $e297024529b24fb0$export$c421b2a9819014e7 = ({ href: href , analyticsInfo: analyticsInfo , isMobile: isMobile = false  })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationLogin",
                attributes: {
                    href: href
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).LOG_IN_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $e297024529b24fb0$var$loginSignupWrapperStyles(isMobile),
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                css: $e297024529b24fb0$var$loginButtonStyles(isMobile),
                href: href,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                    appearance: "subtle",
                    children: (0, $1ff01338112cd7fe$export$46dbfbdf99745111)
                })
            })
        })
    });
};
const $e297024529b24fb0$export$5f193ccad31822c4 = ({ href: href , analyticsInfo: analyticsInfo , isMobile: isMobile = false  })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationSignup",
                attributes: {
                    href: href
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).SIGN_UP_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $e297024529b24fb0$var$loginSignupWrapperStyles(isMobile),
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                css: $e297024529b24fb0$var$signupButtonStyles(isMobile),
                href: href,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                    appearance: "primary",
                    children: (0, $1ff01338112cd7fe$export$4fe37309c24221ae)
                })
            })
        })
    });
};
const $e297024529b24fb0$export$55b351f575b2f75b = ({ analyticsInfo: analyticsInfo , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationProfileMenuOpen" : "communityNavigationProfileMenuClose"
            }, analyticsInfo), !isMenuOpen ? (0, $1ff01338112cd7fe$export$d778a884eb401313).PROFILE_MENU_OPEN : (0, $1ff01338112cd7fe$export$d778a884eb401313).PROFILE_MENU_CLOSE);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $397a78fff494027c$export$1cba3806e1f1b01d), {
        onProfileMenuClick: analyticsInfo && getSendEventFn(analyticsInfo),
        ...rest
    });
};
const $e297024529b24fb0$export$92905cc84b82619c = ({ analyticsInfo: analyticsInfo , link: link , type: type , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationMenuItem",
                attributes: {
                    href: link.href,
                    label: link.text,
                    menuItemId: link.id
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).PROFILE_MENU_ITEM_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3539883ac1727dfc$export$2ce376c2cc3355c8), {
            type: type,
            link: link,
            ...rest
        })
    });
};
const $e297024529b24fb0$export$86a131c9ca6f534a = ({ analyticsInfo: analyticsInfo , ...rest })=>{
    // event when clicking on the menu toggle button in mobile/tablet view
    const getSendEventMenuToggleFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationMobileMenuOpen" : "communityNavigationMobileMenuClose"
            }, analyticsInfo), // TODO: Fix bug with outside click handler in NavigationBar (currently, it doesn't register toggling the menu closed)
            !isMenuOpen ? (0, $1ff01338112cd7fe$export$d778a884eb401313).MOBILE_MENU_OPEN : (0, $1ff01338112cd7fe$export$d778a884eb401313).MOBILE_MENU_CLOSE);
        };
    // event when clicking outside of the menu in mobile/tablet view, which closes the menu
    const getSendEventOutsideClickFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "component",
                actionSubjectId: "communityNavigationMobileMenuClose"
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).MOBILE_MENU_CLOSE);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $25cbe9fdb2d8d071$export$214ae410b202e65a), {
        onMenuToggleClick: analyticsInfo && getSendEventMenuToggleFn(analyticsInfo),
        onMenuOutsideClick: analyticsInfo && getSendEventOutsideClickFn(analyticsInfo),
        ...rest
    });
};





const $a3d28c94a229f94e$export$311e5e9ca09eea69 = ({ subtitleHref: subtitleHref , analyticsInfo: analyticsInfo  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$5aa64ab1f07d6e00), {
        subtitleHref: subtitleHref,
        label: "Community homepage",
        logoSubtitle: "Community",
        analyticsInfo: analyticsInfo
    });
};
const $a3d28c94a229f94e$var$renderAppButtons = (currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email)=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    return (0, $1ff01338112cd7fe$export$67e61a6fa639f224)(email).map((button)=>{
        if (button.app === (0, $1ff01338112cd7fe$export$93d048dc21eb282a).FORUMS && isLoggedIn && forumsLoggedInRedirectHref) button.href[loginState] += forumsLoggedInRedirectHref;
        return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$b18dbc162161ec9c), {
            isSelected: button.app === currentApp,
            link: {
                text: button.label,
                href: button.href[loginState],
                target: button.target
            },
            expandableBodyContent: subMenuContentByApp?.[button.app],
            destinationApp: button.app,
            analyticsInfo: analyticsInfo
        }, button.app);
    });
};
const $a3d28c94a229f94e$var$getUserDisplayMenuContent = (logoutHref, type, profileHref, settingsHref, analyticsInfo)=>{
    const subMenuItems = [
        {
            ...(0, $1ff01338112cd7fe$export$668d072b293d5f38).PROFILE,
            href: profileHref
        },
        {
            ...(0, $1ff01338112cd7fe$export$668d072b293d5f38).SETTINGS,
            href: settingsHref
        },
        {
            ...(0, $1ff01338112cd7fe$export$668d072b293d5f38).LOG_OUT,
            href: logoutHref
        }
    ];
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Fragment), {
        children: subMenuItems.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$92905cc84b82619c), {
                link: item,
                type: type,
                analyticsInfo: analyticsInfo
            }, `${item.text}-${index}`))
    });
};
const $a3d28c94a229f94e$export$901cb8c9de2be2aa = ({ currentApp: currentApp , isLoggedIn: isLoggedIn , user: user , loginHref: loginHref , signupHref: signupHref , logoutHref: logoutHref , subMenuContentByApp: subMenuContentByApp , onAnalyticsSendEvent: onAnalyticsSendEvent , forumsLoggedInRedirectHref: forumsLoggedInRedirectHref , isSticky: isSticky = true , showChampions: showChampions = false , email: email  })=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    const homeHref = (0, $hgUW1$useMemo)(()=>(0, $1ff01338112cd7fe$export$d349399b473d7299)[loginState], [
        loginState
    ]);
    const profileHref = (0, $hgUW1$useMemo)(()=>(0, $1ff01338112cd7fe$export$132b2bf91782e62b)[loginState], [
        loginState
    ]);
    const settingsHref = (0, $hgUW1$useMemo)(()=>(0, $1ff01338112cd7fe$export$b9cc8022ec117e91)[loginState], [
        loginState
    ]);
    const isMobileOrTablet = (0, $6e8a4d5d78071ed7$export$32d5543ab307c01)(`(max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`);
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    let leftItems = [
        ...$a3d28c94a229f94e$var$renderAppButtons(currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email)
    ];
    if (!showChampions) leftItems = leftItems.filter((item)=>item.key !== (0, $1ff01338112cd7fe$export$93d048dc21eb282a).CHAMPIONS);
    const rightItems = [
        isLoggedIn && user ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$55b351f575b2f75b), {
            user: user,
            expandableMenuContent: $a3d28c94a229f94e$var$getUserDisplayMenuContent(logoutHref, "subMenu", profileHref, settingsHref, analyticsInfo),
            profileMenuContent: $a3d28c94a229f94e$var$getUserDisplayMenuContent(logoutHref, "profile", profileHref, settingsHref, analyticsInfo),
            analyticsInfo: analyticsInfo
        }) : isMobileOrTablet ? /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Stack), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$c421b2a9819014e7), {
                    href: loginHref,
                    analyticsInfo: analyticsInfo,
                    isMobile: isMobileOrTablet
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$5f193ccad31822c4), {
                    href: signupHref,
                    analyticsInfo: analyticsInfo,
                    isMobile: isMobileOrTablet
                })
            ]
        }) : /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Inline), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$c421b2a9819014e7), {
                    href: loginHref,
                    analyticsInfo: analyticsInfo
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$5f193ccad31822c4), {
                    href: signupHref,
                    analyticsInfo: analyticsInfo
                })
            ]
        })
    ];
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$86a131c9ca6f534a), {
        logoItem: /*#__PURE__*/ (0, $hgUW1$jsx)($a3d28c94a229f94e$export$311e5e9ca09eea69, {
            subtitleHref: homeHref,
            analyticsInfo: analyticsInfo
        }, "community-logo"),
        leftItems: leftItems,
        rightItems: rightItems,
        analyticsInfo: analyticsInfo,
        isSticky: isSticky
    });
};


$parcel$exportWildcard($0cf4554ad00467b5$exports, $a3d28c94a229f94e$exports);


$parcel$exportWildcard($a69491ea5a126553$exports, $5d4509b60606b6df$exports);
$parcel$exportWildcard($a69491ea5a126553$exports, $6e379ec2eca3d7d3$exports);
$parcel$exportWildcard($a69491ea5a126553$exports, $a6a41c835fd01d00$exports);
$parcel$exportWildcard($a69491ea5a126553$exports, $0cf4554ad00467b5$exports);



var $ca43fe01b6155439$exports = {};



$parcel$exportWildcard($ca43fe01b6155439$exports, $3ced3ef7e9864bf1$exports);
$parcel$exportWildcard($ca43fe01b6155439$exports, $965a3cfbe886b380$exports);
$parcel$exportWildcard($ca43fe01b6155439$exports, $6e8a4d5d78071ed7$exports);




export {$660bd1c6cb41002a$export$29a7a275fe11687 as Blockquote, $660bd1c6cb41002a$export$7a77f8e9665fa6b2 as blockquoteStyles, $fec02fc26c7e145d$export$5dd2748b7940a2a0 as ButtonSize, $fec02fc26c7e145d$export$261c9483fc4a455a as ButtonAppearance, $fec02fc26c7e145d$export$353f5b6fc5456de1 as Button, $d501466973a9f0a6$export$138e17770a0a93a6 as CheckboxType, $d501466973a9f0a6$export$5e435bc8b081a399 as CheckboxSize, $d501466973a9f0a6$export$48513f6b9f8ce62d as Checkbox, $c4979bfceee73878$export$8577c1390d697bac as CommonModal, $0903e93de01b205a$export$2e0a83ec2e27ecbb as Divider, $a950778dc3003c4a$export$71f050e2efa708bb as Eyebrow, $582583ec420fce57$export$a8a3e93435678ff9 as Heading, $a02a6f7de308273b$export$df03f54e09e486fa as icons, $a02a6f7de308273b$export$ff775019b5b6e7df as IconSize, $a02a6f7de308273b$export$b3241a99d3e47e02 as IconRotation, $a02a6f7de308273b$export$f04a61298a47a40f as Icon, $1298c86a7e6a9fc7$export$3e431a229df88919 as Image, $4fce8dfc4ce8f546$export$2b77966d73aefa77 as LinkStyle, $4fce8dfc4ce8f546$export$be4c932f76c19adf as LinkSize, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a as Link, $800df40a54823a3f$export$54c2e3dc7acea9f5 as List, $800df40a54823a3f$export$6427468642e6e9fe as variantsListStyles, $25cbe9fdb2d8d071$export$214ae410b202e65a as NavigationBar, $397a78fff494027c$export$1cba3806e1f1b01d as NavBarProfileItem, $90d3cbebafca1fdb$export$6ce3be5638d8e2a as AtlassianNavLogo, $3539883ac1727dfc$export$2ce376c2cc3355c8 as MenuItem, $3b7e032fd37ae5a5$export$1229978ae51a03a8 as NavBarExpandableItem, $3fbcb32390ca7008$export$f5eff9f4cffe1e46 as RadioType, $3fbcb32390ca7008$export$4da24539a3bb7d98 as RadioSize, $3fbcb32390ca7008$export$d7b12c4107be0d61 as Radio, $731a4fd527bab680$export$ddadc1228c8dcfa as TabsSize, $731a4fd527bab680$export$3e41faf802a29e71 as Tab, $5cf70e33bfc6ce73$export$3288d34c523a1192 as Tag, $5cf70e33bfc6ce73$export$f40d73b6f7f951e9 as tagListStyles, $8b54d37779d052e8$export$5f1af8db9871e1d6 as Text, $9cfa05d02afa3952$export$8f89d78db9c8c41f as AccordionSize, $9cfa05d02afa3952$export$a766cd26d0d69044 as Accordion, $7d458ed59bb9c6a8$export$7f1bf47c7f50a6aa as InlineCode, $a467abe0c2c1750b$export$a31cbe1bf5463979 as Lozenge, $52124b9ae1d78e04$export$710836885d72543c as SectionMessageAppearance, $52124b9ae1d78e04$export$a36903bd214cec06 as SectionMessage, $6e2eae4c8556b5b9$export$2393c31da95977ae as DropdownMenuCheckbox, $4366d2b05f9f8f6b$export$e52b3c28ffecde23 as GreetingCard, $be203e745bcefb12$export$edf27be85e5f6da0 as Error, $a0eced43682c2d75$export$bd0c6e28f5d6b66e as LicenseModal, $83fc18f8199a12ff$export$832cc5475f11d8b4 as AudioPlayer, $389dbaf1c04dd698$export$22da447a4012011 as BadgeCard, $c18917e553fd2737$export$c572aa3e2aa38d2 as CertificateCard, $3ca3d702a74367ba$export$84c408eab3fc01b3 as ContentOverviewCardState, $3ca3d702a74367ba$export$cb86f63bb5e77777 as ContentOverviewCard, $e018ab7ed2648ae8$export$fddf379e22a74b00 as EmptyState, $81dd635d83decaee$export$f9292ef28b7b429a as InlineFeedbackMessageAppearance, $81dd635d83decaee$export$f23c56ac9ab316f as InlineFeedbackMessage, $8d99d7c025746ac9$export$c01be50dd5c433fe as LearningContentCard, $1f7c4876f10b107b$export$2b77a92f1a5ad772 as Modal, $c5616d3f1657fc84$export$415b2bdf1346d2d4 as LessonsTabContentSize, $c5616d3f1657fc84$export$ce96f190f5d3ee14 as LessonsTabContent, $eb6f767c51421421$export$e7adebdc1ebd2fed as Metadata, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9 as ArrowPosition, $7fe7e19d380f3d34$export$129a32eedafa97c5 as Popup, $915f5687b3b07750$export$c17561cb55d4db30 as ProgressBar, $579f9ef2424e0bd8$export$fad76899145ca0c7 as ProgressStatus, $579f9ef2424e0bd8$export$aa03ab7e1a208875 as defineProgressStatus, $579f9ef2424e0bd8$export$86f07cccb119409d as LearningHeader, $d559b1cc82536c49$export$a06f1c675e846f6f as Footer, $fa53e9c0a1746730$export$12b5e3eab33f219b as LabelledGraphic, $9225344cd5d1f99b$export$7bee7638d150bc04 as LessonHeader, $3b9afd8fe4435353$export$962a95c44e73eb25 as LessonList, $65703ff0bcd12648$export$c2bf8d11366d1eb0 as LessonSidebar, $dbb9d5792c296a49$export$f6dc54b55657f29f as SubmitFeedback, $2cfa64583f556289$export$477c64ffaba52edf as PopupShare, $44303f6c3c81eeac$export$51940fbbacba35d4 as QuestionType, $44303f6c3c81eeac$export$bf1c1ed72daa392b as QuizStatus, $44303f6c3c81eeac$export$602daccbd963b20 as QuestionStatus, $44303f6c3c81eeac$export$85e3e62cc743c830 as MatchingAnswerStatus, $44303f6c3c81eeac$export$cb9c858407602327 as ActionDescription, $44303f6c3c81eeac$export$76709845c4fea6cd as Quiz, $9c3f769544bb2079$export$1ba59dacbcbf90fe as Sidebar, $764442aba3de2fce$export$ae01dedf5c052bb as Video, $77282b3961d82199$export$f02cc02ad0e0bba3 as Columns, $77282b3961d82199$export$2dde675552f76fc5 as LessonColumns, $4c35f7fd4ad5f13f$export$5ae3342de8088f07 as LearningCourseCard, $d8ee29df49af8811$export$184a993f673fc83f as LearningProgressBar, $27d686e47ff412fd$export$41cd510048068b0c as FeedbackHeader, $a4deb03146bf3bfc$export$448811829c5d1992 as ReportIssueModal, $0ae392c3008c8a3e$export$f2adaabc3a0295ef as FlatContentCardStyle, $0ae392c3008c8a3e$export$8023ea0baf29b8db as FlatContentCardType, $0ae392c3008c8a3e$export$bc8a9d98c2eabbb7 as FlatContentCard, $3c691af970e2b3d8$export$e1c6e381de15460b as ThumbType, $3c691af970e2b3d8$export$8eec558e14651de4 as FeedbackButtonType, $3c691af970e2b3d8$export$3e6d4d99e8c08756 as THUMBS_UP_FEEDBACK_OPTIONS, $3c691af970e2b3d8$export$592a942fdddb4b1a as THUMBS_DOWN_FEEDBACK_OPTIONS, $3c691af970e2b3d8$export$c6f2bf448101d429 as QuickFeedback, $ed20910b93d89c3f$export$e2e108cbe2e4f865 as ContentType, $1ca64a7075ab6eae$export$2c73285ae9390cec as TextField, $60ab015507144a2b$export$9144c5f9beecc4b7 as TextFieldMessage, $57b1d5df6b5425d4$export$76375b2580d1f8ac as TextFieldLabel, $4be7278e65b71184$export$c031b829a2452999 as UnifiedAccountCardContent, $db9d361cdef36cb6$export$c9d2f1697787ae74 as UnifiedAccountContainerCard, $e6da040d2ca2c72a$export$fc13faf098015d3a as UnifiedAccountLinkAccountCard, $9c7edcd33b2e220b$export$b27c6704e245f018 as UnifiedAccountTagContainer, $3ec1f71319ba0295$export$8bee5cfdbbc2fc0c as UnifiedAccountTagLoggedIn, $7cbc56ac0bc2e1de$export$be7f7dedc3a0e1ad as UnifiedAccountTagPrimary, $01ef21c48d795edb$export$446c53c437a3d14a as UnifiedAccountTagLinked, $80cd39a44f20f361$export$7a92b4adf6bd95bb as SharedFooter, $fff41b96fcd62262$export$9d12d42929c3fcf as WelcomeModal, $a3d28c94a229f94e$export$311e5e9ca09eea69 as CommunityLogo, $a3d28c94a229f94e$export$901cb8c9de2be2aa as CommunityNavigation, $1ff01338112cd7fe$export$d778a884eb401313 as AnalyticsActivityType, $1ff01338112cd7fe$export$3d7865934588d77e as EventType, $1ff01338112cd7fe$export$93d048dc21eb282a as CommunityApp, $e297024529b24fb0$export$92905cc84b82619c as MenuItemWithAnalytics, $e297024529b24fb0$export$b18dbc162161ec9c as NavBarLinkItemWithAnalytics, $1ff01338112cd7fe$export$208c68d48dfc9a12 as APP_BUTTONS, $1ff01338112cd7fe$export$67e61a6fa639f224 as getAppButtons, $fde9406d76ec24a9$export$8a8918d045227e35 as objectValuesToControls, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f as withFocusInteraction, $fde9406d76ec24a9$export$1784ac302bd8ebad as inspectorProps, $fde9406d76ec24a9$export$30c35cbf580cab77 as formatMinutes, $fde9406d76ec24a9$export$93832c3affb240d3 as getRedirectUrl, $fde9406d76ec24a9$export$6e67b290ed5690f6 as calculateLearningProgress, $3ced3ef7e9864bf1$export$4616d33c54ae5baf as useDeviceSize, $965a3cfbe886b380$export$aa79b0abe3dfeaba as useOutsideClickHandler, $6e8a4d5d78071ed7$export$32d5543ab307c01 as useMediaQuery};
//# sourceMappingURL=index.es.js.map
